(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired589"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired589"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


var $iUSsr = parcelRequire("iUSsr");
const $f67e0c7059ce8336$var$moneyFormats = {
    USD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
        money_format: "&euro;{{amount_with_comma_separator}}",
        money_with_currency_format: "&euro;{{amount_with_comma_separator}} EUR"
    },
    GBP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
        money_format: "Lek {{amount}}",
        money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
        money_format: "DA {{amount}}",
        money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
        money_format: "Kz{{amount}}",
        money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
        money_format: "{{amount}} AMD",
        money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
        money_format: "Afl{{amount}}",
        money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
        money_format: "m.{{amount}}",
        money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
        money_format: "Tk {{amount}}",
        money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
        money_format: "BS${{amount}}",
        money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
        money_format: "{{amount}}0 BD",
        money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
        money_format: "Br {{amount}}",
        money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
        money_format: "BZ${{amount}}",
        money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
        money_format: "Nu {{amount}}",
        money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
        money_format: "KM {{amount_with_comma_separator}}",
        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
        money_format: "R$ {{amount_with_comma_separator}}",
        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
        money_format: "Bs{{amount_with_comma_separator}}",
        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
        money_format: "P{{amount}}",
        money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
        money_format: "{{amount}} \u043B\u0432",
        money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
        money_format: "K{{amount}}",
        money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
        money_format: "KHR{{amount}}",
        money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
        money_format: "FCFA{{amount}}",
        money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
        money_format: "${{amount_no_decimals}}",
        money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
        money_format: "&#165;{{amount}}",
        money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
        money_format: "&#8353; {{amount_with_comma_separator}}",
        money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
        money_format: "{{amount_with_comma_separator}} kn",
        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
        money_format: "{{amount_with_comma_separator}} K&#269;",
        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
        money_format: "RD$ {{amount}}",
        money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
        money_format: "${{amount}}",
        money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
        money_format: "LE {{amount}}",
        money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
        money_format: "Br{{amount}}",
        money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
        money_format: "${{amount}}",
        money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
        money_format: "D {{amount}}",
        money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
        money_format: "GH&#8373;{{amount}}",
        money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
        money_format: "Q{{amount}}",
        money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
        money_format: "G${{amount}}",
        money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
        money_format: "{{amount}} GEL",
        money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
        money_format: "L {{amount}}",
        money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
        money_format: "${{amount}}",
        money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
        money_format: "{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
        money_format: "Rs. {{amount}}",
        money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
        money_format: "{{amount_with_comma_separator}}",
        money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
        money_format: "{{amount}} NIS",
        money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
        money_format: "&#165;{{amount_no_decimals}}",
        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
        money_format: "&pound;{{amount}}",
        money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
        money_format: "{{amount}}0 JD",
        money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
        money_format: "{{amount}} KZT",
        money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
        money_format: "KSh{{amount}}",
        money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
        money_format: "{{amount}}0 KD",
        money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
        money_format: "\u043B\u0432{{amount}}",
        money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
        money_format: "Ls {{amount}}",
        money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
        money_format: "L&pound;{{amount}}",
        money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
        money_format: "{{amount}} Lt",
        money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
        money_format: "Ar {{amount}}",
        money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
        money_format: "\u0434\u0435\u043D {{amount}}",
        money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
        money_format: "MOP${{amount}}",
        money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
        money_format: "Rf{{amount}}",
        money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
        money_format: "$ {{amount}}",
        money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
        money_format: "RM{{amount}} MYR",
        money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
        money_format: "{{amount}} MDL",
        money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
        money_format: "{{amount}} dh",
        money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
        money_format: "{{amount_no_decimals}} &#8366",
        money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
        money_format: "{{amount}} Mt",
        money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
        money_format: "N${{amount}}",
        money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
        money_format: "Rs{{amount}}",
        money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
        money_format: "&fnof;{{amount}}",
        money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
        money_format: "C${{amount}}",
        money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
        money_format: "&#8358;{{amount}}",
        money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
        money_format: "kr {{amount_with_comma_separator}}",
        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
        money_format: "{{amount_with_comma_separator}} OMR",
        money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
        money_format: "Rs.{{amount}}",
        money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
        money_format: "K {{amount}}",
        money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
        money_format: "S/. {{amount}}",
        money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
        money_format: "&#8369;{{amount}}",
        money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
        money_format: "{{amount_with_comma_separator}} zl",
        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
        money_format: "QAR {{amount_with_comma_separator}}",
        money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
        money_format: "{{amount_with_comma_separator}} lei",
        money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
        money_format: "{{amount_no_decimals}} RF",
        money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
        money_format: "WS$ {{amount}}",
        money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
        money_format: "{{amount}} SR",
        money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
        money_format: "Db {{amount}}",
        money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
        money_format: "{{amount}} RSD",
        money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
        money_format: "S&pound;{{amount}}",
        money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
        money_format: "R {{amount}}",
        money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
        money_format: "&#8361;{{amount_no_decimals}}",
        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
        money_format: "Rs {{amount}}",
        money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
        money_format: "{{amount_no_decimals}} kr",
        money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
        money_format: "SFr. {{amount}}",
        money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
        money_format: "{{amount}} &#xe3f;",
        money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
        money_format: "{{amount}} TZS",
        money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
        money_format: "{{amount}}",
        money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
        money_format: "{{amount}}TL",
        money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
        money_format: "Ush {{amount_no_decimals}}",
        money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
        money_format: "\u20B4{{amount}}",
        money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
        money_format: "Dhs. {{amount}}",
        money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
        money_format: "${{amount_with_comma_separator}}",
        money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
        money_format: "${{amount}}",
        money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
        money_format: "Bs. {{amount_with_comma_separator}}",
        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
        money_format: "{{amount_no_decimals}} BTC",
        money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
        money_format: "CFA{{amount}}",
        money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
        money_format: "K{{amount_no_decimals_with_comma_separator}}",
        money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
};
const $f67e0c7059ce8336$export$3a90bcda830d8985 = [
    "de",
    "fr"
];
const $f67e0c7059ce8336$var$localizePrice = (price)=>{
    const locale = window.Shopify && window.Shopify.locale;
    if (!locale || !$f67e0c7059ce8336$export$3a90bcda830d8985.includes(locale.toLowerCase())) return price;
    const match = price.match(/^([^\d\s]+)\s?([\d.,]+)$/);
    if (match) {
        const [, symbol, amount] = match;
        return `${amount}${symbol}`;
    }
    const reverseMatch = price.match(/^([\d.,]+)\s?([^\d\s]+)$/);
    if (reverseMatch) {
        const [, amount, symbol] = reverseMatch;
        return `${amount}${symbol}`;
    }
    // Format we don't recognise (e.g. "1.234,56 EUR") — leave it untouched
    // rather than returning undefined and blanking the price.
    return price;
};
// Money formats are authored with HTML entities (`&euro;`). Plenty of callers
// push the result through jQuery `.text()`, which would print the entity
// literally, so decode before returning.
const $f67e0c7059ce8336$var$decodeEntities = (str)=>{
    if (str.indexOf("&") === -1) return str;
    const el = document.createElement("textarea");
    el.innerHTML = str;
    return el.value;
};
/**
 * Resolve the money format for the active market.
 *
 * Priority: explicit argument > the active cart currency > the shop-level
 * format exposed on `window.theme`. `shop.money_format` is shop-wide, so the
 * currency lookup has to win for markets that don't use the shop currency.
 *
 * @param {String} [fmt]
 * @returns {String}
 */ const $f67e0c7059ce8336$var$resolveFormat = (fmt)=>{
    if (fmt) return fmt;
    const theme = window.theme || {};
    const currency = theme.currency;
    if (currency && $f67e0c7059ce8336$var$moneyFormats[currency] && $f67e0c7059ce8336$var$moneyFormats[currency].money_format) return $f67e0c7059ce8336$var$moneyFormats[currency].money_format;
    return theme.moneyFormat || "\u20AC{{amount}}";
};
/**
 * Format a number to a specific format
 *
 * @param {Number} number - Value to format
 * @param {Number} precision - Amount of decimal points to show
 * @param {String} thousands - Thousands delimiter
 * @param {String} decimal - Decimal delimiter
 * @returns {String|Number}
 */ function $f67e0c7059ce8336$var$formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || !number) return 0;
    const preciseNumber = (number / 100.0).toFixed(precision);
    const parts = preciseNumber.split(thousands);
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
}
function $f67e0c7059ce8336$export$a17b3c2052469c69(cents, fmt) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    let format = $f67e0c7059ce8336$var$resolveFormat(fmt);
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const placeholder = format.match(placeholderRegex);
    if (!placeholder) return $f67e0c7059ce8336$var$decodeEntities(format);
    switch(placeholder[1]){
        case "amount":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 2, ",", ".");
            break;
        case "amount_with_space_separator":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 0, ",", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 0, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = $f67e0c7059ce8336$var$formatWithDelimiters(cents, 0, ".", ",");
            break;
    }
    return $f67e0c7059ce8336$var$localizePrice($f67e0c7059ce8336$var$decodeEntities(format.replace(placeholderRegex, value)));
}
/**
 * Return the value of money in cents value
 *
 * @param {Number} moneyAmount - Money value of a price
 *                 eg: 1000
 * @param {String} format - Shop formatting of a price
 *                 eg: {{amount}}
 * @param {String} currency - Currency of a price
 *                 eg: 'CAD'
 * @returns {Number}
 * @private
 */ function $f67e0c7059ce8336$var$getCentsValue(moneyAmount, format, currency) {
    let cents = 0;
    // Convert prices from float values to integers if needed, then convert
    if (format.indexOf("amount_no_decimals") !== -1) cents = moneyAmount * 100;
    else if (currency === "JOD" || currency === "KWD" || currency === "BHD") cents = moneyAmount / 10;
    else cents = moneyAmount;
    return cents;
}
/**
 * Converts formatted money to a number
 *
 * @param {Element} priceEl
 * @returns {Number|String}
 */ function $f67e0c7059ce8336$var$getMoneyValue(priceEl) {
    const price = priceEl.getAttribute("data-currency-original") || priceEl.textContent;
    const value = parseInt(price.replace(/[^0-9]/g, ""), 10);
    return !isNaN(value) ? value : "";
}



var $iUSsr = parcelRequire("iUSsr");
window.debounce = function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            func.apply(context, args);
        }, wait);
    };
};
const $4d3add7eda271e10$var$stickyHeader = function() {
    const $header = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-site-header]');
    let topBarHeight, headerHeight;
    const update = ()=>{
        topBarHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-top-bar]').outerHeight();
        headerHeight = $header.hasClass('m-transparent') && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989 ? topBarHeight : $header.outerHeight();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').css('paddingTop', headerHeight + 'px');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").hasClass('header-with-sticky-bar')) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 980) {
                headerHeight += 46;
                topBarHeight += 46;
            }
        }
    };
    update();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).resize(update);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        const scroll = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).scrollTop();
        if (scroll > headerHeight / 3) $header.css('transform', `translate(0, -${topBarHeight}px)`).addClass('is-scrolled');
        else $header.css('transform', `translate(0, 0)`).removeClass('is-scrolled');
        var $btnATC = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-main form#addToCartForm button[data-add-to-cart]");
        if ($btnATC.length > 0) {
            if (scroll > $btnATC.offset().top) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.sticky-bottom').addClass('visible');
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.sticky-bottom').removeClass('visible');
        }
    });
};
const $4d3add7eda271e10$var$mobileHeader = function() {
    const $btn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-open-menu]');
    $btn.click(function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('html, body').toggleClass('is-menu-open');
    });
};
const $4d3add7eda271e10$var$header = ()=>{
    $4d3add7eda271e10$var$stickyHeader();
    $4d3add7eda271e10$var$mobileHeader();
};
var $4d3add7eda271e10$export$2e2bcd8739ae039 = $4d3add7eda271e10$var$header;



var $iUSsr = parcelRequire("iUSsr");
var $ce3b64eb948e58bc$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ /* global window, document, define, jQuery, setInterval, clearInterval */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $ce3b64eb948e58bc$exports = factory((parcelRequire("iUSsr")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && typeof asNavFor === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                'tabindex': '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    'role': 'presentation'
                });
                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            'tabindex': '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});


const $0d840adb65d390a7$export$43bee144004852f1 = ($slider, initCallBack, responsive)=>{
    if ($slider === undefined) {
        console.error("Can't mount undefined slider");
        return false;
    }
    if ($slider.data('desktop-only') == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() <= 989) return false;
    if ($slider.data('mobile-only') == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989) return false;
    if ($slider.data('small-divice-only') == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 767) return false;
    if (typeof initCallBack === 'function') $slider.on('init', initCallBack);
    const $controls = $slider.parent().find('.slider-controls');
    const options = {
        slidesToShow: $slider.data('slides-to-show') || 1,
        slidesToScroll: $slider.data('slides-to-scroll') || 1,
        draggable: $slider.data('draggable') == false ? false : true,
        infinite: $slider.data('infinite') == false ? false : true,
        adaptiveHeight: $slider.data('adaptive-height') == true ? true : false,
        arrows: $slider.data('arrows') == false ? false : true,
        dots: $slider.data('dots') == false ? false : true,
        autoplay: $slider.data('autoplay') == true ? true : false,
        centerMode: $slider.data('centermode') == true ? true : false,
        variableWidth: $slider.data('variable-width') == true ? true : false,
        accessibility: true
    };
    const optionsMobile = {
        slidesToShow: $slider.data('slides-to-show-mob') || options.slidesToShow,
        slidesToScroll: $slider.data('slides-to-scroll-mob') || options.slidesToScroll,
        draggable: $slider.data('draggable-mob') == false ? false : true,
        infinite: $slider.data('infinite-mob') == false ? false : true,
        adaptiveHeight: $slider.data('adaptive-height-mob') == true ? true : false,
        arrows: $slider.data('arrows-mob') == false ? false : true,
        dots: $slider.data('dots-mob') == false ? false : true,
        autoplay: $slider.data('autoplay-mob') == true ? true : false,
        centerMode: $slider.data('centermode-mob') == true ? true : false,
        variableWidth: $slider.data('variable-width-mob') == true ? true : false,
        accessibility: true
    };
    if ($slider.data('custom-controls') == "1") {
        options['appendDots'] = $controls.find('[data-hor-slider-dots]');
        options['prevArrow'] = $controls.find('[data-hor-slider-prev]');
        options['nextArrow'] = $controls.find('[data-hor-slider-next]');
    }
    if ($slider.data('custom-dots') == "1") options['appendDots'] = $controls.find('[data-hor-slider-dots]');
    if ($slider.data('dots-titles') == "1") options['customPaging'] = function(slider, i) {
        var title = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(slider.$slides[i]).find('[data-title]').data('title');
        return '<hr><button><span>' + title + '</span></button>';
    };
    if ($slider.data('disable-swipe') == "1") {
        options['swipe'] = false;
        options['swipeToSlide'] = false;
        options['touchMove'] = false;
        options['accessibility'] = false;
    }
    if ($controls.length) $slider.on('init', ()=>$controls.addClass('m-mounted'));
    if (typeof responsive == 'object') options['responsive'] = responsive;
    if ($slider.data('slides-to-show-ipad')) {
        const ipadBreakpoint = $slider.data('breakpoint-ipad') || 989;
        const mobBreakpoint = $slider.data('breakpoint-mob') || 767;
        options['responsive'] = [
            {
                breakpoint: ipadBreakpoint,
                settings: {
                    slidesToShow: $slider.data('slides-to-show-ipad')
                }
            },
            {
                breakpoint: mobBreakpoint,
                settings: optionsMobile
            }
        ];
    } else {
        const mobBreakpoint = $slider.data('breakpoint-mob') || 989;
        if ($slider.data('slides-to-show-mob')) options['responsive'] = [
            {
                breakpoint: mobBreakpoint,
                settings: optionsMobile
            }
        ];
    }
    if ($slider.data('as-nav-for')) {
        const id = $slider.data('as-nav-for');
        options['asNavFor'] = `[data-slider=${id}]`;
        options['focusOnSelect'] = true;
    }
    $slider.not('.slick-initialized').slick(options);
    $slider.on('afterChange', function(event, slick, currentSlide) {
        $0d840adb65d390a7$var$toggleSlideTabIndex(slick);
    });
    $0d840adb65d390a7$var$toggleSlideTabIndex($slider);
};
function $0d840adb65d390a7$var$toggleSlideTabIndex(slider) {
    if (!slider) return;
    let slick;
    if (typeof slider.slick === 'function') slick = slider.slick('getSlick');
    else slick = slider;
    if (!slick || !slick.$slides || typeof slick.$slides.length === 'undefined') return;
    if (slick.$slides.length > 1) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(slick.$slides).each((index, item)=>{
        const selectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).attr('aria-hidden') === 'true') {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).find(selectors).attr('tabindex', '-1');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).attr('tabindex', '-1');
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).find(selectors).attr('tabindex', '0');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).attr('tabindex', '0');
        }
    });
}
const $0d840adb65d390a7$var$initializeTestimonialSlider = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#section-review .section-review_slider").slick({
        arrows: false,
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 668,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
};
const $0d840adb65d390a7$var$initializeWhatsNewSlider = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#section-whats-new .section-whatsnew_slider").slick({
        arrows: false,
        dots: false,
        slidesToShow: 3,
        infinite: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 668,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
};
const $0d840adb65d390a7$var$initializeFaqSlider = function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() <= 1200) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-faq-slider]").not('.slick-initialized').slick({
        arrows: false,
        dots: true,
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
};
function $0d840adb65d390a7$export$2e2bcd8739ae039() {
    const $sliders = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-hor-slider]');
    $sliders.each(function(index, slider) {
        const $slider = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(slider);
        $0d840adb65d390a7$export$43bee144004852f1($slider);
    });
    $0d840adb65d390a7$var$initializeTestimonialSlider();
    $0d840adb65d390a7$var$initializeWhatsNewSlider();
    $0d840adb65d390a7$var$initializeFaqSlider();
}



var $iUSsr = parcelRequire("iUSsr");
const $e362e5530e455afb$var$smoothScroll = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('a[href*="#"]')// Remove links that don't actually link to anything
    .not('[href="#"]').not('[href="#0"]').not('[data-anchor-link]').click(function(event) {
        // On-page links
        $e362e5530e455afb$var$scrollToHash(event, this);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-scroll-next]').click(function(e) {
        const target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.shopify-section').eq(2);
        if (target.length) {
            e.preventDefault();
            $e362e5530e455afb$export$209876d7b1ac8f3(target);
        }
    });
};
const $e362e5530e455afb$var$scrollToHash = function(event, _this) {
    console.log("SMOOTH");
    if (location.pathname.replace(/^\//, '') == _this.pathname.replace(/^\//, '') && location.hostname == _this.hostname) {
        // Figure out element to scroll to
        var target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(_this.hash);
        target = target.length ? target : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[name=' + _this.hash.slice(1) + ']');
        console.log(target[0].id);
        // Does a scroll target exist?
        if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $e362e5530e455afb$export$209876d7b1ac8f3(target);
        }
    }
};
function $e362e5530e455afb$export$209876d7b1ac8f3(target) {
    var ofsetValue = target.offset().top;
    var adjustmentValue = 0;
    var delay = 1000;
    if (target[0].id == 'compare_products') {
        adjustmentValue = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#see_compare').outerHeight(true) + target.outerHeight();
        console.log(adjustmentValue);
        ofsetValue -= adjustmentValue;
        delay = 0;
    //ofsetValue = $("._popup").eq(0).offset().top - (2 * $("._popup").eq(0).outerHeight()) - target.outerHeight(true) - $('#see_compare').outerHeight(true);
    }
    const position = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#see_compare').offset().top + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#see_compare').outerHeight(true) + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("._popup").eq(0).outerHeight() - 20 - (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).innerHeight();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('html, body').animate({
        scrollTop: position
    }, 0, function() {
        console.log("test value");
    // Callback after animation
    });
}
var $e362e5530e455afb$export$2e2bcd8739ae039 = $e362e5530e455afb$var$smoothScroll;



var $iUSsr = parcelRequire("iUSsr");
var $25f849c497f8b209$exports = {};

var $iUSsr = parcelRequire("iUSsr");
// Cart.js
// version: 0.4.1
// author: Gavin Ballard
// license: MIT
(function() {
    var a, b, c, d, e, f, g = function(a, b) {
        return function() {
            return a.apply(b, arguments);
        };
    };
    b = function() {
        function a() {
            this.update = g(this.update, this);
        }
        return a.prototype.update = function(a) {
            var b, c, e;
            for(c in a)e = a[c], "items" !== c && (this[c] = e);
            return this.items = function() {
                var c, e, f, g;
                for(f = a.items, g = [], c = 0, e = f.length; e > c; c++)b = f[c], g.push(new d(b));
                return g;
            }();
        }, a;
    }(), d = function() {
        function a(a) {
            this.propertyArray = g(this.propertyArray, this), this.update = g(this.update, this), this.update(a);
        }
        return a.prototype.update = function(a) {
            var b, d;
            for(b in a)d = a[b], "properties" !== b && (this[b] = d);
            return this.properties = c.Utils.extend({}, a.properties);
        }, a.prototype.propertyArray = function() {
            var a, b, c, d;
            c = this.properties, d = [];
            for(a in c)b = c[a], d.push({
                name: a,
                value: b
            });
            return d;
        }, a;
    }(), c = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new b
    }, c.init = function(a, b) {
        return null == b && (b = {}), c.configure(b), c.Utils.log("Initialising CartJS."), c.cart.update(a), c.settings.dataAPI && (c.Utils.log('"dataAPI" setting is true, initialising Data API.'), c.Data.init()), c.settings.requestBodyClass && (c.Utils.log('"requestBodyClass" set, adding event listeners.'), (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("cart.requestStarted", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").addClass(c.settings.requestBodyClass);
        }), (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("cart.requestComplete", function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").removeClass(c.settings.requestBodyClass);
        })), c.Rivets.init(), (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).trigger("cart.ready", [
            c.cart
        ]);
    }, c.configure = function(a) {
        return null == a && (a = {}), c.Utils.extend(c.settings, a);
    }, null == window.console && (window.console = {}, window.console.log = function() {}), c.Utils = {
        log: function() {
            return c.Utils.console(console.log, arguments);
        },
        error: function() {
            return c.Utils.console(console.error, arguments);
        },
        console: function(a, b) {
            return c.settings.debug && "undefined" != typeof console && null !== console ? (b = Array.prototype.slice.call(b), b.unshift("[CartJS]:"), a.apply(console, b)) : void 0;
        },
        wrapKeys: function(a, b, c) {
            var d, e, f;
            null == b && (b = "properties"), f = {};
            for(d in a)e = a[d], f["" + b + "[" + d + "]"] = null != c ? c : e;
            return f;
        },
        unwrapKeys: function(a, b, c) {
            var d, e, f, g;
            null == b && (b = "properties"), e = {};
            for(d in a)g = a[d], f = d.replace("" + b + "[", "").replace("]", ""), e[f] = null != c ? c : g;
            return e;
        },
        extend: function(a, b) {
            var c, d;
            for(c in b)d = b[c], a[c] = d;
            return a;
        },
        clone: function(a) {
            var b, c;
            if (null == a || "object" != typeof a) return a;
            c = new a.constructor;
            for(b in a)c[b] = clone(a[b]);
            return c;
        },
        isArray: Array.isArray || function(a) {
            return "[object Array]" === ({}).toString.call(a);
        },
        ensureArray: function(a) {
            return c.Utils.isArray(a) ? a : null != a ? [
                a
            ] : [];
        },
        formatMoney: function(a, b, d, e) {
            var f, g;
            return null == e && (e = ""), e || (e = c.settings.currency), null != window.Currency && e !== c.settings.currency && (a = Currency.convert(a, c.settings.currency, e), null != (null != (f = window.Currency) ? f.moneyFormats : void 0) && e in window.Currency.moneyFormats && (b = window.Currency.moneyFormats[e][d])), null != (null != (g = window.Shopify) ? g.formatMoney : void 0) ? Shopify.formatMoney(a, b) : a;
        },
        getSizedImageUrl: function(a, b) {
            var c, d;
            return null != (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0) ? a ? Shopify.Image.getSizedImageUrl(a, b) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", b).replace("-_", "-") : a ? a : "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        }
    }, f = [], e = !1, c.Queue = {
        add: function(a, b, d) {
            var g;
            return null == d && (d = {}), g = {
                url: a,
                data: b,
                type: d.type || "POST",
                dataType: d.dataType || "json",
                success: c.Utils.ensureArray(d.success),
                error: c.Utils.ensureArray(d.error),
                complete: c.Utils.ensureArray(d.complete)
            }, d.updateCart && g.success.push(c.cart.update), f.push(g), e ? void 0 : ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).trigger("cart.requestStarted", [
                c.cart
            ]), c.Queue.process());
        },
        process: function() {
            var a;
            return f.length ? (e = !0, a = f.shift(), a.complete = c.Queue.process, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax(a)) : (e = !1, void (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).trigger("cart.requestComplete", [
                c.cart
            ]));
        }
    }, c.Core = {
        getCart: function(a) {
            return null == a && (a = {}), a.type = "GET", a.updateCart = !0, c.Queue.add("/cart.js", {}, a);
        },
        addItem: function(a, b, d, e) {
            var f;
            return null == b && (b = 1), null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.id = a, f.quantity = b, c.Queue.add("/cart/add.js", f, e), c.Core.getCart();
        },
        updateItem: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.line = a, null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        removeItem: function(a, b) {
            return null == b && (b = {}), c.Core.updateItem(a, 0, {}, b);
        },
        updateItemById: function(a, b, d, e) {
            var f;
            return null == d && (d = {}), null == e && (e = {}), f = c.Utils.wrapKeys(d), f.id = a, null != b && (f.quantity = b), e.updateCart = !0, c.Queue.add("/cart/change.js", f, e);
        },
        updateItemQuantitiesById: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                updates: a
            }, b);
        },
        removeItemById: function(a, b) {
            var d;
            return null == b && (b = {}), d = {
                id: a,
                quantity: 0
            }, b.updateCart = !0, c.Queue.add("/cart/change.js", d, b);
        },
        clear: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/clear.js", {}, a);
        },
        getAttribute: function(a, b) {
            return a in c.cart.attributes ? c.cart.attributes[a] : b;
        },
        setAttribute: function(a, b, d) {
            var e;
            return null == d && (d = {}), e = {}, e[a] = b, c.Core.setAttributes(e, d);
        },
        getAttributes: function() {
            return c.cart.attributes;
        },
        setAttributes: function(a, b) {
            return null == a && (a = {}), null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b);
        },
        clearAttributes: function(a) {
            return null == a && (a = {}), a.updateCart = !0, c.Queue.add("/cart/update.js", c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""), a);
        },
        getNote: function() {
            return c.cart.note;
        },
        setNote: function(a, b) {
            return null == b && (b = {}), b.updateCart = !0, c.Queue.add("/cart/update.js", {
                note: a
            }, b);
        }
    }, a = null, c.Data = {
        init: function() {
            return a = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document), c.Data.setEventListeners("on"), c.Data.render(null, c.cart);
        },
        destroy: function() {
            return c.Data.setEventListeners("off");
        },
        setEventListeners: function(b) {
            return a[b]("click", "[data-cart-add]", c.Data.add), a[b]("click", "[data-cart-remove]", c.Data.remove), a[b]("click", "[data-cart-remove-id]", c.Data.removeById), a[b]("click", "[data-cart-update]", c.Data.update), a[b]("click", "[data-cart-update-id]", c.Data.updateById), a[b]("click", "[data-cart-clear]", c.Data.clear), a[b]("change", "[data-cart-toggle]", c.Data.toggle), a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute), a[b]("submit", "[data-cart-submit]", c.Data.submit), a[b]("cart.requestComplete", c.Data.render);
        },
        add: function(a) {
            var b;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"));
        },
        remove: function(a) {
            var b;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Core.removeItem(b.attr("data-cart-remove"));
        },
        removeById: function(a) {
            var b;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Core.removeItemById(b.attr("data-cart-remove-id"));
        },
        update: function(a) {
            var b;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"));
        },
        updateById: function(a) {
            var b;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"));
        },
        clear: function(a) {
            return a.preventDefault(), c.Core.clear();
        },
        toggle: function() {
            var a, b;
            return a = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), b = a.attr("data-cart-toggle"), a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b);
        },
        toggleAttribute: function() {
            var a, b;
            return a = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), b = a.attr("data-cart-toggle-attribute"), c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "");
        },
        submit: function(a) {
            var b, d, e, f;
            return a.preventDefault(), b = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).serializeArray(), d = void 0, f = void 0, e = {}, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).each(b, function(a, b) {
                return "id" === b.name ? d = b.value : "quantity" === b.name ? f = b.value : b.name.match(/^properties\[\w+\]$/) ? e[b.name] = b.value : void 0;
            }), c.Core.addItem(d, f, c.Utils.unwrapKeys(e));
        },
        render: function(a, b) {
            var d;
            return d = {
                item_count: b.item_count,
                total_price: b.total_price,
                total_price_money: c.Utils.formatMoney(b.total_price, c.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: c.Utils.formatMoney(b.total_price, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            }, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-cart-render]").each(function() {
                var a;
                return a = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), a.html(d[a.attr("data-cart-render")]);
            });
        }
    }, "rivets" in window ? (c.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return c.Rivets.bindViews();
        },
        destroy: function() {
            return c.Rivets.unbindViews();
        },
        bindViews: function() {
            return c.Utils.log("Rivets.js is present, binding views."), c.Rivets.unbindViews(), c.Rivets.model = c.Utils.extend({
                cart: c.cart
            }, c.settings.rivetsModels), null != window.Currency && (c.Rivets.model.Currency = window.Currency), (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-cart-view]").each(function() {
                var a;
                return a = rivets.bind((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), c.Rivets.model), c.Rivets.boundViews.push(a);
            });
        },
        unbindViews: function() {
            var a, b, d, e;
            for(e = c.Rivets.boundViews, b = 0, d = e.length; d > b; b++)a = e[b], a.unbind();
            return c.Rivets.boundViews = [];
        }
    }, rivets.formatters.eq = function(a, b) {
        return a === b;
    }, rivets.formatters.includes = function(a, b) {
        return a.indexOf(b) >= 0;
    }, rivets.formatters.match = function(a, b, c) {
        return a.match(new RegExp(b, c));
    }, rivets.formatters.lt = function(a, b) {
        return b > a;
    }, rivets.formatters.gt = function(a, b) {
        return a > b;
    }, rivets.formatters.not = function(a) {
        return !a;
    }, rivets.formatters.empty = function(a) {
        return !a.length;
    }, rivets.formatters.plus = function(a, b) {
        return parseInt(a) + parseInt(b);
    }, rivets.formatters.minus = function(a, b) {
        return parseInt(a) - parseInt(b);
    }, rivets.formatters.times = function(a, b) {
        return a * b;
    }, rivets.formatters.divided_by = function(a, b) {
        return a / b;
    }, rivets.formatters.modulo = function(a, b) {
        return a % b;
    }, rivets.formatters.prepend = function(a, b) {
        return b + a;
    }, rivets.formatters.append = function(a, b) {
        return a + b;
    }, rivets.formatters.slice = function(a, b, c) {
        return a.slice(b, c);
    }, rivets.formatters.pluralize = function(a, b, d) {
        return null == d && (d = b + "s"), c.Utils.isArray(a) && (a = a.length), 1 === a ? b : d;
    }, rivets.formatters.array_element = function(a, b) {
        return a[b];
    }, rivets.formatters.array_first = function(a) {
        return a[0];
    }, rivets.formatters.array_last = function(a) {
        return a[a.length - 1];
    }, rivets.formatters.money = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b);
    }, rivets.formatters.money_with_currency = function(a, b) {
        return c.Utils.formatMoney(a, c.settings.moneyWithCurrencyFormat, "money_with_currency_format", b);
    }, rivets.formatters.weight = function(a) {
        switch(c.settings.weightUnit){
            case "kg":
                return (a / 1e3).toFixed(c.settings.weightPrecision);
            case "oz":
                return (.035274 * a).toFixed(c.settings.weightPrecision);
            case "lb":
                return (.00220462 * a).toFixed(c.settings.weightPrecision);
            default:
                return a.toFixed(c.settings.weightPrecision);
        }
    }, rivets.formatters.weight_with_unit = function(a) {
        return rivets.formatters.weight(a) + c.settings.weightUnit;
    }, rivets.formatters.product_image_size = function(a, b) {
        return c.Utils.getSizedImageUrl(a, b);
    }, rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency, rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit, rivets.formatters.productImageSize = rivets.formatters.product_image_size) : c.Rivets = {
        init: function() {},
        destroy: function() {}
    }, c.factory = function(a) {
        return a.init = c.init, a.configure = c.configure, a.cart = c.cart, a.settings = c.settings, a.getCart = c.Core.getCart, a.addItem = c.Core.addItem, a.updateItem = c.Core.updateItem, a.updateItemById = c.Core.updateItemById, a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById, a.removeItem = c.Core.removeItem, a.removeItemById = c.Core.removeItemById, a.clear = c.Core.clear, a.getAttribute = c.Core.getAttribute, a.setAttribute = c.Core.setAttribute, a.getAttributes = c.Core.getAttributes, a.setAttributes = c.Core.setAttributes, a.clearAttributes = c.Core.clearAttributes, a.getNote = c.Core.getNote, a.setNote = c.Core.setNote, a.render = c.Data.render;
    }, c.factory($25f849c497f8b209$exports);
}).call(undefined);


const $48cc3ffebca0f766$var$qty = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '[data-qty-btn]', function(e) {
        e.preventDefault();
        const [operation, element] = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('qty-btn').split(', ');
        $48cc3ffebca0f766$var$updateQty(operation, element, e);
    });
};
const $48cc3ffebca0f766$var$updateQty = function(operation, element, event) {
    const id = event.currentTarget.dataset.id;
    const _input = document.querySelector('#qty-id-' + id);
    const _error = document.querySelector('#qty-id-error-' + id);
    const _errors = document.querySelectorAll('[data-qty-error]');
    const resetErrors = function() {
        _errors.forEach(function(err) {
            err.classList.add('hide');
            err.innerHTML = '';
        });
    };
    if (_input.value == 1 && operation == 'decr') return false;
    if (element == 'cart') {
        const line = _input.dataset.line;
        const _btn = event.currentTarget;
        let qty = _input.value * 1;
        _btn.disabled = true;
        resetErrors();
        switch(operation){
            case 'incr':
                qty++;
                (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).updateItem(line, qty, {}, {
                    "success": function(data, textStatus, jqXHR) {
                        _input.value = qty;
                        _btn.disabled = false;
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.error("cart add error:", jqXHR, textStatus, errorThrown);
                        _error.classList.remove('hide');
                        _error.innerHTML = "Sorry, we only have " + qty + " in stock";
                        _btn.disabled = false;
                    }
                });
                break;
            case 'decr':
                qty--;
                (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).updateItem(line, qty, {}, {
                    "success": function(data, textStatus, jqXHR) {
                        _input.value = qty;
                        _btn.disabled = false;
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.error("cart update error:", jqXHR, textStatus, errorThrown);
                        _btn.disabled = false;
                    }
                });
                break;
            default:
                break;
        }
    }
    if (element == 'product') switch(operation){
        case 'incr':
            _input.value++;
            break;
        case 'decr':
            _input.value--;
            break;
        default:
            break;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(_input).trigger('change');
};
var $48cc3ffebca0f766$export$2e2bcd8739ae039 = $48cc3ffebca0f766$var$qty;



var $iUSsr = parcelRequire("iUSsr");

function $09bbf9086b09b2ab$export$2e2bcd8739ae039() {
    const $productSlider = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-ps]');
    if ($productSlider.length) {
        $productSlider.on('init', function() {
            $productSlider.addClass('is-visible');
        });
        const sliderConfig = {
            asNavFor: '.product-thumb-slider',
            focusOnSelect: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="18.535" height="35" viewBox="0 0 18.535 35"><path d="M47.289 32.074L31.544 16.339A1.033 1.033 0 0 1 33 14.878l16.469 16.465a1.03 1.03 0 0 1 0 1.463L33 49.271a1.033 1.033 0 1 1-1.461-1.461z" transform="translate(-31.239 -14.576)"/></svg></button>',
            prevArrow: '<button class="slick-prev"><svg style="transform: rotateY(180deg);" xmlns="http://www.w3.org/2000/svg" width="18.535" height="35" viewBox="0 0 18.535 35"><path d="M47.289 32.074L31.544 16.339A1.033 1.033 0 0 1 33 14.878l16.469 16.465a1.03 1.03 0 0 1 0 1.463L33 49.271a1.033 1.033 0 1 1-1.461-1.461z" transform="translate(-31.239 -14.576)"/></svg></button>',
            dots: false,
            responsive: [
                {
                    breakpoint: 989,
                    settings: {
                        arrows: false,
                        infinite: true
                    }
                }
            ]
        };
        if ($productSlider.parents('.productTemplate--b').length != 0 && $productSlider.parents('.productTemplate--newBundle').length == 0) {
            delete sliderConfig.asNavFor;
            sliderConfig.dots = false;
            sliderConfig.adaptiveHeight = true;
            sliderConfig.responsive.dots = false;
        // sliderConfig.slide = 'a[data-contains]';
        }
        if ($productSlider.parents('.productTemplate--newBundle').length != 0) sliderConfig.responsive[0].settings.infinite = false;
        const slider = $productSlider.slick(sliderConfig).on('afterChange', function(slick, currentSlide, nextSlide) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-slider-dots ul li").removeClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-slider-dots ul li").eq(nextSlide % 4).addClass('active');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-slider-dots ul li").on('click', function() {
            var idx = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).index();
            $productSlider.slick('slickGoTo', idx);
        });
        function getLifeStyleSlide() {
            var ls_index = 100;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-ps] .slick-slide').each(function(index) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('img.lifestyle').length > 0) ls_index = index;
            });
            return ls_index;
        }
        function getLifeStyleSlideThumb() {
            var ls_index = 100;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-thumb-ps] .slick-slide:not(.slick-cloned)').each(function(index) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('img.lifestyle').length > 0) ls_index = index;
            });
            return ls_index;
        }
        function reindex(slider) {
            var indx = 0;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).each((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(slider + " .slick-slide:not(.slick-cloned)"), function(t, v) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(v).attr("data-slick-index", indx);
                indx++;
            });
        }
        if (screen.width >= 990) {
            var toRemove = parseInt(getLifeStyleSlide());
            if (toRemove < 100) {
                $productSlider.slick('slickRemove', toRemove);
                reindex('[data-ps]');
            }
        }
        const $productThumbSlider = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-thumb-ps]');
        if ($productThumbSlider.length) {
            $productThumbSlider.on('init', function() {
                $productThumbSlider.addClass('is-visible');
            });
            const thumbSlider = $productThumbSlider.slick({
                asNavFor: '.product-slider',
                slidesToShow: 3.8,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: false,
                focusOnSelect: true
            });
            if (screen.width >= 990) {
                const toRemove = parseInt(getLifeStyleSlideThumb());
                if (toRemove < 100) {
                    $productThumbSlider.slick('slickRemove', toRemove);
                    reindex('[data-thumb-ps]');
                }
            }
        }
    }
}



var $iUSsr = parcelRequire("iUSsr");

const $3de39f9df6e61772$var$$qtySelector = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-qty]");
const $3de39f9df6e61772$var$$readMore = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-read-more");
var $3de39f9df6e61772$var$is_first = true;
// Function to show ships_on metafield text
const $3de39f9df6e61772$var$showShipsOnText = function($variantSelected) {
    const shipsOnText = $variantSelected.data("variant-oos");
    // Display ships_on text in a specific area
    if (shipsOnText) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".ships-on").show();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".ships-on").text(shipsOnText); // Change the selector to match your specific area
    } else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".ships-on").hide().empty(); // Optional: Clear the text if there is no shipsOnText
};
const $3de39f9df6e61772$var$updateProduct = function($productForm) {
    if (!$productForm.length) return;
    const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", $productForm.find("[data-all-variants]"));
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-selected-variant-id]").val($variantSelected.val());
    if (typeof bwp !== "undefined") bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
    $3de39f9df6e61772$var$updatePrice($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateOptions($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateButton($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateLowStock($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateTopLabel($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateImage($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateHistoryState($variantSelected.val());
    // updateRecharge($variantSelected);
    $3de39f9df6e61772$var$showShipsOnText($variantSelected); // Display ships_on text
};
const $3de39f9df6e61772$var$updateProduct_first = function($productForm) {
    if (!$productForm.length) return;
    const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", $productForm.find("[data-all-variants]"));
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-selected-variant-id]").val($variantSelected.val());
    if (typeof bwp !== "undefined") bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
    $3de39f9df6e61772$var$updatePrice($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateOptions($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateButton($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateLowStock($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateTopLabel($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateImage_first($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateHistoryState($variantSelected.val());
    // updateRecharge($variantSelected);
    $3de39f9df6e61772$var$showShipsOnText($variantSelected); // Display ships_on text
};
const $3de39f9df6e61772$var$updateProduct1 = function($productForm) {
    if (!$productForm.length) return;
    const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", $productForm.find("[data-all-variants]"));
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-selected-variant-id1]").val($variantSelected.val());
    if (typeof bwp !== "undefined") bwp.updateWidget(`${$variantSelected.attr("data-sku")}`);
    $3de39f9df6e61772$var$updatePrice($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateOptions($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateButton($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateLowStock($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateTopLabel($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateImage($variantSelected, $productForm);
    $3de39f9df6e61772$var$updateHistoryState($variantSelected.val());
// updateRecharge($variantSelected);
};
const $3de39f9df6e61772$var$updateHistoryState = function(variant) {
    if (!history.replaceState || !variant) return;
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant;
    window.history.replaceState({
        path: newurl
    }, "", newurl);
};
const $3de39f9df6e61772$var$updateImage = function($variantSelected, $productForm) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".productTemplate--b").length != 0) {
        const option1 = $variantSelected.data("option1");
        const variantid = $variantSelected.val();
        if (typeof variantid != "undefined") {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-images").attr("data--hidden", true).removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-images[data-variant-color="' + option1 + '"]').addClass("active").removeAttr("data--hidden", true);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-images.active [data-ps]").slick("refresh");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-images.active  .mobile-product-images[data-ps]").slick("refresh");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-ps]").slick("slickGoTo", 0);
        }
    }
};
const $3de39f9df6e61772$var$updateImage_first = function($variantSelected, $productForm) {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-slider").slick("slickGoTo", 0);
};
const $3de39f9df6e61772$var$updatePrice = function($variantSelected, $productForm) {
    const $price = $productForm.find("[data-price]").length > 0 ? $productForm.find("[data-price]") : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-top-info [data-price]");
    const $priceCompare = $productForm.find("[data-price-compare]").length > 0 ? $productForm.find("[data-price-compare]") : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-top-info [data-price-compare]");
    const $benefit = $productForm.find("[data-price-save]").length > 0 ? $productForm.find("[data-price-save]") : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-top-info [data-price-save]");
    const price = $variantSelected.data("variant-price");
    const comparePrice = $variantSelected.data("variant-compare-price");
    let counter = 0;
    function checkParent(item) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).parents(".product-switcher__item").length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).parents(".product-switcher__item").find("input").is(":checked") : true;
    }
    $price.each((index, item)=>{
        if (checkParent(item)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(price));
            if ($priceCompare.length > 0 && checkParent($priceCompare[counter])) {
                comparePrice > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($priceCompare[counter]).text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(comparePrice)).show() : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($priceCompare[counter]).hide();
                comparePrice > 0 && $benefit.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($benefit[counter]).text("Save $" + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(comparePrice - price, "{{amount_no_decimals}}")).show() : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($benefit[counter]).hide();
            }
            counter = ++counter;
        }
    });
};
const $3de39f9df6e61772$var$updateButton = function($variantSelected, $productForm) {
    const stickyButton = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".sticky-bottom--button [data-add-to-cart]");
    let $addToCart = $productForm.find("[data-add-to-cart]").add(stickyButton);
    var $preorder = $productForm.find(".preorder_text");
    var btn_label = window.theme.strings.addToCart;
    var is_preorder = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-form").attr("data-preorder");
    var is_offer = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-add-to-cart:not(.orginal-add-to-cart)").hasClass("redeem-offer");
    if (is_offer) btn_label = window.theme.strings.redeemoffer;
    if (!$productForm.hasClass("product-form--bundle")) {
        btn_label += " - <span>" + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.attr("data-variant-price")) + "</span>";
        var btn_preorder_label = window.theme.strings.preOrder + " - <span>" + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.attr("data-variant-price")) + "</span>";
        if ($variantSelected.attr("data-variant-compare-price") != "") btn_label += '<span class="was"> (' + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.attr("data-variant-compare-price")) + ")</span>";
    }
    var interval = 1;
    if ($3de39f9df6e61772$var$is_first) interval = 1000;
    if ($variantSelected.data("subscription-id") != "") {
        let text = window.theme.strings.recharge;
        if ($variantSelected.data("product-handle") && $variantSelected.data("product-handle").indexOf("annual") != -1) {
            let price = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.data("variant-price"));
            text += " - " + price;
        }
        $addToCart.attr("disabled", false).text(text);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-bis-trigger").removeClass("visible");
    } else if ($variantSelected.data("available") == true) {
        if (is_preorder == "true" && $variantSelected.data("inventory-quantity") <= 0) {
            if ($variantSelected.closest(".product-form").find(".product-progress").length > 0) $variantSelected.closest(".product-form").find(".product-progress").removeClass("hide");
            if ($variantSelected.closest(".product-form").find(".product-preorder").length > 0) $variantSelected.closest(".product-form").find(".product-preorder").removeClass("hide");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".preorder_text").removeClass("hide");
        } else {
            if ($variantSelected.closest(".product-form").find(".product-progress").length > 0) $variantSelected.closest(".product-form").find(".product-progress").addClass("hide");
            if ($variantSelected.closest(".product-form").find(".product-preorder").length > 0) $variantSelected.closest(".product-form").find(".product-preorder").addClass("hide");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".preorder_text").addClass("hide");
        }
        if ($variantSelected.data("inventory-policy") == "continue" && $variantSelected.data("inventory-quantity") <= 0 && $variantSelected.data("product-handle") != "beast-e-gift-card") {
            $addToCart.attr("disabled", false).html(btn_preorder_label);
            $preorder.removeAttr("data--hidden");
        } else $addToCart.attr("disabled", false).html(btn_label);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-bis-trigger").removeClass("visible");
    } else if (is_preorder == "true" && $variantSelected.data("inventory-quantity") <= 0) {
        $addToCart.attr("disabled", false).html(btn_preorder_label);
        $preorder.removeAttr("data--hidden");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-bis-trigger").removeClass("visible");
        if ($variantSelected.closest(".product-form").find(".product-progress").length > 0) $variantSelected.closest(".product-form").find(".product-progress").removeClass("hide");
        if ($variantSelected.closest(".product-form").find(".product-preorder").length > 0) $variantSelected.closest(".product-form").find(".product-preorder").removeClass("hide");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".preorder_text").removeClass("hide");
    } else {
        if (!$productForm.hasClass("product-form--bundle")) $addToCart.attr("disabled", true).text(window.theme.strings.soldOut + " - " + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.data("variant-price")));
        else $addToCart.attr("disabled", true).text(window.theme.strings.soldOut);
        $preorder.attr("data--hidden", "true");
        setTimeout(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-bis-trigger").addClass("visible");
        }, interval);
    }
    $3de39f9df6e61772$var$is_first = false;
};
const $3de39f9df6e61772$var$updateTopLabel = function($variantSelected, $productForm) {
    const $topLabel = $productForm.find(".product-info__top-label").find("span");
    if ($variantSelected.data("product-handle") && $variantSelected.data("product-handle").indexOf("annual") != -1 && $variantSelected.data("subscription-id") != "" && $topLabel.length) {
        let text = window.theme.strings.recharge;
        let price = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)($variantSelected.data("variant-price"));
        text += " - " + price;
        text = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`<b>${text}</b>`);
        $topLabel.html(text);
    }
};
const $3de39f9df6e61772$var$updateLowStock = function($variantSelected, $productForm) {
    const $lowStock = $productForm.find("[data-low-stock]");
    if ($variantSelected.data("available")) $lowStock.removeClass("hide");
    else $lowStock.addClass("hide");
};
const $3de39f9df6e61772$var$syncBundleRadioStates = function($variantSelected, $productForm) {
    const option1 = $variantSelected.data("option1");
    const option2 = $variantSelected.data("option2");
    const option3 = $variantSelected.data("option3");
    if (option2 && option2 !== "_BLANK_") {
        $productForm.find("[data-product-option=2]").prop("checked", false).parent().find("label").removeClass("checked");
        const $r2 = $productForm.find(`[data-product-option=2][value="${option2}"]`);
        $r2.prop("checked", true).parent().find("label").addClass("checked");
    }
    if (option3 && option3 !== "_BLANK_") {
        $productForm.find("[data-product-option=3]").prop("checked", false).parent().find("label").removeClass("checked");
        const $r3 = $productForm.find(`[data-product-option=3][value="${option3}"]`);
        $r3.prop("checked", true).parent().find("label").addClass("checked");
    }
    if (option1 && option1 !== "_BLANK_") {
        const $r1 = $productForm.find(`[data-product-option=1][value="${option1}"]`);
        $r1.prop("checked", true).parent().find("label").addClass("checked");
    }
};
const $3de39f9df6e61772$var$updateOptions = function($variantSelected, $productForm) {
    // For bundle products the variant list is capped at 250 — do not disable swatches
    // based on an incomplete availability picture. Still sync radio checked states.
    if ($productForm.hasClass("product-form--bundle")) {
        $3de39f9df6e61772$var$syncBundleRadioStates($variantSelected, $productForm);
        return;
    }
    // Update option 1
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=1]").each(function(index, option1) {
        const $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]");
        let disabled = true;
        const optionVal = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(option1).val();
        $productForm.find("[data-all-variants]").find("option").each(function(index, selectOption) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("option1") == optionVal && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("available") == true) disabled = false;
        });
        if (disabled) // $(option1).attr('disabled', true);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(option1).addClass("is-disabled");
    });
    // Update options 2 and 3
    const option1 = $variantSelected.data("option1");
    $productForm.find("[data-all-variants]").find("option").each(function(index, selectOption) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("option1") == option1) {
            const option2 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("option2");
            const $option2 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-product-option=2][value='${option2}']`);
            const option3 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("option3");
            const $option3 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-product-option=3][value='${option3}']`);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(selectOption).data("available") == false) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(option2).addClass("is-disabled");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(option3).addClass("is-disabled");
            } else {
                $option2.attr("disabled", false);
                $option3.attr("disabled", false);
            }
        }
    });
};
const $3de39f9df6e61772$var$fetchVariantFromSection = async ($productForm, option1, option2, option3)=>{
    const productHandle = $productForm.data('product-handle');
    const sectionId = $productForm.data('section-id');
    if (!productHandle || !sectionId) return null;
    const getValueId = (optionNum, value)=>{
        if (value === '_BLANK_') return null;
        return $productForm.find(`[data-product-option=${optionNum}][value='${value}']`).data('option-value-id') || null;
    };
    const ids = [
        getValueId(1, option1),
        getValueId(2, option2),
        getValueId(3, option3)
    ].filter(Boolean);
    if (!ids.length) return null;
    const url = `/products/${productHandle}?option_values=${ids.join(',')}&section_id=${sectionId}`;
    try {
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newForm = doc.querySelector('[data-product-form]');
        if (!newForm) return null;
        const newVariantId = newForm.dataset.variantid;
        if (!newVariantId) return null;
        const newPriceEl = doc.querySelector('[data-price]');
        const newComparePriceEl = doc.querySelector('[data-price-compare]');
        const newBtn = doc.querySelector('[data-add-to-cart]');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-selected-variant-id]').val(newVariantId);
        $productForm.attr('data-variantid', newVariantId);
        $3de39f9df6e61772$var$updateHistoryState(newVariantId);
        if (newPriceEl) {
            $productForm.find('[data-price]').text(newPriceEl.textContent.trim());
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-top-info [data-price]').text(newPriceEl.textContent.trim());
        }
        if (newComparePriceEl) {
            const compareText = newComparePriceEl.textContent.trim();
            if (compareText) {
                $productForm.find('[data-price-compare]').text(compareText).show();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-top-info [data-price-compare]').text(compareText).show();
            } else {
                $productForm.find('[data-price-compare]').hide();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-top-info [data-price-compare]').hide();
            }
        }
        if (newBtn) {
            const isDisabled = newBtn.hasAttribute('disabled');
            const $atcBtn = $productForm.find('[data-add-to-cart]');
            if (isDisabled) {
                $atcBtn.attr('disabled', true).text(window.theme.strings.soldOut);
                setTimeout(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.custom-bis-trigger').addClass('visible');
                }, 1000);
            } else {
                $atcBtn.attr('disabled', false).html(newBtn.innerHTML);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.custom-bis-trigger').removeClass('visible');
            }
        }
        return newVariantId;
    } catch (e) {
        console.error('Variant fetch failed', e);
        return null;
    }
};
function $3de39f9df6e61772$export$2e2bcd8739ae039() {
    // Sync option label spans with the initially-checked radio values
    const $opt1Checked = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=1]:checked");
    const $opt2Checked = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=2]:checked");
    const $opt3Checked = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=3]:checked");
    if ($opt1Checked.length) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option1").text($opt1Checked.val());
    if ($opt2Checked.length) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option2").text($opt2Checked.val());
    if ($opt3Checked.length) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option3").text($opt3Checked.val());
    // Variants changing (automatically triggers from options changing)
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("change", "[data-all-variants]", function() {
        $3de39f9df6e61772$var$updateProduct((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]"));
    });
    $3de39f9df6e61772$var$$qtySelector.on("change", function() {
        $3de39f9df6e61772$var$updateProduct((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]"));
    });
    $3de39f9df6e61772$var$$readMore.on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).parent().parent().find(".product-block").removeClass("read-more");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).parent().addClass("read-more");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-in-box]", function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("in-box") == true) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".in-box-arrow").show();
            var ls_index = 100;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-ps] .slick-slide:not(.slick-cloned)").each(function(index) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find("[data-box-image]").length > 0) ls_index = index;
            });
            try {
                const slideIndex = ls_index;
                if (slideIndex < 100) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-slider").slick("slickGoTo", slideIndex);
            } catch  {
                console.log("No in box image");
            }
        } else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".in-box-arrow").hide();
    });
    // Options changing
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-product-option]", function() {
        const $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]");
        const option1 = $productForm.find("[data-product-option=1]:checked").val() || "_BLANK_";
        const option2 = $productForm.find("[data-product-option=2]:checked").val() || "_BLANK_";
        const option3 = $productForm.find("[data-product-option=3]:checked").val() || "_BLANK_";
        const $vSelector = $productForm.find("[data-all-variants]");
        const value = $vSelector.find(`[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        if (value !== undefined) $vSelector.val(value).trigger("change");
        else {
            // Variant not in the first 250 — use Section Rendering API
            $3de39f9df6e61772$var$fetchVariantFromSection($productForm, option1, option2, option3);
            $3de39f9df6e61772$var$updateImage($vSelector.find("option:selected"), $productForm);
        }
        // Update option label spans (scoped to this form)
        if (option1 !== "_BLANK_") $productForm.find("#product_option1").text(option1);
        if (option2 !== "_BLANK_") $productForm.find("#product_option2").text(option2);
        if (option3 !== "_BLANK_") $productForm.find("#product_option3").text(option3);
        $productForm.find(".product-option__color").removeClass("checked");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).parent().find("label").addClass("checked");
    });
    // Options changing
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size1").on("change", function() {
        const $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]");
        const option1 = $productForm.find("#option-size1").val() ? $productForm.find("#option-size1").val() : "_BLANK_";
        const option2 = $productForm.find("[data-product-option=2]:checked").length ? $productForm.find("[data-product-option=2]:checked").val() : "_BLANK_";
        const option3 = $productForm.find("[data-product-option=3]:checked").length ? $productForm.find("[data-product-option=3]:checked").val() : "_BLANK_";
        const $vSelector = $productForm.find("[data-all-variants]");
        const value = $vSelector.find(`[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        $vSelector.val(value).trigger("change");
        //Option name changing
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option1").text((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size1").val());
    });
    var _flag = false;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .selected_val").on("mouseover", function() {
        _flag = true;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .selected_val").on("mouseleave", function() {
        _flag = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", function() {
        if (_flag == false) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .selected_val").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .dropdown-list").removeClass("visible");
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".custom-bis-trigger button", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-bis-trigger")[0].click();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .dropdown-list span").on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size2").val((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text()).change();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-custom-dropdown] .selected_val").on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass("active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).next(".dropdown-list").toggleClass("visible");
    });
    // Options changing
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size2").on("change", function() {
        const $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]");
        const option1 = $productForm.find("[data-product-option=1]:checked").length ? $productForm.find("[data-product-option=1]:checked").val() : "_BLANK_";
        const option2 = $productForm.find("#option-size2").val() ? $productForm.find("#option-size2").val() : "_BLANK_";
        const option3 = $productForm.find("[data-product-option=3]:checked").length ? $productForm.find("[data-product-option=3]:checked").val() : "_BLANK_";
        const $vSelector = $productForm.find("[data-all-variants]");
        const value = $vSelector.find(`[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        // $vSelector.val(value).trigger('change');
        console.log("variantselector value", $vSelector.val());
        //Option name changing
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option2").text((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size2").val());
        var targetObj = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-redirect-selector]").find('option[data-value1="' + option1 + '"][data-value2="' + option2 + '"]');
        window.location.href = "/products/" + targetObj.attr("data-url");
    });
    // Options changing
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size3").on("change", function() {
        const $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]");
        const option1 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=1]:checked").length ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=1]:checked").val() : "_BLANK_";
        const option2 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=2]:checked").length ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-option=2]:checked").val() : "_BLANK_";
        const option3 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size3").val() ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size3").val() : "_BLANK_";
        const $vSelector = $productForm.find("[data-all-variants]");
        const value = $vSelector.find(`[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        $vSelector.val(value).trigger("change");
        console.log("variantselector value", $vSelector.val());
        //Option name changing
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#product_option3").text((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#option-size3").val());
    });
    if (window.productTemplateLoaded) {
        $3de39f9df6e61772$var$updateProduct_first((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-main").find("[data-product-form]"));
        $3de39f9df6e61772$var$updateProduct1((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-main").find("[data-product-form1]"));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".product-preorder-title.hide--desktop", function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").hasClass("open")) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").removeClass("open");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").find(".product-preorder-subtitle").addClass("hide--mobile");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").find(".product-preorder-item").addClass("hide--mobile");
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").addClass("open");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").find(".product-preorder-subtitle").removeClass("hide--mobile");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-items").find(".product-preorder-item").removeClass("hide--mobile");
        }
    });
}



var $iUSsr = parcelRequire("iUSsr");

const $732388c7eeead09f$export$aeacd9116b5e16bd = (productId)=>{
    if (productId != undefined && productId != null) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989) $732388c7eeead09f$export$8a1fd327dc8d396c((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-product-recommendations].hide__mobile'), productId);
        else $732388c7eeead09f$export$8a1fd327dc8d396c((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.hide--desktop > [data-product-recommendations]'), productId);
    }
};
const $732388c7eeead09f$export$8a1fd327dc8d396c = ($recommendationSection, productId)=>{
    if (!$recommendationSection || !$recommendationSection.length) return;
    const selectors = {
        placeholder: '[data-product-recommendations-placeholder]',
        recommendationsContent_d: ' [data-product-recommendations-content].hide--mobile',
        recommendationsContent_m: ' [data-product-recommendations-content].hide--desktop'
    };
    const limit = 6;
    const $placeholder = $recommendationSection.find(selectors.placeholder);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-upsell-wrapper]').css('opacity', 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        type: 'GET',
        url: '/recommendations/products?section_id=ea-product-recommendations&limit=' + limit + '&product_id=' + productId,
        success: function(data) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find(selectors.recommendationsContent_d).length && !(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find(selectors.recommendationsContent_m).length) ;
            else {
                // $placeholder.html($(data).find(selectors.recommendationsContent).html());
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-minicart].minicart .upsell_recommend").removeClass('slick-initialized').removeClass('slick-slider');
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-upsell-wrapper].hide__mobile').html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find(selectors.recommendationsContent_d).html());
                    setTimeout(function() {
                        if (window.lazySizes && typeof window.lazySizes.init === 'function') window.lazySizes.init();
                        (0, $0d840adb65d390a7$export$43bee144004852f1)((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-upsell-wrapper].hide__mobile'));
                    }, 300);
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.hide--desktop > [data-upsell-wrapper]').html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find(selectors.recommendationsContent_m).html());
                    setTimeout(function() {
                        (0, $0d840adb65d390a7$export$43bee144004852f1)((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.hide--desktop > [data-upsell-wrapper]'));
                    }, 300);
                }
                setTimeout(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-upsell-wrapper]').css('opacity', 1);
                }, 500);
            // $('[data-upsell-wrapper]').slick();
            // mountSlider($('[data-upsell-wrapper]'));
            // const $recommendationSliders = $recommendationSection.find('[data-hor-slider]');
            // $recommendationSliders.each(function (index, recommendationSlider) {
            //     const $recommendationSlider = $(recommendationSlider);
            //     mountSlider($recommendationSlider);
            // });
            }
        },
        error: function() {
            console.error("Recommendations content load failed");
        }
    });
};
function $732388c7eeead09f$export$2e2bcd8739ae039() {
// mountRecommendationSection();
}


//import stickyATC from './stickyATC';
const $05f743a724b1c58b$var$scrollNav = ()=>{
    $('.anchors-items .anchors-item a').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(".anchors-item .active").removeClass("active");
        $(this).addClass("active");
    /*    if($(this).attr('href') == '') {
      $('.anchors-item a[href=""]').addClass('active');
      $('.template-product').addClass('prod-specs');
      $(".product-main, #product-process, #product-faq, #product-reviews").hide();
      $("#product-tech").show();
      $("html, body").animate({ scrollTop: 0 }, "fast");       
     // $('.product-stickybar-top').removeClass('hide--mobile');
    }
    else {
      $('.template-product').removeClass('prod-specs');
      $(".product-main, #product-process, #product-faq, #product-reviews").show();
      $("#product-tech").hide();
      //$('.product-stickybar-top').addClass('hide--mobile');
      if($(this).attr('href') == '#shopify-section-ea-product-main') {
        setTimeout(function(){
          $("html, body").animate({ scrollTop: 0 }, 350);       
        }, 800);
      }
    }*/ });
    let $div = $("#addToCartForm .product-add-to-cart"), $div2 = $(".afterpay-paragraph"), $div2text, div2oldtext;
    function fixDiv() {
        if ($("body.template-product-bundle").length > 0) return;
        $div = $("#addToCartForm .product-add-to-cart");
        $div2 = $(".afterpay-paragraph");
        $div2text = $(".afterpay-paragraph .afterpay-text1");
        div2oldtext = $(".afterpay-paragraph .afterpay-text1").text();
        if ($(window).scrollTop() > $div.data("top")) {
            $div.addClass('bottom-fixed');
            $div2.addClass('bottom-fixed');
            $div2text.text('Shop now. Pay later with');
            $('#shopify-section-ea-footer').addClass('bottom-fixed');
        } else {
            $div.removeClass('bottom-fixed');
            $div2.removeClass('bottom-fixed');
            $div2text.text(div2oldtext);
            $('#shopify-section-ea-footer').removeClass('bottom-fixed');
        }
    }
    if (typeof $div.offset() != "undefined") $("#addToCartForm .product-add-to-cart").data("top", $("#addToCartForm .product-add-to-cart").offset().top); // set original position on load
    $(window).scroll(fixDiv);
};
const $05f743a724b1c58b$var$scrollReviews = ()=>{
    if ($('.template-product-bundle').length > 0) $(document).on('click', '[data-link]', function() {
        const thisLink = $(this).attr('data-link');
        const $elem = $(`[${thisLink}]`);
        if ($elem) $elem[0].scrollIntoView({
            behavior: "auto",
            block: "end",
            inline: "nearest"
        });
    });
};
function $05f743a724b1c58b$export$2e2bcd8739ae039() {
    $05f743a724b1c58b$var$scrollReviews();
    (0, $09bbf9086b09b2ab$export$2e2bcd8739ae039)();
    (0, $3de39f9df6e61772$export$2e2bcd8739ae039)();
    (0, $732388c7eeead09f$export$2e2bcd8739ae039)();
    $05f743a724b1c58b$var$scrollNav();
//stickyATC();
}



var $iUSsr = parcelRequire("iUSsr");
const $56032083f0ed7410$var$login = function() {
    $56032083f0ed7410$var$resetPassHandle();
};
const $56032083f0ed7410$var$resetPassHandle = function() {
    const login = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-login]');
    const forgot = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-login-forgot]');
    const forgotLink = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-forgot-link]');
    const loginLink = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-login-link]');
    forgotLink.click(function(e) {
        e.preventDefault();
        login.addClass('is-hidden').parent().css('height', 0);
        forgot.removeClass('is-hidden').parent().css('height', 'auto');
    });
    loginLink.click(function(e) {
        e.preventDefault();
        login.removeClass('is-hidden').parent().css('height', 'auto');
        forgot.addClass('is-hidden').parent().css('height', 0);
    }).click();
};
var $56032083f0ed7410$export$2e2bcd8739ae039 = $56032083f0ed7410$var$login;



var $iUSsr = parcelRequire("iUSsr");
const $819ac149f13a907c$var$customerAddresses = function() {
    var $newAddressForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#AddressNewForm');
    if (!$newAddressForm.length) return;
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
    });
    // Initialize each edit form's country/province selector
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.address-country-option').each(function() {
        var formId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });
    // Toggle new/edit address forms
    var flag = false;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.address-new-toggle.top').toggleClass('hide');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".return_account").toggleClass('hide');
        var title;
        if (flag == false) {
            flag = true;
            title = 'Add a New Address';
        } else {
            flag = false;
            title = 'Addresses';
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-title-address]").text(title);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.address-edit-toggle').on('click', function() {
        var formId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('form-id');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#EditAddress_' + formId).toggleClass('hide');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".current_address").toggleClass('hide');
    });
    var formId;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.address-delete').on('click', function() {
        var $el = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        formId = $el.data('form-id');
    // var confirmMessage = $el.data('confirm-message');
    // if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
    //   Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    // }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-remove-address]").on('click', function() {
        Shopify.postLink('/account/addresses/' + formId, {
            parameters: {
                _method: 'delete'
            }
        });
    });
};
var $819ac149f13a907c$export$2e2bcd8739ae039 = $819ac149f13a907c$var$customerAddresses;



var $iUSsr = parcelRequire("iUSsr");
const $1069474bd9395150$var$animation = function() {
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section, [data-animate-section]');
    const blocks = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-animate-block]');
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        const scroll = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).scrollTop();
        const windowHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerHeight();
        const headerHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-site-header]').outerHeight();
        sections.each(function(index, section) {
            const sectionTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(section).offset().top - (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerHeight() / 1.5;
            if (scroll >= sectionTop) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(section).addClass('section-in');
        });
        blocks.each(function(index, block) {
            const blockTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).offset().top;
            const blockHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).outerHeight();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).find('[data-scroll-line]').length) {
                let lineHeight = 0;
                let $lastActiveBlock = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).find('[data-animate-block].is-active').last();
                if ($lastActiveBlock.length) {
                    const lastActiveBlockHeight = $lastActiveBlock.outerHeight();
                    lineHeight = 100 * (scroll + headerHeight + windowHeight / 2 - blockTop - lastActiveBlockHeight) / blockHeight;
                } else $lastActiveBlock = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).find('[data-animate-block]').eq(0);
                const imgUrl = $lastActiveBlock.data('image');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-scroll-image]').attr('src', imgUrl);
                if (lineHeight >= 100) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).addClass('is-active');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-scroll-line]', (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block)).css('height', '100%');
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).removeClass('is-active');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-scroll-line]', (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block)).css('height', lineHeight + '%');
                }
            } else if (scroll + headerHeight + windowHeight / 2 >= blockTop + blockHeight - 300) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).addClass('is-active');
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(block).removeClass('is-active');
        });
    }).scroll();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').addClass('body-in');
    });
};
var $1069474bd9395150$export$2e2bcd8739ae039 = $1069474bd9395150$var$animation;



var $iUSsr = parcelRequire("iUSsr");


const $34a037206fb20059$var$$cartPage = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-cart-page]');
const $34a037206fb20059$export$827a6c17a85f6d1a = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).get("/cart?view=ajax", function(data, textStatus, jqXHR) {
        const tpl = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find('[data-cart-page]').html();
        const count = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find('[data-items-count]').data('items-count');
        $34a037206fb20059$var$$cartPage.html(tpl);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-cart-count]').text(count);
    });
};
const $34a037206fb20059$var$updateDiscounts = function(discounts) {
    discounts.forEach((discount)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-discount]').each(function(index, element) {
            if (discount.title == (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).data('discount')) {
                let discountValue = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(discount.total_allocated_amount);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).text('-' + discountValue);
            }
        });
    });
};
const $34a037206fb20059$var$redirect = function() {
    const $checkoutBtn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-checkout-btn]');
    const $cartHookBtn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-checkout-btn]').next();
    if (localStorage.getItem('redirect_to_checkout') === 'true') {
        if (window.ReCharge && window.ReCharge.subscriptions) {
            console.log('redirect to recharge checkout');
            $checkoutBtn.click();
        } else if ($cartHookBtn.length) {
            console.log('redirect to carthook checkout');
            setInterval(()=>{
                if (window.chScriptLoaded === true) $cartHookBtn.click();
            }, 500);
        } else {
            console.log('redirect to shopify checkout');
            $checkoutBtn.click();
        }
        localStorage.setItem('redirect_to_checkout', false);
    } else window.location.href = '/';
};
function $34a037206fb20059$export$2e2bcd8739ae039() {
    if ($34a037206fb20059$var$$cartPage.length) {
        $34a037206fb20059$var$redirect();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('cart.requestComplete', $34a037206fb20059$export$827a6c17a85f6d1a);
        // Remove variant:
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '[data-cart-remove-item]', function(e) {
            e.preventDefault();
            const currentId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('id');
            (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).removeItemById(currentId, {
                "error": function(jqXHR, textStatus, errorThrown) {
                    console.error("cart delete item error:", jqXHR, textStatus, errorThrown);
                }
            });
        });
        // Update variant:
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('change', '[data-variant-select]', function(e) {
            const $row = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('[data-cart-row]');
            const qty = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-qty]', $row).val();
            const id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('option:selected').data('variant-id');
            const currentId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('current-id');
            let properties = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('properties');
            (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).addItem(id, qty, properties, {
                "success": function(data, textStatus, jqXHR) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).removeItemById(currentId, {
                        "error": function(jqXHR, textStatus, errorThrown) {
                            console.error("cart delete item after adding new item error:", jqXHR, textStatus, errorThrown);
                        }
                    });
                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    console.error("cart update error:", jqXHR, textStatus, errorThrown);
                }
            });
        });
        // Update recharge period
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-rc-period]').change(function(e) {
            const $row = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('[data-cart-row]');
            const qty = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-qty]', $row).val();
            const line = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('line');
            const properties = {
                "shipping_interval_frequency": (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).val(),
                "shipping_interval_unit_type": (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('rc-period'),
                "subscription_id": (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('subscription-id')
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($25f849c497f8b209$exports))).updateItem(line, qty, properties, {
                "error": function(jqXHR, textStatus, errorThrown) {
                    console.error("cart update error:", jqXHR, textStatus, errorThrown);
                }
            });
        });
    }
}



var $iUSsr = parcelRequire("iUSsr");
const $b8bcb8152ef21fa3$var$selectors = {
    feed: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-instagram-feed]')
};
let $b8bcb8152ef21fa3$var$items = [];
const $b8bcb8152ef21fa3$var$render = (items)=>{
    $b8bcb8152ef21fa3$var$selectors.feed.html('');
    items.forEach((edge, index)=>{
        if (index >= $b8bcb8152ef21fa3$var$selectors.feed.data('max-slides')) return false;
        const el = `<a 
      href="${edge.href}" 
      target="_blank" 
      class="instagram-feed__post no-hover-link">
        <img src="${edge.image}">
        <span>
          <b><i class="icon-heart"></i>${edge.likes}</b>
          <b><i class="icon-bubble"></i>${edge.comments}</b>
        </span>
      </a>`;
        $b8bcb8152ef21fa3$var$selectors.feed.append(el);
    });
    let i = $b8bcb8152ef21fa3$var$selectors.feed.find("img").length;
    let j = 0;
    $b8bcb8152ef21fa3$var$selectors.feed.find("img").one("load", function() {
        j++;
        if (j == i) $b8bcb8152ef21fa3$var$selectors.feed.removeClass('is-hidden');
    }).each(function() {
        if (this.complete) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).trigger('load'); // For jQuery >= 3.0 
    });
};
const $b8bcb8152ef21fa3$var$init = ()=>{
    if (window.instagramUrl) {
        if ($b8bcb8152ef21fa3$var$items.length == 0) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).get(window.instagramUrl + '?__a=1', (data)=>{
            const edges = data.graphql.user.edge_owner_to_timeline_media.edges;
            edges.forEach((edge)=>{
                $b8bcb8152ef21fa3$var$items.push({
                    image: edge.node.thumbnail_src,
                    href: `https://www.instagram.com/p/${edge.node.shortcode}`,
                    comments: edge.node.edge_media_to_comment.count,
                    likes: edge.node.edge_liked_by.count
                });
            });
            $b8bcb8152ef21fa3$var$render($b8bcb8152ef21fa3$var$items);
        }).fail(()=>{
            console.error("Instagram didn't get data");
        });
        else $b8bcb8152ef21fa3$var$render($b8bcb8152ef21fa3$var$items);
    } else console.error("Instagram url not found");
};
const $b8bcb8152ef21fa3$var$instagramFeed = ()=>{
    if ($b8bcb8152ef21fa3$var$selectors.feed.length) {
        $b8bcb8152ef21fa3$var$init();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).resize($b8bcb8152ef21fa3$var$init);
    }
};
var $b8bcb8152ef21fa3$export$2e2bcd8739ae039 = $b8bcb8152ef21fa3$var$instagramFeed;



var $iUSsr = parcelRequire("iUSsr");
function $4a6467074ac21b06$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-popup-close]').click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('[data-popup]').addClass('is-hidden').trigger('setDefaultContent');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-popup-open]').click(function(event) {
        event.preventDefault();
        var popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('popup-open');
        var $popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-popup="' + popup + '"');
        $popup.toggleClass('is-hidden');
    });
    // Open popup when popup form loaded with errors
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-popup-form-errors]').each(function(index, element) {
        const popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('popup-form-errors');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-popup-open="${popup}"]`).trigger('click');
    });
}



var $iUSsr = parcelRequire("iUSsr");
var $9b125a4b43f93caa$exports = {};
(function(global, factory) {
    $9b125a4b43f93caa$exports = factory();
})($9b125a4b43f93caa$exports, function() {
    'use strict';
    var OPTIONS = [
        'prefix',
        'templateDelimiters',
        'rootInterface',
        'preloadData',
        'handler'
    ];
    var EXTENSIONS = [
        'binders',
        'formatters',
        'adapters'
    ];
    var PRIMITIVE = 0;
    var KEYPATH = 1;
    var TEXT = 0;
    var BINDING = 1;
    var QUOTED_STR = /^'.*'$|^".*"$/; // Parser and tokenizer for getting the type and value from a string.
    function parseType(string) {
        var type = PRIMITIVE;
        var value1 = string;
        if (QUOTED_STR.test(string)) value1 = string.slice(1, -1);
        else if (string === 'true') value1 = true;
        else if (string === 'false') value1 = false;
        else if (string === 'null') value1 = null;
        else if (string === 'undefined') value1 = undefined;
        else if (!isNaN(string)) value1 = Number(string);
        else type = KEYPATH;
        return {
            type: type,
            value: value1
        };
    } // Template parser and tokenizer for mustache-style text content bindings.
    // Parses the template and returns a set of tokens, separating static portions
    // of text from binding declarations.
    function parseTemplate(template, delimiters) {
        var tokens;
        var length = template.length;
        var index = 0;
        var lastIndex = 0;
        var open = delimiters[0], close = delimiters[1];
        while(lastIndex < length){
            index = template.indexOf(open, lastIndex);
            if (index < 0) {
                if (tokens) tokens.push({
                    type: TEXT,
                    value: template.slice(lastIndex)
                });
                break;
            } else {
                tokens || (tokens = []);
                if (index > 0 && lastIndex < index) tokens.push({
                    type: TEXT,
                    value: template.slice(lastIndex, index)
                });
                lastIndex = index + open.length;
                index = template.indexOf(close, lastIndex);
                if (index < 0) {
                    var substring = template.slice(lastIndex - close.length);
                    var lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === TEXT) lastToken.value += substring;
                    else tokens.push({
                        type: TEXT,
                        value: substring
                    });
                    break;
                }
                var value1 = template.slice(lastIndex, index).trim();
                tokens.push({
                    type: BINDING,
                    value: value1
                });
                lastIndex = index + close.length;
            }
        }
        return tokens;
    }
    var tinybind = {
        // Global binders.
        binders: {},
        // Global formatters.
        formatters: {},
        // Global sightglass adapters.
        adapters: {},
        // Default attribute prefix.
        _prefix: 'rv',
        _fullPrefix: 'rv-',
        get prefix () {
            return this._prefix;
        },
        set prefix (value){
            this._prefix = value;
            this._fullPrefix = value + '-';
        },
        parseTemplate: parseTemplate,
        parseType: parseType,
        // Default template delimiters.
        templateDelimiters: [
            '{',
            '}'
        ],
        // Default sightglass root interface.
        rootInterface: '.',
        // Preload data by default.
        preloadData: true,
        // Default event handler.
        handler: function handler(context, ev, binding) {
            this.call(context, ev, binding.view.models);
        },
        // Sets the attribute on the element. If no binder above is matched it will fall
        // back to using this binder.
        fallbackBinder: function fallbackBinder(el, value1) {
            if (value1 != null) el.setAttribute(this.type, value1);
            else el.removeAttribute(this.type);
        },
        // Merges an object literal into the corresponding global options.
        configure: function configure(options) {
            var _this = this;
            if (!options) return;
            Object.keys(options).forEach(function(option) {
                var value1 = options[option];
                if (EXTENSIONS.indexOf(option) > -1) Object.keys(value1).forEach(function(key) {
                    _this[option][key] = value1[key];
                });
                else _this[option] = value1;
            });
        }
    };
    // Check if a value is an object than can be observed.
    function isObject(obj) {
        return typeof obj === 'object' && obj !== null;
    } // Error thrower.
    function error(message) {
        throw new Error("[Observer] " + message);
    }
    var adapters;
    var interfaces;
    var rootInterface; // Constructs a new keypath observer and kicks things off.
    var Observer = /*#__PURE__*/ function() {
        Observer.updateOptions = function updateOptions(options) {
            adapters = options.adapters;
            interfaces = Object.keys(adapters);
            rootInterface = options.rootInterface;
        } // Tokenizes the provided keypath string into interface + path tokens for the
        ;
        Observer.tokenize = function tokenize(keypath, root) {
            var tokens = [];
            var current = {
                i: root,
                path: ''
            };
            var index;
            var chr;
            for(index = 0; index < keypath.length; index++){
                chr = keypath.charAt(index);
                if (!!~interfaces.indexOf(chr)) {
                    tokens.push(current);
                    current = {
                        i: chr,
                        path: ''
                    };
                } else current.path += chr;
            }
            tokens.push(current);
            return tokens;
        };
        function Observer(obj, keypath, callback) {
            this.keypath = keypath;
            this.callback = callback;
            this.objectPath = [];
            this.parse();
            this.obj = this.getRootObject(obj);
            if (isObject(this.target = this.realize())) this.set(true, this.key, this.target, this.callback);
        } // Parses the keypath using the interfaces defined on the view. Sets variables
        // for the tokenized keypath as well as the end key.
        var _proto = Observer.prototype;
        _proto.parse = function parse() {
            var path;
            var root;
            if (!interfaces.length) error('Must define at least one adapter interface.');
            if (!!~interfaces.indexOf(this.keypath[0])) {
                root = this.keypath[0];
                path = this.keypath.substr(1);
            } else {
                root = rootInterface;
                path = this.keypath;
            }
            this.tokens = Observer.tokenize(path, root);
            this.key = this.tokens.pop();
        } // Realizes the full keypath, attaching observers for every key and correcting
        ;
        _proto.realize = function realize() {
            var current = this.obj;
            var unreached = -1;
            var prev;
            var token;
            for(var index = 0; index < this.tokens.length; index++){
                token = this.tokens[index];
                if (isObject(current)) {
                    if (typeof this.objectPath[index] !== 'undefined') {
                        if (current !== (prev = this.objectPath[index])) {
                            this.set(false, token, prev, this);
                            this.set(true, token, current, this);
                            this.objectPath[index] = current;
                        }
                    } else {
                        this.set(true, token, current, this);
                        this.objectPath[index] = current;
                    }
                    current = this.get(token, current);
                } else {
                    if (unreached === -1) unreached = index;
                    if (prev = this.objectPath[index]) this.set(false, token, prev, this);
                }
            }
            if (unreached !== -1) this.objectPath.splice(unreached);
            return current;
        } // Updates the keypath. This is called when any intermediary key is changed.
        ;
        _proto.sync = function sync() {
            var next;
            var oldValue;
            var newValue;
            if ((next = this.realize()) !== this.target) {
                if (isObject(this.target)) this.set(false, this.key, this.target, this.callback);
                if (isObject(next)) this.set(true, this.key, next, this.callback);
                oldValue = this.value();
                this.target = next;
                newValue = this.value();
                if (newValue !== oldValue || newValue instanceof Function) this.callback.sync();
            } else if (next instanceof Array) this.callback.sync();
        } // Reads the current end value of the observed keypath. Returns undefined if
        ;
        _proto.value = function value1() {
            if (isObject(this.target)) return this.get(this.key, this.target);
        } // Sets the current end value of the observed keypath. Calling setValue when
        ;
        _proto.setValue = function setValue(value1) {
            if (isObject(this.target)) adapters[this.key.i].set(this.target, this.key.path, value1);
        } // Gets the provided key on an object.
        ;
        _proto.get = function get(key, obj) {
            return adapters[key.i].get(obj, key.path);
        } // Observes or unobserves a callback on the object using the provided key.
        ;
        _proto.set = function set(active, key, obj, callback) {
            var action = active ? 'observe' : 'unobserve';
            adapters[key.i][action](obj, key.path, callback);
        } // Unobserves the entire keypath.
        ;
        _proto.unobserve = function unobserve() {
            var obj;
            var token;
            for(var index = 0; index < this.tokens.length; index++){
                token = this.tokens[index];
                if (obj = this.objectPath[index]) this.set(false, token, obj, this);
            }
            if (isObject(this.target)) this.set(false, this.key, this.target, this.callback);
        } // traverse the scope chain to find the scope which has the root property
        ;
        _proto.getRootObject = function getRootObject(obj) {
            var rootProp;
            var current;
            if (!obj.$parent) return obj;
            if (this.tokens.length) rootProp = this.tokens[0].path;
            else rootProp = this.key.path;
            current = obj;
            while(current.$parent && current[rootProp] === undefined)current = current.$parent;
            return current;
        };
        return Observer;
    }();
    function getInputValue(el) {
        if (el.type === 'checkbox') return el.checked;
        else if (el.type === 'select-multiple') {
            var results = [];
            var option;
            for(var i = 0; i < el.options.length; i++){
                option = el.options[i];
                if (option.selected) results.push(option.value);
            }
            return results;
        } else return el.value;
    }
    var FORMATTER_ARGS = /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g;
    var FORMATTER_SPLIT = /\s+/; // A single binding between a model attribute and a DOM element.
    var Binding = /*#__PURE__*/ function() {
        // All information about the binding is passed into the constructor; the
        // containing view, the DOM node, the type of binding, the model object and the
        // keypath at which to listen for changes.
        function Binding(view, el, type, keypath, binder, arg, formatters) {
            this.view = view;
            this.el = el;
            this.type = type;
            this.keypath = keypath;
            this.binder = binder;
            this.arg = arg;
            this.formatters = formatters;
            this.formatterObservers = {};
            this.model = undefined;
        } // Observes the object keypath
        var _proto = Binding.prototype;
        _proto.observe = function observe(obj, keypath) {
            return new Observer(obj, keypath, this);
        };
        _proto.parseTarget = function parseTarget() {
            if (this.keypath) {
                var token = parseType(this.keypath);
                if (token.type === 0) this.value = token.value;
                else {
                    this.observer = this.observe(this.view.models, this.keypath);
                    this.model = this.observer.target;
                }
            } else this.value = undefined;
        };
        _proto.parseFormatterArguments = function parseFormatterArguments(args, formatterIndex) {
            var _this = this;
            return args.map(parseType).map(function(_ref, ai) {
                var type = _ref.type, value1 = _ref.value;
                if (type === 0) return value1;
                else {
                    if (!_this.formatterObservers[formatterIndex]) _this.formatterObservers[formatterIndex] = {};
                    var observer = _this.formatterObservers[formatterIndex][ai];
                    if (!observer) {
                        observer = _this.observe(_this.view.models, value1);
                        _this.formatterObservers[formatterIndex][ai] = observer;
                    }
                    return observer.value();
                }
            });
        } // Applies all the current formatters to the supplied value and returns the
        ;
        _proto.formattedValue = function formattedValue(value1) {
            var _this2 = this;
            return this.formatters.reduce(function(result, declaration, index) {
                var args = declaration.match(FORMATTER_ARGS);
                var id = args.shift();
                var formatter = _this2.view.options.formatters[id];
                var processedArgs = _this2.parseFormatterArguments(args, index);
                if (formatter && formatter.read instanceof Function) result = formatter.read.apply(formatter, [
                    result
                ].concat(processedArgs));
                else if (formatter instanceof Function) result = formatter.apply(void 0, [
                    result
                ].concat(processedArgs));
                return result;
            }, value1);
        } // Returns an event handler for the binding around the supplied function.
        ;
        _proto.eventHandler = function eventHandler(fn) {
            var binding = this;
            var handler = binding.view.options.handler;
            return function(ev) {
                handler.call(fn, this, ev, binding);
            };
        } // Sets the value for the binding. This Basically just runs the binding routine
        ;
        _proto.set = function set(value1) {
            if (value1 instanceof Function && !this.binder.function) value1 = this.formattedValue(value1.call(this.model));
            else value1 = this.formattedValue(value1);
            var routineFn = this.binder.routine || this.binder;
            if (routineFn instanceof Function) routineFn.call(this, this.el, value1);
        } // Syncs up the view binding with the model.
        ;
        _proto.sync = function sync() {
            if (this.observer) {
                this.model = this.observer.target;
                this.set(this.observer.value());
            } else this.set(this.value);
        } // Publishes the value currently set on the input element back to the model.
        ;
        _proto.publish = function publish() {
            var _this3 = this;
            if (this.observer) {
                var value1 = this.formatters.reduceRight(function(result, declaration, index) {
                    var args = declaration.split(FORMATTER_SPLIT);
                    var id = args.shift();
                    var formatter = _this3.view.options.formatters[id];
                    var processedArgs = _this3.parseFormatterArguments(args, index);
                    if (formatter && formatter.publish) result = formatter.publish.apply(formatter, [
                        result
                    ].concat(processedArgs));
                    return result;
                }, this.getValue(this.el));
                this.observer.setValue(value1);
            }
        } // Subscribes to the model for changes at the specified keypath. Bi-directional
        ;
        _proto.bind = function bind() {
            this.parseTarget();
            if (this.binder.hasOwnProperty('bind')) this.binder.bind.call(this, this.el);
            if (this.view.options.preloadData) this.sync();
        } // Unsubscribes from the model and the element.
        ;
        _proto.unbind = function unbind() {
            var _this4 = this;
            if (this.binder.unbind) this.binder.unbind.call(this, this.el);
            if (this.observer) this.observer.unobserve();
            Object.keys(this.formatterObservers).forEach(function(fi) {
                var args = _this4.formatterObservers[fi];
                Object.keys(args).forEach(function(ai) {
                    args[ai].unobserve();
                });
            });
            this.formatterObservers = {};
        } // Updates the binding's model from what is currently set on the view. Unbinds
        ;
        _proto.update = function update(models) {
            if (models === void 0) models = {};
            if (this.observer) this.model = this.observer.target;
            if (this.binder.update) this.binder.update.call(this, models);
        } // Returns elements value
        ;
        _proto.getValue = function getValue(el) {
            if (this.binder && this.binder.getValue) return this.binder.getValue.call(this, el);
            else return getInputValue(el);
        };
        return Binding;
    }();
    var textBinder = {
        routine: function routine(node, value1) {
            node.data = value1 != null ? value1 : '';
        }
    };
    var DECLARATION_SPLIT = /((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g;
    var parseNode = function parseNode(view, node) {
        var block = false;
        if (node.nodeType === 3) {
            var tokens = parseTemplate(node.data, tinybind.templateDelimiters);
            if (tokens) {
                for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    var text = document.createTextNode(token.value);
                    node.parentNode.insertBefore(text, node);
                    if (token.type === 1) view.buildBinding(text, null, token.value, textBinder, null);
                }
                node.parentNode.removeChild(node);
            }
            block = true;
        } else if (node.nodeType === 1) block = view.traverse(node);
        if (!block) for(var _i = 0; _i < node.childNodes.length; _i++)parseNode(view, node.childNodes[_i]);
    };
    var bindingComparator = function bindingComparator(a, b) {
        var aPriority = a.binder ? a.binder.priority || 0 : 0;
        var bPriority = b.binder ? b.binder.priority || 0 : 0;
        return bPriority - aPriority;
    };
    var trimStr = function trimStr(str) {
        return str.trim();
    }; // A collection of bindings built from a set of parent nodes.
    var View = /*#__PURE__*/ function() {
        // The DOM elements and the model objects for binding are passed into the
        // constructor along with any local options that should be used throughout the
        // context of the view and it's bindings.
        function View(els, models, options) {
            if (els.jquery || els instanceof Array) this.els = els;
            else this.els = [
                els
            ];
            this.models = models;
            this.options = options;
            this.build();
        }
        var _proto = View.prototype;
        _proto.buildBinding = function buildBinding(node, type, declaration, binder, arg) {
            var pipes = declaration.match(DECLARATION_SPLIT).map(trimStr);
            var keypath = pipes.shift();
            this.bindings.push(new Binding(this, node, type, keypath, binder, arg, pipes));
        } // Parses the DOM tree and builds `Binding` instances for every matched
        ;
        _proto.build = function build() {
            this.bindings = [];
            var elements = this.els, i, len;
            for(i = 0, len = elements.length; i < len; i++)parseNode(this, elements[i]);
            this.bindings.sort(bindingComparator);
        };
        _proto.traverse = function traverse(node) {
            var bindingPrefix = tinybind._fullPrefix;
            var block = node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE';
            var attributes = node.attributes;
            var bindInfos = [];
            var starBinders = this.options.starBinders;
            var type, binder, identifier, arg;
            for(var i = 0, len = attributes.length; i < len; i++){
                var attribute = attributes[i];
                if (attribute.name.indexOf(bindingPrefix) === 0) {
                    type = attribute.name.slice(bindingPrefix.length);
                    binder = this.options.binders[type];
                    arg = undefined;
                    if (!binder) for(var k = 0; k < starBinders.length; k++){
                        identifier = starBinders[k];
                        if (type.slice(0, identifier.length - 1) === identifier.slice(0, -1)) {
                            binder = this.options.binders[identifier];
                            arg = type.slice(identifier.length - 1);
                            break;
                        }
                    }
                    if (!binder) binder = tinybind.fallbackBinder;
                    if (binder.block) {
                        this.buildBinding(node, type, attribute.value, binder, arg);
                        node.removeAttribute(attribute.name);
                        return true;
                    }
                    bindInfos.push({
                        attr: attribute,
                        binder: binder,
                        type: type,
                        arg: arg
                    });
                }
            }
            for(var _i2 = 0; _i2 < bindInfos.length; _i2++){
                var bindInfo = bindInfos[_i2];
                this.buildBinding(node, bindInfo.type, bindInfo.attr.value, bindInfo.binder, bindInfo.arg);
                node.removeAttribute(bindInfo.attr.name);
            }
            return block;
        } // Binds all of the current bindings for this view.
        ;
        _proto.bind = function bind() {
            this.bindings.forEach(function(binding) {
                binding.bind();
            });
        } // Unbinds all of the current bindings for this view.
        ;
        _proto.unbind = function unbind() {
            this.bindings.forEach(function(binding) {
                binding.unbind();
            });
        } // Syncs up the view with the model by running the routines on all bindings.
        ;
        _proto.sync = function sync() {
            this.bindings.forEach(function(binding) {
                binding.sync();
            });
        } // Publishes the input values from the view back to the model (reverse sync).
        ;
        _proto.publish = function publish() {
            this.bindings.forEach(function(binding) {
                if (binding.binder && binding.binder.publishes) binding.publish();
            });
        } // Updates the view's models along with any affected bindings.
        ;
        _proto.update = function update(models) {
            var _this = this;
            if (models === void 0) models = {};
            Object.keys(models).forEach(function(key) {
                _this.models[key] = models[key];
            });
            this.bindings.forEach(function(binding) {
                if (binding.update) binding.update(models);
            });
        };
        return View;
    }();
    // The default `.` adapter that comes with tinybind.js. Allows subscribing to
    // properties on plain objects, implemented in ES5 natives using
    // `Object.defineProperty`.
    var ARRAY_METHODS = [
        'push',
        'pop',
        'shift',
        'unshift',
        'sort',
        'reverse',
        'splice'
    ];
    var adapter = {
        counter: 0,
        weakmap: {},
        weakReference: function weakReference(obj) {
            if (!obj.hasOwnProperty('__rv')) {
                var id = this.counter++;
                Object.defineProperty(obj, '__rv', {
                    value: id
                });
            }
            if (!this.weakmap[obj.__rv]) this.weakmap[obj.__rv] = {
                callbacks: {}
            };
            return this.weakmap[obj.__rv];
        },
        cleanupWeakReference: function cleanupWeakReference(data, refId) {
            if (!Object.keys(data.callbacks).length) {
                if (!(data.pointers && Object.keys(data.pointers).length)) delete this.weakmap[refId];
            }
        },
        stubFunction: function stubFunction(obj, fn) {
            var original = obj[fn];
            var data = this.weakReference(obj);
            var weakmap = this.weakmap;
            obj[fn] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var response = original.apply(obj, args);
                Object.keys(data.pointers).forEach(function(refId) {
                    var k = data.pointers[refId];
                    if (weakmap[refId]) {
                        if (weakmap[refId].callbacks[k] instanceof Array) weakmap[refId].callbacks[k].forEach(function(callback) {
                            callback.sync();
                        });
                    }
                });
                return response;
            };
        },
        observeArray: function observeArray(value1, refId, keypath) {
            var _this = this;
            if (value1 instanceof Array) {
                var data = this.weakReference(value1);
                if (!data.pointers) {
                    data.pointers = {};
                    ARRAY_METHODS.forEach(function(fn) {
                        _this.stubFunction(value1, fn);
                    });
                }
                if (!data.pointers[refId]) data.pointers[refId] = [];
                if (data.pointers[refId].indexOf(keypath) === -1) data.pointers[refId].push(keypath);
            }
        },
        unobserveArray: function unobserveArray(value1, refId, keypath) {
            if (value1 instanceof Array && value1.__rv != null) {
                var data = this.weakmap[value1.__rv];
                if (data) {
                    var pointers = data.pointers[refId];
                    if (pointers) {
                        var idx = pointers.indexOf(keypath);
                        if (idx > -1) pointers.splice(idx, 1);
                        if (!pointers.length) delete data.pointers[refId];
                        this.cleanupWeakReference(data, value1.__rv);
                    }
                }
            }
        },
        observe: function observe(obj, keypath, callback) {
            var _this2 = this;
            var value1;
            var callbacks = this.weakReference(obj).callbacks;
            if (!callbacks[keypath]) {
                callbacks[keypath] = [];
                var desc = Object.getOwnPropertyDescriptor(obj, keypath);
                if (!desc || !(desc.get || desc.set || !desc.configurable)) {
                    value1 = obj[keypath];
                    Object.defineProperty(obj, keypath, {
                        enumerable: true,
                        get: function get() {
                            return value1;
                        },
                        set: function set(newValue) {
                            if (newValue !== value1) {
                                _this2.unobserveArray(value1, obj.__rv, keypath);
                                value1 = newValue;
                                var data = _this2.weakmap[obj.__rv];
                                if (data) {
                                    var _callbacks = data.callbacks[keypath];
                                    if (_callbacks) _callbacks.forEach(function(cb) {
                                        cb.sync();
                                    });
                                    _this2.observeArray(newValue, obj.__rv, keypath);
                                }
                            }
                        }
                    });
                }
            }
            if (callbacks[keypath].indexOf(callback) === -1) callbacks[keypath].push(callback);
            this.observeArray(obj[keypath], obj.__rv, keypath);
        },
        unobserve: function unobserve(obj, keypath, callback) {
            var data = this.weakmap[obj.__rv];
            if (data) {
                var callbacks = data.callbacks[keypath];
                if (callbacks) {
                    var idx = callbacks.indexOf(callback);
                    if (idx > -1) {
                        callbacks.splice(idx, 1);
                        if (!callbacks.length) {
                            delete data.callbacks[keypath];
                            this.unobserveArray(obj[keypath], obj.__rv, keypath);
                        }
                    }
                    this.cleanupWeakReference(data, obj.__rv);
                }
            }
        },
        get: function get(obj, keypath) {
            return obj[keypath];
        },
        set: function set(obj, keypath, value1) {
            obj[keypath] = value1;
        }
    };
    var getString = function getString(value1) {
        return value1 != null ? value1.toString() : undefined;
    };
    var times = function times(n, cb) {
        for(var i = 0; i < n; i++)cb();
    };
    function createView(binding, data, anchorEl) {
        var template = binding.el.cloneNode(true);
        var view = new View(template, data, binding.view.options);
        view.bind();
        binding.marker.parentNode.insertBefore(template, anchorEl);
        return view;
    }
    var binders = {
        // Binds an event handler on the element.
        'on-*': {
            function: true,
            priority: 1000,
            unbind: function unbind(el) {
                if (this.handler) el.removeEventListener(this.arg, this.handler);
            },
            routine: function routine(el, value1) {
                if (this.handler) el.removeEventListener(this.arg, this.handler);
                this.handler = this.eventHandler(value1);
                el.addEventListener(this.arg, this.handler);
            }
        },
        // Appends bound instances of the element in place for each item in the array.
        'each-*': {
            block: true,
            priority: 4000,
            bind: function bind(el) {
                if (!this.marker) {
                    this.marker = document.createComment(" tinybind: " + this.type + " ");
                    this.iterated = [];
                    el.parentNode.insertBefore(this.marker, el);
                    el.parentNode.removeChild(el);
                } else this.iterated.forEach(function(view) {
                    view.bind();
                });
            },
            unbind: function unbind(el) {
                if (this.iterated) this.iterated.forEach(function(view) {
                    view.unbind();
                });
            },
            routine: function routine(el, collection) {
                var _this = this;
                var modelName = this.arg;
                collection = collection || [];
                var indexProp = el.getAttribute('index-property') || '$index';
                collection.forEach(function(model, index) {
                    var data = {
                        $parent: _this.view.models
                    };
                    data[indexProp] = index;
                    data[modelName] = model;
                    var view = _this.iterated[index];
                    if (!view) {
                        var previous = _this.marker;
                        if (_this.iterated.length) previous = _this.iterated[_this.iterated.length - 1].els[0];
                        view = createView(_this, data, previous.nextSibling);
                        _this.iterated.push(view);
                    } else if (view.models[modelName] !== model) {
                        // search for a view that matches the model
                        var matchIndex, nextView;
                        for(var nextIndex = index + 1; nextIndex < _this.iterated.length; nextIndex++){
                            nextView = _this.iterated[nextIndex];
                            if (nextView.models[modelName] === model) {
                                matchIndex = nextIndex;
                                break;
                            }
                        }
                        if (matchIndex !== undefined) {
                            // model is in other position
                            // todo: consider avoiding the splice here by setting a flag
                            // profile performance before implementing such change
                            _this.iterated.splice(matchIndex, 1);
                            _this.marker.parentNode.insertBefore(nextView.els[0], view.els[0]);
                            nextView.models[indexProp] = index;
                        } else //new model
                        nextView = createView(_this, data, view.els[0]);
                        _this.iterated.splice(index, 0, nextView);
                    } else view.models[indexProp] = index;
                });
                if (this.iterated.length > collection.length) times(this.iterated.length - collection.length, function() {
                    var view = _this.iterated.pop();
                    view.unbind();
                    _this.marker.parentNode.removeChild(view.els[0]);
                });
                if (el.nodeName === 'OPTION') this.view.bindings.forEach(function(binding) {
                    if (binding.el === _this.marker.parentNode && binding.type === 'value') binding.sync();
                });
            },
            update: function update(models) {
                var _this2 = this;
                var data = {}; //todo: add test and fix if necessary
                Object.keys(models).forEach(function(key) {
                    if (key !== _this2.arg) data[key] = models[key];
                });
                this.iterated.forEach(function(view) {
                    view.update(data);
                });
            }
        },
        // Adds or removes the class from the element when value is true or false.
        'class-*': function _class(el, value1) {
            var elClass = " " + el.className + " ";
            if (!value1 === elClass.indexOf(" " + this.arg + " ") > -1) {
                if (value1) el.className = el.className + " " + this.arg;
                else el.className = elClass.replace(" " + this.arg + " ", ' ').trim();
            }
        },
        // Sets the element's text value.
        text: function text(el, value1) {
            el.textContent = value1 != null ? value1 : '';
        },
        // Sets the element's HTML content.
        html: function html(el, value1) {
            el.innerHTML = value1 != null ? value1 : '';
        },
        // Shows the element when value is true.
        show: function show(el, value1) {
            el.style.display = value1 ? '' : 'none';
        },
        // Hides the element when value is true (negated version of `show` binder).
        hide: function hide(el, value1) {
            el.style.display = value1 ? 'none' : '';
        },
        // Enables the element when value is true.
        enabled: function enabled(el, value1) {
            el.disabled = !value1;
        },
        // Disables the element when value is true (negated version of `enabled` binder).
        disabled: function disabled(el, value1) {
            el.disabled = !!value1;
        },
        // Checks a checkbox or radio input when the value is true. Also sets the model
        // property when the input is checked or unchecked (two-way binder).
        checked: {
            publishes: true,
            priority: 2000,
            bind: function bind(el) {
                var self = this;
                if (!this.callback) this.callback = function() {
                    self.publish();
                };
                el.addEventListener('change', this.callback);
            },
            unbind: function unbind(el) {
                el.removeEventListener('change', this.callback);
            },
            routine: function routine(el, value1) {
                if (el.type === 'radio') el.checked = getString(el.value) === getString(value1);
                else el.checked = !!value1;
            }
        },
        // Sets the element's value. Also sets the model property when the input changes
        // (two-way binder).
        value: {
            publishes: true,
            priority: 3000,
            bind: function bind(el) {
                this.isRadio = el.tagName === 'INPUT' && el.type === 'radio';
                if (!this.isRadio) {
                    this.event = el.getAttribute('event-name') || (el.tagName === 'SELECT' ? 'change' : 'input');
                    var self = this;
                    if (!this.callback) this.callback = function() {
                        self.publish();
                    };
                    el.addEventListener(this.event, this.callback);
                }
            },
            unbind: function unbind(el) {
                if (!this.isRadio) el.removeEventListener(this.event, this.callback);
            },
            routine: function routine(el, value1) {
                if (this.isRadio) el.setAttribute('value', value1);
                else {
                    if (el.type === 'select-multiple') {
                        if (value1 instanceof Array) for(var i = 0; i < el.length; i++){
                            var option = el[i];
                            option.selected = value1.indexOf(option.value) > -1;
                        }
                    } else if (getString(value1) !== getString(el.value)) el.value = value1 != null ? value1 : '';
                }
            }
        },
        // Inserts and binds the element and it's child nodes into the DOM when true.
        if: {
            block: true,
            priority: 4000,
            bind: function bind(el) {
                if (!this.marker) {
                    this.marker = document.createComment(' tinybind: ' + this.type + ' ' + this.keypath + ' ');
                    this.attached = false;
                    el.parentNode.insertBefore(this.marker, el);
                    el.parentNode.removeChild(el);
                } else if (this.bound === false && this.nested) this.nested.bind();
                this.bound = true;
            },
            unbind: function unbind() {
                if (this.nested) {
                    this.nested.unbind();
                    this.bound = false;
                }
            },
            routine: function routine(el, value1) {
                if (!!value1 !== this.attached) {
                    if (value1) {
                        if (!this.nested) {
                            this.nested = new View(el, this.view.models, this.view.options);
                            this.nested.bind();
                        }
                        this.marker.parentNode.insertBefore(el, this.marker.nextSibling);
                        this.attached = true;
                    } else {
                        el.parentNode.removeChild(el);
                        this.attached = false;
                    }
                }
            },
            update: function update(models) {
                if (this.nested) this.nested.update(models);
            }
        }
    };
    var formatters = {
        watch: function watch(value1) {
            return value1;
        },
        not: function not(value1) {
            return !value1;
        },
        negate: function negate(value1) {
            return !value1;
        }
    };
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function _wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        _wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return _construct(Class, arguments, _getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return _setPrototypeOf(Wrapper, Class);
        };
        return _wrapNativeSuper(Class);
    }
    var Component = /*#__PURE__*/ function(_HTMLElement) {
        _inheritsLoose(Component, _HTMLElement);
        function Component() {
            return _HTMLElement.apply(this, arguments) || this;
        }
        var _proto = Component.prototype;
        _proto.connectedCallback = function connectedCallback() {
            var nodes = this.constructor.__templateEl.content.cloneNode(true);
            this.__tinybindView = tinybind.bind(nodes, this);
            while(this.firstChild)this.removeChild(this.firstChild);
            this.appendChild(nodes);
        };
        _proto.disconnectedCallback = function disconnectedCallback() {
            this.__tinybindView.unbind();
        };
        _proto.attributeChangedCallback = function attributeChangedCallback(name, old, value1) {
            if (old !== value1) {
                var propName = this.constructor.__propAttributeMap[name];
                this[propName] = value1;
            }
        };
        _createClass(Component, null, [
            {
                key: "observedAttributes",
                get: function get() {
                    var template = this.template;
                    if (!template) throw new Error("No template declared for " + this.name);
                    this.__templateEl = document.createElement('template');
                    this.__templateEl.innerHTML = template;
                    var propAttributeMap = this.__propAttributeMap = {};
                    var attributes = [];
                    var properties = this.properties;
                    if (properties) Object.keys(properties).forEach(function(propName) {
                        var propConfig = properties[propName];
                        var attrName = typeof propConfig === 'string' ? propConfig : propName;
                        propAttributeMap[attrName] = propName;
                        attributes.push(attrName);
                    });
                    return attributes;
                }
            }
        ]);
        return Component;
    }(_wrapNativeSuper(HTMLElement));
    tinybind.binders = binders;
    tinybind.formatters = formatters;
    tinybind.adapters['.'] = adapter;
    tinybind.Component = Component; // Binds some data to a template / element. Returns a tinybind.View instance.
    tinybind.bind = function(el, models, options) {
        var viewOptions = {};
        models = models || {};
        options = options || {};
        EXTENSIONS.forEach(function(extensionType) {
            viewOptions[extensionType] = Object.create(null);
            if (options[extensionType]) Object.keys(options[extensionType]).forEach(function(key) {
                viewOptions[extensionType][key] = options[extensionType][key];
            });
            Object.keys(tinybind[extensionType]).forEach(function(key) {
                if (!viewOptions[extensionType][key]) viewOptions[extensionType][key] = tinybind[extensionType][key];
            });
        });
        OPTIONS.forEach(function(option) {
            var value1 = options[option];
            viewOptions[option] = value1 != null ? value1 : tinybind[option];
        });
        viewOptions.starBinders = Object.keys(viewOptions.binders).filter(function(key) {
            return key.indexOf('*') > 0;
        });
        Observer.updateOptions(viewOptions);
        var view = new View(el, models, viewOptions);
        view.bind();
        return view;
    };
    return tinybind;
});



/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */ function $5fbeb0576f6aeb94$var$get(element) {
    return getComputedStyle(element);
}
function $5fbeb0576f6aeb94$var$set(element, obj) {
    for(var key in obj){
        var val = obj[key];
        if (typeof val === 'number') val = val + "px";
        element.style[key] = val;
    }
    return element;
}
function $5fbeb0576f6aeb94$var$div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
}
var $5fbeb0576f6aeb94$var$elMatches = typeof Element !== 'undefined' && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function $5fbeb0576f6aeb94$var$matches(element, query) {
    if (!$5fbeb0576f6aeb94$var$elMatches) throw new Error('No element matching method supported');
    return $5fbeb0576f6aeb94$var$elMatches.call(element, query);
}
function $5fbeb0576f6aeb94$var$remove(element) {
    if (element.remove) element.remove();
    else if (element.parentNode) element.parentNode.removeChild(element);
}
function $5fbeb0576f6aeb94$var$queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function(child) {
        return $5fbeb0576f6aeb94$var$matches(child, selector);
    });
}
var $5fbeb0576f6aeb94$var$cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
        thumb: function(x) {
            return "ps__thumb-" + x;
        },
        rail: function(x) {
            return "ps__rail-" + x;
        },
        consuming: 'ps__child--consume'
    },
    state: {
        focus: 'ps--focus',
        clicking: 'ps--clicking',
        active: function(x) {
            return "ps--active-" + x;
        },
        scrolling: function(x) {
            return "ps--scrolling-" + x;
        }
    }
};
/*
 * Helper methods
 */ var $5fbeb0576f6aeb94$var$scrollingClassTimeout = {
    x: null,
    y: null
};
function $5fbeb0576f6aeb94$var$addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = $5fbeb0576f6aeb94$var$cls.state.scrolling(x);
    if (classList.contains(className)) clearTimeout($5fbeb0576f6aeb94$var$scrollingClassTimeout[x]);
    else classList.add(className);
}
function $5fbeb0576f6aeb94$var$removeScrollingClass(i, x) {
    $5fbeb0576f6aeb94$var$scrollingClassTimeout[x] = setTimeout(function() {
        return i.isAlive && i.element.classList.remove($5fbeb0576f6aeb94$var$cls.state.scrolling(x));
    }, i.settings.scrollingThreshold);
}
function $5fbeb0576f6aeb94$var$setScrollingClassInstantly(i, x) {
    $5fbeb0576f6aeb94$var$addScrollingClass(i, x);
    $5fbeb0576f6aeb94$var$removeScrollingClass(i, x);
}
var $5fbeb0576f6aeb94$var$EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
};
var $5fbeb0576f6aeb94$var$prototypeAccessors = {
    isEmpty: {
        configurable: true
    }
};
$5fbeb0576f6aeb94$var$EventElement.prototype.bind = function bind(eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') this.handlers[eventName] = [];
    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
};
$5fbeb0576f6aeb94$var$EventElement.prototype.unbind = function unbind(eventName, target) {
    var this$1 = this;
    this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
        if (target && handler !== target) return true;
        this$1.element.removeEventListener(eventName, handler, false);
        return false;
    });
};
$5fbeb0576f6aeb94$var$EventElement.prototype.unbindAll = function unbindAll() {
    for(var name in this.handlers)this.unbind(name);
};
$5fbeb0576f6aeb94$var$prototypeAccessors.isEmpty.get = function() {
    var this$1 = this;
    return Object.keys(this.handlers).every(function(key) {
        return this$1.handlers[key].length === 0;
    });
};
Object.defineProperties($5fbeb0576f6aeb94$var$EventElement.prototype, $5fbeb0576f6aeb94$var$prototypeAccessors);
var $5fbeb0576f6aeb94$var$EventManager = function EventManager() {
    this.eventElements = [];
};
$5fbeb0576f6aeb94$var$EventManager.prototype.eventElement = function eventElement(element) {
    var ee = this.eventElements.filter(function(ee) {
        return ee.element === element;
    })[0];
    if (!ee) {
        ee = new $5fbeb0576f6aeb94$var$EventElement(element);
        this.eventElements.push(ee);
    }
    return ee;
};
$5fbeb0576f6aeb94$var$EventManager.prototype.bind = function bind(element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
};
$5fbeb0576f6aeb94$var$EventManager.prototype.unbind = function unbind(element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);
    if (ee.isEmpty) // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
};
$5fbeb0576f6aeb94$var$EventManager.prototype.unbindAll = function unbindAll() {
    this.eventElements.forEach(function(e) {
        return e.unbindAll();
    });
    this.eventElements = [];
};
$5fbeb0576f6aeb94$var$EventManager.prototype.once = function once(element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function(evt) {
        ee.unbind(eventName, onceHandler);
        handler(evt);
    };
    ee.bind(eventName, onceHandler);
};
function $5fbeb0576f6aeb94$var$createEvent(name) {
    if (typeof window.CustomEvent === 'function') return new CustomEvent(name);
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
}
function $5fbeb0576f6aeb94$var$processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var fields;
    if (axis === 'top') fields = [
        'contentHeight',
        'containerHeight',
        'scrollTop',
        'y',
        'up',
        'down'
    ];
    else if (axis === 'left') fields = [
        'contentWidth',
        'containerWidth',
        'scrollLeft',
        'x',
        'left',
        'right'
    ];
    else throw new Error('A proper axis should be provided');
    $5fbeb0576f6aeb94$var$processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function $5fbeb0576f6aeb94$var$processScrollDiff$1(i, diff, ref, useScrollingClass, forceFireReachEvent) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var element = i.element;
    // reset reach
    i.reach[y] = null;
    // 1 for subpixel rounding
    if (element[scrollTop] < 1) i.reach[y] = 'start';
    // 1 for subpixel rounding
    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) i.reach[y] = 'end';
    if (diff) {
        element.dispatchEvent($5fbeb0576f6aeb94$var$createEvent("ps-scroll-" + y));
        if (diff < 0) element.dispatchEvent($5fbeb0576f6aeb94$var$createEvent("ps-scroll-" + up));
        else if (diff > 0) element.dispatchEvent($5fbeb0576f6aeb94$var$createEvent("ps-scroll-" + down));
        if (useScrollingClass) $5fbeb0576f6aeb94$var$setScrollingClassInstantly(i, y);
    }
    if (i.reach[y] && (diff || forceFireReachEvent)) element.dispatchEvent($5fbeb0576f6aeb94$var$createEvent("ps-" + y + "-reach-" + i.reach[y]));
}
function $5fbeb0576f6aeb94$var$toInt(x) {
    return parseInt(x, 10) || 0;
}
function $5fbeb0576f6aeb94$var$isEditable(el) {
    return $5fbeb0576f6aeb94$var$matches(el, 'input,[contenteditable]') || $5fbeb0576f6aeb94$var$matches(el, 'select,[contenteditable]') || $5fbeb0576f6aeb94$var$matches(el, 'textarea,[contenteditable]') || $5fbeb0576f6aeb94$var$matches(el, 'button,[contenteditable]');
}
function $5fbeb0576f6aeb94$var$outerWidth(element) {
    var styles = $5fbeb0576f6aeb94$var$get(element);
    return $5fbeb0576f6aeb94$var$toInt(styles.width) + $5fbeb0576f6aeb94$var$toInt(styles.paddingLeft) + $5fbeb0576f6aeb94$var$toInt(styles.paddingRight) + $5fbeb0576f6aeb94$var$toInt(styles.borderLeftWidth) + $5fbeb0576f6aeb94$var$toInt(styles.borderRightWidth);
}
var $5fbeb0576f6aeb94$var$env = {
    isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
    supportsTouch: typeof window !== 'undefined' && ('ontouchstart' in window || 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== 'undefined' && /Chrome/i.test(navigator && navigator.userAgent)
};
/* eslint-disable no-lonely-if */ function $5fbeb0576f6aeb94$var$updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();
    i.containerWidth = Math.floor(rect.width);
    i.containerHeight = Math.floor(rect.height);
    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;
    if (!element.contains(i.scrollbarXRail)) {
        // clean up and append
        $5fbeb0576f6aeb94$var$queryChildren(element, $5fbeb0576f6aeb94$var$cls.element.rail('x')).forEach(function(el) {
            return $5fbeb0576f6aeb94$var$remove(el);
        });
        element.appendChild(i.scrollbarXRail);
    }
    if (!element.contains(i.scrollbarYRail)) {
        // clean up and append
        $5fbeb0576f6aeb94$var$queryChildren(element, $5fbeb0576f6aeb94$var$cls.element.rail('y')).forEach(function(el) {
            return $5fbeb0576f6aeb94$var$remove(el);
        });
        element.appendChild(i.scrollbarYRail);
    }
    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
        i.scrollbarXActive = true;
        i.railXWidth = i.containerWidth - i.railXMarginWidth;
        i.railXRatio = i.containerWidth / i.railXWidth;
        i.scrollbarXWidth = $5fbeb0576f6aeb94$var$getThumbSize(i, $5fbeb0576f6aeb94$var$toInt(i.railXWidth * i.containerWidth / i.contentWidth));
        i.scrollbarXLeft = $5fbeb0576f6aeb94$var$toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else i.scrollbarXActive = false;
    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
        i.scrollbarYActive = true;
        i.railYHeight = i.containerHeight - i.railYMarginHeight;
        i.railYRatio = i.containerHeight / i.railYHeight;
        i.scrollbarYHeight = $5fbeb0576f6aeb94$var$getThumbSize(i, $5fbeb0576f6aeb94$var$toInt(i.railYHeight * i.containerHeight / i.contentHeight));
        i.scrollbarYTop = $5fbeb0576f6aeb94$var$toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else i.scrollbarYActive = false;
    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    $5fbeb0576f6aeb94$var$updateCss(element, i);
    if (i.scrollbarXActive) element.classList.add($5fbeb0576f6aeb94$var$cls.state.active('x'));
    else {
        element.classList.remove($5fbeb0576f6aeb94$var$cls.state.active('x'));
        i.scrollbarXWidth = 0;
        i.scrollbarXLeft = 0;
        element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) element.classList.add($5fbeb0576f6aeb94$var$cls.state.active('y'));
    else {
        element.classList.remove($5fbeb0576f6aeb94$var$cls.state.active('y'));
        i.scrollbarYHeight = 0;
        i.scrollbarYTop = 0;
        element.scrollTop = 0;
    }
}
function $5fbeb0576f6aeb94$var$getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    if (i.settings.maxScrollbarLength) thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    return thumbSize;
}
function $5fbeb0576f6aeb94$var$updateCss(element, i) {
    var xRailOffset = {
        width: i.railXWidth
    };
    var roundedScrollTop = Math.floor(element.scrollTop);
    if (i.isRtl) xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
    else xRailOffset.left = element.scrollLeft;
    if (i.isScrollbarXUsingBottom) xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    else xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    $5fbeb0576f6aeb94$var$set(i.scrollbarXRail, xRailOffset);
    var yRailOffset = {
        top: roundedScrollTop,
        height: i.railYHeight
    };
    if (i.isScrollbarYUsingRight) {
        if (i.isRtl) yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
        else yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    } else if (i.isRtl) yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    else yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    $5fbeb0576f6aeb94$var$set(i.scrollbarYRail, yRailOffset);
    $5fbeb0576f6aeb94$var$set(i.scrollbarX, {
        left: i.scrollbarXLeft,
        width: i.scrollbarXWidth - i.railBorderXWidth
    });
    $5fbeb0576f6aeb94$var$set(i.scrollbarY, {
        top: i.scrollbarYTop,
        height: i.scrollbarYHeight - i.railBorderYWidth
    });
}
/* eslint-disable */ function $5fbeb0576f6aeb94$var$clickRail(i) {
    // const element = i.element;
    i.event.bind(i.scrollbarY, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarYRail, 'mousedown', function(e) {
        var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
        var direction = positionTop > i.scrollbarYTop ? 1 : -1;
        i.element.scrollTop += direction * i.containerHeight;
        $5fbeb0576f6aeb94$var$updateGeometry(i);
        e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarXRail, 'mousedown', function(e) {
        var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
        var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
        i.element.scrollLeft += direction * i.containerWidth;
        $5fbeb0576f6aeb94$var$updateGeometry(i);
        e.stopPropagation();
    });
}
var $5fbeb0576f6aeb94$var$activeSlider = null; // Variable to track the currently active slider
function $5fbeb0576f6aeb94$var$setupScrollHandlers(i) {
    $5fbeb0576f6aeb94$var$bindMouseScrollHandler(i, [
        'containerHeight',
        'contentHeight',
        'pageY',
        'railYHeight',
        'scrollbarY',
        'scrollbarYHeight',
        'scrollTop',
        'y',
        'scrollbarYRail'
    ]);
    $5fbeb0576f6aeb94$var$bindMouseScrollHandler(i, [
        'containerWidth',
        'contentWidth',
        'pageX',
        'railXWidth',
        'scrollbarX',
        'scrollbarXWidth',
        'scrollLeft',
        'x',
        'scrollbarXRail'
    ]);
}
function $5fbeb0576f6aeb94$var$bindMouseScrollHandler(i, ref) {
    var containerDimension = ref[0];
    var contentDimension = ref[1];
    var pageAxis = ref[2];
    var railDimension = ref[3];
    var scrollbarAxis = ref[4];
    var scrollbarDimension = ref[5];
    var scrollAxis = ref[6];
    var axis = ref[7];
    var scrollbarRail = ref[8];
    var element = i.element;
    var startingScrollPosition = null;
    var startingMousePagePosition = null;
    var scrollBy = null;
    function moveHandler(e) {
        if (e.touches && e.touches[0]) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
        // Only move if the active slider is the one we started with
        if ($5fbeb0576f6aeb94$var$activeSlider === scrollbarAxis) {
            element[scrollAxis] = startingScrollPosition + scrollBy * (e[pageAxis] - startingMousePagePosition);
            $5fbeb0576f6aeb94$var$addScrollingClass(i, axis);
            $5fbeb0576f6aeb94$var$updateGeometry(i);
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function endHandler() {
        $5fbeb0576f6aeb94$var$removeScrollingClass(i, axis);
        i[scrollbarRail].classList.remove($5fbeb0576f6aeb94$var$cls.state.clicking);
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', endHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', endHandler);
        $5fbeb0576f6aeb94$var$activeSlider = null; // Reset active slider when interaction ends
    }
    function bindMoves(e) {
        if ($5fbeb0576f6aeb94$var$activeSlider === null) {
            // Only bind if no slider is currently active
            $5fbeb0576f6aeb94$var$activeSlider = scrollbarAxis; // Set current slider as active
            startingScrollPosition = element[scrollAxis];
            if (e.touches) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
            startingMousePagePosition = e[pageAxis];
            scrollBy = (i[contentDimension] - i[containerDimension]) / (i[railDimension] - i[scrollbarDimension]);
            if (!e.touches) {
                document.addEventListener('mousemove', moveHandler);
                document.addEventListener('mouseup', endHandler);
            } else {
                document.addEventListener('touchmove', moveHandler, {
                    passive: false
                });
                document.addEventListener('touchend', endHandler);
            }
            i[scrollbarRail].classList.add($5fbeb0576f6aeb94$var$cls.state.clicking);
        }
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
    }
    i[scrollbarAxis].addEventListener('mousedown', bindMoves);
    i[scrollbarAxis].addEventListener('touchstart', bindMoves);
}
/* eslint-disable */ function $5fbeb0576f6aeb94$var$keyboard(i) {
    var element = i.element;
    var elementHovered = function() {
        return $5fbeb0576f6aeb94$var$matches(element, ':hover');
    };
    var scrollbarFocused = function() {
        return $5fbeb0576f6aeb94$var$matches(i.scrollbarX, ':focus') || $5fbeb0576f6aeb94$var$matches(i.scrollbarY, ':focus');
    };
    function shouldPreventDefault(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        if (deltaX === 0) {
            if (!i.scrollbarYActive) return false;
            if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) return !i.settings.wheelPropagation;
        }
        var scrollLeft = element.scrollLeft;
        if (deltaY === 0) {
            if (!i.scrollbarXActive) return false;
            if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) return !i.settings.wheelPropagation;
        }
        return true;
    }
    i.event.bind(i.ownerDocument, 'keydown', function(e) {
        if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) return;
        if (!elementHovered() && !scrollbarFocused()) return;
        var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
        if (activeElement) {
            if (activeElement.tagName === 'IFRAME') activeElement = activeElement.contentDocument.activeElement;
            else // go deeper if element is a webcomponent
            while(activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
            if ($5fbeb0576f6aeb94$var$isEditable(activeElement)) return;
        }
        var deltaX = 0;
        var deltaY = 0;
        switch(e.which){
            case 37:
                if (e.metaKey) deltaX = -i.contentWidth;
                else if (e.altKey) deltaX = -i.containerWidth;
                else deltaX = -30;
                break;
            case 38:
                if (e.metaKey) deltaY = i.contentHeight;
                else if (e.altKey) deltaY = i.containerHeight;
                else deltaY = 30;
                break;
            case 39:
                if (e.metaKey) deltaX = i.contentWidth;
                else if (e.altKey) deltaX = i.containerWidth;
                else deltaX = 30;
                break;
            case 40:
                if (e.metaKey) deltaY = -i.contentHeight;
                else if (e.altKey) deltaY = -i.containerHeight;
                else deltaY = -30;
                break;
            case 32:
                if (e.shiftKey) deltaY = i.containerHeight;
                else deltaY = -i.containerHeight;
                break;
            case 33:
                deltaY = i.containerHeight;
                break;
            case 34:
                deltaY = -i.containerHeight;
                break;
            case 36:
                deltaY = i.contentHeight;
                break;
            case 35:
                deltaY = -i.contentHeight;
                break;
            default:
                return;
        }
        if (i.settings.suppressScrollX && deltaX !== 0) return;
        if (i.settings.suppressScrollY && deltaY !== 0) return;
        element.scrollTop -= deltaY;
        element.scrollLeft += deltaX;
        $5fbeb0576f6aeb94$var$updateGeometry(i);
        if (shouldPreventDefault(deltaX, deltaY)) e.preventDefault();
    });
}
/* eslint-disable */ function $5fbeb0576f6aeb94$var$wheel(i) {
    var element = i.element;
    function shouldPreventDefault(deltaX, deltaY) {
        var roundedScrollTop = Math.floor(element.scrollTop);
        var isTop = element.scrollTop === 0;
        var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
        var isLeft = element.scrollLeft === 0;
        var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
        var hitsBound;
        // pick axis with primary direction
        if (Math.abs(deltaY) > Math.abs(deltaX)) hitsBound = isTop || isBottom;
        else hitsBound = isLeft || isRight;
        return hitsBound ? !i.settings.wheelPropagation : true;
    }
    function getDeltaFromEvent(e) {
        var deltaX = e.deltaX;
        var deltaY = -1 * e.deltaY;
        if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
            // OS X Safari
            deltaX = -1 * e.wheelDeltaX / 6;
            deltaY = e.wheelDeltaY / 6;
        }
        if (e.deltaMode && e.deltaMode === 1) {
            // Firefox in deltaMode 1: Line scrolling
            deltaX *= 10;
            deltaY *= 10;
        }
        if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */ ) {
            // IE in some mouse drivers
            deltaX = 0;
            deltaY = e.wheelDelta;
        }
        if (e.shiftKey) // reverse axis with shift key
        return [
            -deltaY,
            -deltaX
        ];
        return [
            deltaX,
            deltaY
        ];
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        // FIXME: this is a workaround for <select> issue in FF and IE #571
        if (!$5fbeb0576f6aeb94$var$env.isWebKit && element.querySelector('select:focus')) return true;
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($5fbeb0576f6aeb94$var$cls.element.consuming)) return true;
            var style = $5fbeb0576f6aeb94$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function mousewheelHandler(e) {
        var ref = getDeltaFromEvent(e);
        var deltaX = ref[0];
        var deltaY = ref[1];
        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) return;
        var shouldPrevent = false;
        if (!i.settings.useBothWheelAxes) {
            // deltaX will only be used for horizontal scrolling and deltaY will
            // only be used for vertical scrolling - this is the default
            element.scrollTop -= deltaY * i.settings.wheelSpeed;
            element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
            // only vertical scrollbar is active and useBothWheelAxes option is
            // active, so let's scroll vertical bar using both mouse wheel axes
            if (deltaY) element.scrollTop -= deltaY * i.settings.wheelSpeed;
            else element.scrollTop += deltaX * i.settings.wheelSpeed;
            shouldPrevent = true;
        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
            // useBothWheelAxes and only horizontal bar is active, so use both
            // wheel axes for horizontal bar
            if (deltaX) element.scrollLeft += deltaX * i.settings.wheelSpeed;
            else element.scrollLeft -= deltaY * i.settings.wheelSpeed;
            shouldPrevent = true;
        }
        $5fbeb0576f6aeb94$var$updateGeometry(i);
        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
        if (shouldPrevent && !e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    if (typeof window.onwheel !== 'undefined') i.event.bind(element, 'wheel', mousewheelHandler);
    else if (typeof window.onmousewheel !== 'undefined') i.event.bind(element, 'mousewheel', mousewheelHandler);
}
function $5fbeb0576f6aeb94$var$touch(i) {
    if (!$5fbeb0576f6aeb94$var$env.supportsTouch && !$5fbeb0576f6aeb94$var$env.supportsIePointer) return;
    var element = i.element;
    var state = {
        startOffset: {},
        startTime: 0,
        speed: {},
        easingLoop: null
    };
    function shouldPrevent(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        var scrollLeft = element.scrollLeft;
        var magnitudeX = Math.abs(deltaX);
        var magnitudeY = Math.abs(deltaY);
        if (magnitudeY > magnitudeX) {
            // user is perhaps trying to swipe up/down the page
            if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) // set prevent for mobile Chrome refresh
            return window.scrollY === 0 && deltaY > 0 && $5fbeb0576f6aeb94$var$env.isChrome;
        } else if (magnitudeX > magnitudeY) {
            // user is perhaps trying to swipe left/right across the page
            if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) return true;
        }
        return true;
    }
    function applyTouchMove(differenceX, differenceY) {
        element.scrollTop -= differenceY;
        element.scrollLeft -= differenceX;
        $5fbeb0576f6aeb94$var$updateGeometry(i);
    }
    function getTouch(e) {
        if (e.targetTouches) return e.targetTouches[0];
        // Maybe IE pointer
        return e;
    }
    function shouldHandle(e) {
        if (e.target === i.scrollbarX || e.target === i.scrollbarY) return false;
        if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) return false;
        if (e.targetTouches && e.targetTouches.length === 1) return true;
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) return true;
        return false;
    }
    function touchStart(e) {
        if (!shouldHandle(e)) return;
        var touch = getTouch(e);
        state.startOffset.pageX = touch.pageX;
        state.startOffset.pageY = touch.pageY;
        state.startTime = new Date().getTime();
        if (state.easingLoop !== null) clearInterval(state.easingLoop);
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($5fbeb0576f6aeb94$var$cls.element.consuming)) return true;
            var style = $5fbeb0576f6aeb94$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function touchMove(e) {
        if (shouldHandle(e)) {
            var touch = getTouch(e);
            var currentOffset = {
                pageX: touch.pageX,
                pageY: touch.pageY
            };
            var differenceX = currentOffset.pageX - state.startOffset.pageX;
            var differenceY = currentOffset.pageY - state.startOffset.pageY;
            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) return;
            applyTouchMove(differenceX, differenceY);
            state.startOffset = currentOffset;
            var currentTime = new Date().getTime();
            var timeGap = currentTime - state.startTime;
            if (timeGap > 0) {
                state.speed.x = differenceX / timeGap;
                state.speed.y = differenceY / timeGap;
                state.startTime = currentTime;
            }
            if (shouldPrevent(differenceX, differenceY)) // Prevent the default behavior if the event is cancelable
            {
                if (e.cancelable) e.preventDefault();
            }
        }
    }
    function touchEnd() {
        if (i.settings.swipeEasing) {
            clearInterval(state.easingLoop);
            state.easingLoop = setInterval(function() {
                if (i.isInitialized) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (!state.speed.x && !state.speed.y) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (Math.abs(state.speed.x) < 0.01 && Math.abs(state.speed.y) < 0.01) {
                    clearInterval(state.easingLoop);
                    return;
                }
                applyTouchMove(state.speed.x * 30, state.speed.y * 30);
                state.speed.x *= 0.8;
                state.speed.y *= 0.8;
            }, 10);
        }
    }
    if ($5fbeb0576f6aeb94$var$env.supportsTouch) {
        i.event.bind(element, 'touchstart', touchStart);
        i.event.bind(element, 'touchmove', touchMove);
        i.event.bind(element, 'touchend', touchEnd);
    } else if ($5fbeb0576f6aeb94$var$env.supportsIePointer) {
        if (window.PointerEvent) {
            i.event.bind(element, 'pointerdown', touchStart);
            i.event.bind(element, 'pointermove', touchMove);
            i.event.bind(element, 'pointerup', touchEnd);
        } else if (window.MSPointerEvent) {
            i.event.bind(element, 'MSPointerDown', touchStart);
            i.event.bind(element, 'MSPointerMove', touchMove);
            i.event.bind(element, 'MSPointerUp', touchEnd);
        }
    }
}
/* eslint-disable */ var $5fbeb0576f6aeb94$var$defaultSettings = function() {
    return {
        handlers: [
            'click-rail',
            'drag-thumb',
            'keyboard',
            'wheel',
            'touch'
        ],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1000,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1
    };
};
var $5fbeb0576f6aeb94$var$handlers = {
    'click-rail': $5fbeb0576f6aeb94$var$clickRail,
    'drag-thumb': $5fbeb0576f6aeb94$var$setupScrollHandlers,
    keyboard: $5fbeb0576f6aeb94$var$keyboard,
    wheel: $5fbeb0576f6aeb94$var$wheel,
    touch: $5fbeb0576f6aeb94$var$touch
};
var $5fbeb0576f6aeb94$var$PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$1 = this;
    if (userSettings === void 0) userSettings = {};
    if (typeof element === 'string') element = document.querySelector(element);
    if (!element || !element.nodeName) throw new Error('no element is specified to initialize PerfectScrollbar');
    this.element = element;
    element.classList.add($5fbeb0576f6aeb94$var$cls.main);
    this.settings = $5fbeb0576f6aeb94$var$defaultSettings();
    for(var key in userSettings)this.settings[key] = userSettings[key];
    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;
    var focus = function() {
        return element.classList.add($5fbeb0576f6aeb94$var$cls.state.focus);
    };
    var blur = function() {
        return element.classList.remove($5fbeb0576f6aeb94$var$cls.state.focus);
    };
    this.isRtl = $5fbeb0576f6aeb94$var$get(element).direction === 'rtl';
    if (this.isRtl === true) element.classList.add($5fbeb0576f6aeb94$var$cls.rtl);
    this.isNegativeScroll = function() {
        var originalScrollLeft = element.scrollLeft;
        var result = null;
        element.scrollLeft = -1;
        result = element.scrollLeft < 0;
        element.scrollLeft = originalScrollLeft;
        return result;
    }();
    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new $5fbeb0576f6aeb94$var$EventManager();
    this.ownerDocument = element.ownerDocument || document;
    this.scrollbarXRail = $5fbeb0576f6aeb94$var$div($5fbeb0576f6aeb94$var$cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = $5fbeb0576f6aeb94$var$div($5fbeb0576f6aeb94$var$cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = $5fbeb0576f6aeb94$var$get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
    if (isNaN(this.scrollbarXBottom)) {
        this.isScrollbarXUsingBottom = false;
        this.scrollbarXTop = $5fbeb0576f6aeb94$var$toInt(railXStyle.top);
    } else this.isScrollbarXUsingBottom = true;
    this.railBorderXWidth = $5fbeb0576f6aeb94$var$toInt(railXStyle.borderLeftWidth) + $5fbeb0576f6aeb94$var$toInt(railXStyle.borderRightWidth);
    // Set rail to display:block to calculate margins
    $5fbeb0576f6aeb94$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    this.railXMarginWidth = $5fbeb0576f6aeb94$var$toInt(railXStyle.marginLeft) + $5fbeb0576f6aeb94$var$toInt(railXStyle.marginRight);
    $5fbeb0576f6aeb94$var$set(this.scrollbarXRail, {
        display: ''
    });
    this.railXWidth = null;
    this.railXRatio = null;
    this.scrollbarYRail = $5fbeb0576f6aeb94$var$div($5fbeb0576f6aeb94$var$cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = $5fbeb0576f6aeb94$var$div($5fbeb0576f6aeb94$var$cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = $5fbeb0576f6aeb94$var$get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);
    if (isNaN(this.scrollbarYRight)) {
        this.isScrollbarYUsingRight = false;
        this.scrollbarYLeft = $5fbeb0576f6aeb94$var$toInt(railYStyle.left);
    } else this.isScrollbarYUsingRight = true;
    this.scrollbarYOuterWidth = this.isRtl ? $5fbeb0576f6aeb94$var$outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = $5fbeb0576f6aeb94$var$toInt(railYStyle.borderTopWidth) + $5fbeb0576f6aeb94$var$toInt(railYStyle.borderBottomWidth);
    $5fbeb0576f6aeb94$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railYMarginHeight = $5fbeb0576f6aeb94$var$toInt(railYStyle.marginTop) + $5fbeb0576f6aeb94$var$toInt(railYStyle.marginBottom);
    $5fbeb0576f6aeb94$var$set(this.scrollbarYRail, {
        display: ''
    });
    this.railYHeight = null;
    this.railYRatio = null;
    this.reach = {
        x: element.scrollLeft <= 0 ? 'start' : element.scrollLeft >= this.contentWidth - this.containerWidth ? 'end' : null,
        y: element.scrollTop <= 0 ? 'start' : element.scrollTop >= this.contentHeight - this.containerHeight ? 'end' : null
    };
    this.isAlive = true;
    this.settings.handlers.forEach(function(handlerName) {
        return $5fbeb0576f6aeb94$var$handlers[handlerName](this$1);
    });
    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
    this.lastScrollLeft = element.scrollLeft; // for onScroll only
    this.event.bind(this.element, 'scroll', function(e) {
        return this$1.onScroll(e);
    });
    $5fbeb0576f6aeb94$var$updateGeometry(this);
};
$5fbeb0576f6aeb94$var$PerfectScrollbar.prototype.update = function update() {
    if (!this.isAlive) return;
    // Recalcuate negative scrollLeft adjustment
    this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
    // Recalculate rail margins
    $5fbeb0576f6aeb94$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    $5fbeb0576f6aeb94$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railXMarginWidth = $5fbeb0576f6aeb94$var$toInt($5fbeb0576f6aeb94$var$get(this.scrollbarXRail).marginLeft) + $5fbeb0576f6aeb94$var$toInt($5fbeb0576f6aeb94$var$get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight = $5fbeb0576f6aeb94$var$toInt($5fbeb0576f6aeb94$var$get(this.scrollbarYRail).marginTop) + $5fbeb0576f6aeb94$var$toInt($5fbeb0576f6aeb94$var$get(this.scrollbarYRail).marginBottom);
    // Hide scrollbars not to affect scrollWidth and scrollHeight
    $5fbeb0576f6aeb94$var$set(this.scrollbarXRail, {
        display: 'none'
    });
    $5fbeb0576f6aeb94$var$set(this.scrollbarYRail, {
        display: 'none'
    });
    $5fbeb0576f6aeb94$var$updateGeometry(this);
    $5fbeb0576f6aeb94$var$processScrollDiff(this, 'top', 0, false, true);
    $5fbeb0576f6aeb94$var$processScrollDiff(this, 'left', 0, false, true);
    $5fbeb0576f6aeb94$var$set(this.scrollbarXRail, {
        display: ''
    });
    $5fbeb0576f6aeb94$var$set(this.scrollbarYRail, {
        display: ''
    });
};
$5fbeb0576f6aeb94$var$PerfectScrollbar.prototype.onScroll = function onScroll(e) {
    if (!this.isAlive) return;
    $5fbeb0576f6aeb94$var$updateGeometry(this);
    $5fbeb0576f6aeb94$var$processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    $5fbeb0576f6aeb94$var$processScrollDiff(this, 'left', this.element.scrollLeft - this.lastScrollLeft);
    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
};
$5fbeb0576f6aeb94$var$PerfectScrollbar.prototype.destroy = function destroy() {
    if (!this.isAlive) return;
    this.event.unbindAll();
    $5fbeb0576f6aeb94$var$remove(this.scrollbarX);
    $5fbeb0576f6aeb94$var$remove(this.scrollbarY);
    $5fbeb0576f6aeb94$var$remove(this.scrollbarXRail);
    $5fbeb0576f6aeb94$var$remove(this.scrollbarYRail);
    this.removePsClasses();
    // unset elements
    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;
    this.isAlive = false;
};
$5fbeb0576f6aeb94$var$PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
    this.element.className = this.element.className.split(' ').filter(function(name) {
        return !name.match(/^ps([-_].+|)$/);
    }).join(' ');
};
var $5fbeb0576f6aeb94$export$2e2bcd8739ae039 = $5fbeb0576f6aeb94$var$PerfectScrollbar;



const $52772a3ac0d5fa22$var$$variantsSelector = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-all-variants]");
let $52772a3ac0d5fa22$var$data = {
    cart: {},
    update (newCart) {
        this.cart = newCart;
    },
    setRedirect (e) {
        e.preventDefault();
        $52772a3ac0d5fa22$var$goToCheckout();
    }
};
let $52772a3ac0d5fa22$var$open = false;
const $52772a3ac0d5fa22$var$$minicart = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-minicart]");
let $52772a3ac0d5fa22$var$scrollBar = null;
const $52772a3ac0d5fa22$var$$minicart_block = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#minicart-block");
const $52772a3ac0d5fa22$var$$minicart_empty = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#minicart-empty");
const $52772a3ac0d5fa22$var$initMinicartScrollbar = function() {
    const isTouch = "ontouchstart" in window || window.matchMedia("(max-width: 989px)").matches;
    if (isTouch) return;
    const el = document.querySelector("#minicart-block");
    if (el && !$52772a3ac0d5fa22$var$scrollBar) $52772a3ac0d5fa22$var$scrollBar = new (0, $5fbeb0576f6aeb94$export$2e2bcd8739ae039)(el);
};
// cartShow();
$52772a3ac0d5fa22$var$refreshRecommend(3000);
const $52772a3ac0d5fa22$var$addToCart = function(id, qty, properties) {
    let data = {
        quantity: qty,
        id: id,
        properties: {}
    };
    if (properties != null) {
        // Check for specific properties first (like subscription)
        if (properties["shipping_interval_frequency"] && properties["shipping_interval_unit_type"] && properties["subscription_id"]) {
            data["properties"]["shipping_interval_frequency"] = properties["shipping_interval_frequency"];
            data["properties"]["shipping_interval_unit_type"] = properties["shipping_interval_unit_type"];
            data["properties"]["subscription_id"] = properties["subscription_id"];
        }
        // Handle 'preorder' property separately
        if (properties["preorder"]) data["properties"]["preorder"] = properties["preorder"];
        // Add all other properties, including 'Ship On' if present
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).each(properties, function(key, value) {
            // Add each property, regardless of 'preorder'
            if (key !== "preorder") data["properties"][key] = value;
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function() {
            $52772a3ac0d5fa22$var$open = true;
            $52772a3ac0d5fa22$var$updateMinicart();
        },
        error: function(response) {
            $52772a3ac0d5fa22$var$successCallback(response.responseJSON);
            console.error("Can't add item to cart");
        }
    });
};
const $52772a3ac0d5fa22$var$successCallback = function(response) {
    let $errorMessageWrapper = document.querySelector("[data-product-error-wrapper]");
    if (!$errorMessageWrapper) return;
    let $errorMessageContent = $errorMessageWrapper.querySelector("[data-product-error-message]");
    if (response.status && typeof response.status === "number") {
        if ($errorMessageContent) {
            $errorMessageWrapper.classList.remove("visually-hidden");
            $errorMessageContent.textContent = response.description;
        }
        setTimeout(()=>{
            $errorMessageWrapper.classList.add("visually-hidden");
            if (response.description) errorMessage.textContent = "";
        }, 5000);
    }
};
window.newAddToCart = function(items, openCart, successCallback, catchCallback) {
    const config = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/javascript`,
            "X-Requested-With": "XMLHttpRequest"
        }
    };
    config.body = JSON.stringify({
        items: items
    });
    fetch(`/cart/add.js`, config).then((response)=>{
        return response.json();
    }).then((json)=>{
        if (json.status) {
            if (successCallback) successCallback(json);
        } else {
            $52772a3ac0d5fa22$var$open = true;
            $52772a3ac0d5fa22$var$updateMinicart();
        }
    }).catch((error)=>{
        if (catchCallback) catchCallback();
        console.error(error);
    });
};
const $52772a3ac0d5fa22$var$getProperties = function($productForm) {
    let properties = {}; // Ensure properties is an object, not an array
    // Check for elements with data-product-property first
    $productForm.find("[data-product-property]").each(function(index, element) {
        let key = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).data("product-property"); // Get the data-product-property value
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).val(); // Get the value of the element
        if (key && value) properties[key] = value; // Add to properties object
    });
    // Fallback: read other form elements, excluding Shopify-internal and variant-selection fields
    $productForm.find("[name], [data-property]").each(function(index, element) {
        const type = element.type;
        const name = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).attr("name") || "";
        // Skip unchecked radios/checkboxes — val() returns the attribute value, not the checked state
        if ((type === "radio" || type === "checkbox") && !element.checked) return;
        // Skip fields that are not cart properties
        if (type === "submit" || name === "ID" || name === "options[]" || name.startsWith("product-option-")) return;
        let key = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).data("property") || name;
        let value = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).val();
        if (key && value) properties[key] = value;
    });
    // Handle specific case for "preorder" if out of stock
    const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", $productForm.find("[data-all-variants]"));
    if ($variantSelected.attr("data-inventory-policy") == "continue" && parseInt($variantSelected.attr("data-inventory-quantity")) <= 0) properties["preorder"] = "preorder";
    return properties;
};
const $52772a3ac0d5fa22$var$addToCartHandler = function($productForm) {
    if ($productForm instanceof (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))) $productForm;
    else $productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($productForm);
    const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($productForm).find("[data-all-variants]"));
    let variantId = $variantSelected.val();
    if ($variantSelected.data("discount-variant-id") != "") variantId = $variantSelected.data("discount-variant-id");
    const qty = $productForm.find("[data-qty]").val() || 1;
    // get the Ships-on
    let getShipOn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#addToCartForm div.ships-on").css("display") === "none" ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#addToCartForm div.ships-on").text().trim();
    let properties = $52772a3ac0d5fa22$var$getProperties($productForm);
    properties["Ship On"] = getShipOn;
    // console.log("Properties from getProperties 1:", properties);
    if (variantId) $52772a3ac0d5fa22$var$addToCart(variantId, qty, properties);
    else if ($productForm.find("[data-all-variants] option:selected").data("multi-variants")) {
        let $variants = $productForm.find("[data-all-variants] option:selected").data("multi-variants");
        $variants.forEach(function(id) {
            $52772a3ac0d5fa22$var$addToCart(id, qty, properties);
        });
    } else console.error("minicart.js: can't add item to cart, wrong variantId", variantId);
};
const $52772a3ac0d5fa22$var$closeCartModal = function() {
    $52772a3ac0d5fa22$var$$minicart.removeClass("is-open");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").removeClass("is-cart-open");
};
function $52772a3ac0d5fa22$var$cartShow() {
    if ($52772a3ac0d5fa22$var$data.cart.item_count > 0) {
        $52772a3ac0d5fa22$var$$minicart_empty.addClass("minicart_none");
        $52772a3ac0d5fa22$var$$minicart_block.removeClass("minicart_none");
    } else {
        $52772a3ac0d5fa22$var$$minicart_block.addClass("minicart_none");
        $52772a3ac0d5fa22$var$$minicart_empty.removeClass("minicart_none");
    }
}
function $52772a3ac0d5fa22$var$refreshRecommend(t) {
    var time = t;
    if (t == undefined || t == null) time = 0;
    setTimeout(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function(cart) {
                var cartItems = cart["items"];
                if (cart.item_count > 0) {
                    var $item = cartItems.pop();
                    var id = $item["product_id"];
                    (0, $732388c7eeead09f$export$aeacd9116b5e16bd)(id);
                //   $("[data-minicart].minicart").addClass('upsell_include');
                //   // $("[data-minicart].minicart .upsell_recommend").slick();
                // } else {
                //   $("[data-minicart].minicart").removeClass('upsell_include');
                //   setTimeout(function () {
                //     $("[data-minicart].minicart .upsell_static").slick('setPosition');
                //   }, 150);
                }
                //remove '-xsell' url string from cart items
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart_main .minicart__item:not(.crossell_item)").each(function() {
                    var $xlink = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find("a");
                    var xhref = $xlink.attr("href");
                    if (xhref && xhref.includes("-xsell")) {
                        var newxHref = xhref.replace("-xsell", "");
                        $xlink.attr("href", newxHref);
                    }
                });
            }
        });
    }, time);
}
const $52772a3ac0d5fa22$var$removeFromCart = function($item) {
    var updateQuery = "updates[" + $item.attr("data-id") + "]=" + 0;
    jQuery.post("/cart/update.js", updateQuery, function() {
        $52772a3ac0d5fa22$var$updateMinicart();
        $52772a3ac0d5fa22$var$refreshRecommend();
    });
};
function $52772a3ac0d5fa22$var$reChargeProcessCart() {
    let token = "";
    function get_cookie(name) {
        return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
    }
    do token = get_cookie("cart");
    while (token == undefined);
    try {
        var ga_linker = ga.getAll()[0].get("linkerParam");
    } catch (err) {
        var ga_linker = "";
    }
    var customer_param = "{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}";
    document.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;
}
const $52772a3ac0d5fa22$var$goToCheckout = function() {
    let hasSubscription = false;
    for(let i = 0; i < $52772a3ac0d5fa22$var$data.cart.items.length; i++){
        let item = $52772a3ac0d5fa22$var$data.cart.items[i];
        if (item.product_title.includes("Auto renew")) hasSubscription = true;
    }
    if (hasSubscription) $52772a3ac0d5fa22$var$reChargeProcessCart();
    else document.location.href = "/checkout";
};
const $52772a3ac0d5fa22$var$checkFreeItem = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: function(result) {
            const newCart = result;
            $52772a3ac0d5fa22$var$data.update(result);
            var cartItems = newCart.items, qtyInTheCart = 0, freeQtyInCart = {}, cartUpdates = {}, freeAlreadyInCart = false, freeProductHandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart-free-item .handle").text(), freeProductVariants = [], freeProductVariantId = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart-free-item .default_variant").text());
            if (newCart.item_count > 0) {
                for(var i = 0; i < cartItems.length; i++)if (cartItems[i].handle === freeProductHandle) {
                    //console.log("Free one in cart already cart: ", cartItems[i].handle );
                    //qtyInTheCart = cartItems[i].quantity;
                    freeAlreadyInCart = true;
                    var found = jQuery.inArray(cartItems[i].variant_id, freeProductVariants);
                    if (found < 0) freeProductVariants.push(cartItems[i].variant_id);
                    break;
                }
                var main1 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart-free-item .main_product_1_handle").text();
                var main2 = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart-free-item .main_product_2_handle").text();
                for(var i = 0; i < cartItems.length; i++)if (cartItems[i].handle === main1 || cartItems[i].handle === main2) {
                    //console.log("If in cart: ", cartItems[i].handle );
                    //console.log("Then add free product");
                    var colorOfBlender = "";
                    qtyInTheCart = cartItems[i].quantity;
                    //console.log("CArt items ", cartItems[i]);
                    //freeQtyInCart[cartItems[i].variant_id] = cartItems[i].quantity;
                    if (cartItems[i].options_with_values != null) {
                        var options = cartItems[i].options_with_values;
                        for(var j = 0; j < options.length; j++){
                            var color = options[j];
                            if (color.name === "Color") colorOfBlender = color.value;
                        }
                    }
                    var qtyByColor = freeQtyInCart[colorOfBlender] ? freeQtyInCart[colorOfBlender] : 0;
                    freeQtyInCart[colorOfBlender] = qtyByColor + cartItems[i].quantity;
                    //console.log("Color of blender: ", colorOfBlender);
                    /*jQuery.getJSON('/products/'+ freeProductHandle +'.js', function(product) {
              var freeVariants = product.variants;
              for (var p=0; p<freeVariants.length; p++) {
                  if (freeVariants[p]['option1'] === colorOfBlender) {
                    if (freeVariants[p]['available']) {
                      freeProductVariantId = freeVariants[p]['id'];
                    }

                    break;
                  }
              }
            }).done(function() {*/ //console.log("freeProductVariantId ", freeProductVariantId);
                    var found = jQuery.inArray(freeProductVariantId, freeProductVariants);
                    //console.log("Found ", found);
                    //console.log("qtyInTheCart ", qtyInTheCart);
                    //console.log("freeQtyInCart", freeQtyInCart);
                    if (freeProductVariantId > 0) {
                        if (found < 0) jQuery.post("/cart/add.js", {
                            quantity: freeQtyInCart[colorOfBlender],
                            id: freeProductVariantId
                        }).done(function() {
                            freeProductVariants.push(freeProductVariantId);
                            $52772a3ac0d5fa22$var$updateMinicart();
                        });
                        else if (freeQtyInCart[colorOfBlender] > 1) jQuery.post("/cart/change.js", {
                            quantity: freeQtyInCart[colorOfBlender],
                            id: freeProductVariantId
                        }).done(function() {
                            $52772a3ac0d5fa22$var$updateMinicart();
                        });
                    }
                //});
                }
            }
        }
    });
};
const $52772a3ac0d5fa22$var$addCompareAtPrice = function(cart) {
    cart.items.forEach(function(item) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            url: "/products/" + item.handle + ".js",
            dataType: "json",
            async: false,
            success: function(product) {
                product.variants.forEach(function(variant) {
                    if (variant.id == item.variant_id) {
                        if (variant.compare_at_price != null) item["compare_at_price"] = variant.compare_at_price;
                    }
                });
            }
        });
    });
    return cart;
};
const $52772a3ac0d5fa22$var$updateMinicart = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: function(result) {
            $52772a3ac0d5fa22$var$addCompareAtPrice(result);
            $52772a3ac0d5fa22$var$data.update(result);
            $52772a3ac0d5fa22$var$updateCartCount();
            let total_price = result.total_price;
            let original_subtotal = 0;
            result.items.forEach(function(item) {
                let item_original_price = item.compare_at_price || item.price;
                original_subtotal += item_original_price * item.quantity;
            });
            var offer_min_limit = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider").data("offer_min_limit");
            var offer_amount = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider").data("offer_amount");
            var leftOffer = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(offer_min_limit - total_price);
            var percentage = total_price / offer_min_limit * 100;
            var offerPrice = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(total_price + offer_amount);
            var total_saving = original_subtotal - total_price;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider #offer_min_limit").text(leftOffer);
            if (result.total_discount == 3000) {
                percentage = 100;
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider .completed").removeClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider .uncompleted").addClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .saving-offer-note").removeClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .offer-price").removeClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .offer-price span").text(offerPrice);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .normal-price").addClass("has-offer");
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider .uncompleted").removeClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider .completed").addClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .saving-offer-note").addClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .offer-price").addClass("hide");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .normal-price").removeClass("has-offer");
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".offer-cart-slider .offer-slider-fill").css("width", percentage + "%");
            // Update the original subtotal in the minicart footer
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .original-subtotal").text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(total_saving));
            // Hide the original subtotal div if total_saving is 0 or less
            if (total_saving <= 0) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .minicart__totalsavings").hide();
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__footer .minicart__totalsavings").show();
            $52772a3ac0d5fa22$var$checkShipOnProperty();
            $52772a3ac0d5fa22$var$checkCartAndFetchCrossSell();
            if ($52772a3ac0d5fa22$var$open) {
                $52772a3ac0d5fa22$var$$minicart.addClass("is-open");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").addClass("is-cart-open");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").addClass("no-scroll");
                $52772a3ac0d5fa22$var$open = false;
                $52772a3ac0d5fa22$var$refreshRecommend();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell-container").addClass("active_usc");
            }
            $52772a3ac0d5fa22$var$cartShow();
        }
    });
};
// Call updateMinicart function on document ready
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("ready", function() {
    $52772a3ac0d5fa22$var$updateMinicart();
});
const $52772a3ac0d5fa22$var$updateCartCount = function() {
    let cartCount = "[data-cart-count]";
    var count = $52772a3ac0d5fa22$var$data.cart.item_count;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(cartCount).text($52772a3ac0d5fa22$var$data.cart.item_count);
    const $body = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body");
    if (count == 0) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-cart-count]").parent(".cart-count-wrap").addClass("empty_cart");
        if ($body.hasClass("template-product") || $body.hasClass("template-collection")) ;
        else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-cart]").removeAttr("data--hidden");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-shop]").attr("data--hidden", true);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-shop-btn]").removeAttr("data--hidden");
        }
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-cart-count]").parent(".cart-count-wrap").removeClass("empty_cart");
        if ($body.hasClass("template-product") || $body.hasClass("template-collection")) ;
        else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-cart]").removeAttr("data--hidden");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-shop]").removeAttr("data--hidden");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-nav-shop-btn]").attr("data--hidden", true);
        }
    }
};
const $52772a3ac0d5fa22$var$updateFreeShippingBar = function() {
    const theme = window.theme || {};
    const strings = theme.strings || {};
    // Threshold comes from the theme settings so each market can match its own
    // shipping rate, rather than a hardcoded cents value.
    const elgiblePrice = theme.freeShippingThreshold;
    if (!elgiblePrice) return;
    if ($52772a3ac0d5fa22$var$data.cart.total_price >= elgiblePrice) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-free-shipping-label]").html(strings.freeShippingUnlocked || "");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-free-shipping-percent]").css("width", "100%");
    } else {
        const remainingPrice = parseInt(elgiblePrice - $52772a3ac0d5fa22$var$data.cart.total_price);
        const percent = parseInt($52772a3ac0d5fa22$var$data.cart.total_price * 100 / elgiblePrice);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-free-shipping-label]").html((strings.freeShippingRemaining || "").replace("{{ amount }}", (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(remainingPrice)));
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-free-shipping-percent]").css("width", percent + "%");
    }
};
const $52772a3ac0d5fa22$var$eventHandlers = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".beast-checkout", function(e) {
        e.preventDefault();
        $52772a3ac0d5fa22$var$goToCheckout();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-add-to-cart]", function(e) {
        e.preventDefault();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-preorder-item.added").length > 0) {
            var data = [];
            var _this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-preorder-item.added").each(function() {
                var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".product-preorder-atc-form").attr("data-id");
                var item = {
                    id: variant_id,
                    quantity: 1
                };
                data.push(item);
            });
            data.push({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-form").find("[data-selected-variant-id]").val(),
                quantity: 1
            });
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: data
                },
                dataType: "json",
                success: function() {
                    //$('[data-add-to-cart-upsell=true]').parent().find('[data-upsell-btn]').trigger('click');
                    $52772a3ac0d5fa22$var$open = true;
                    $52772a3ac0d5fa22$var$updateMinicart();
                }
            });
        } else {
            // ADD FREE GIFT ON Mega & Mighty PDP
            // if ($('body').hasClass('template-product-bundle-mega') || $('body').hasClass('template-product-bundle-mighty')) {
            //     // get Ship On data
            //     let ship_on_bm = $('#addToCartForm div.ships-on').css('display') === 'none' ? '' : $('#addToCartForm div.ships-on').text().trim();
            //     $('[data-popup]').addClass('is-hidden');
            //     const prodId = $(this).closest(".product-form").data("productid");
            //     //const prodId = $('form#addToCartForm').data("productid");
            //     const varId = $(this).closest(".product-form").find("[data-selected-variant-id]").val();
            //     // Initialize an array to hold product data
            //     let productsToAdd = [{
            //       id: varId,
            //       quantity: 1,
            //       properties: {
            //         'Ship On': ship_on_bm
            //       }
            //     }];
            //     // Free gift with Mega 1200 or Mighty 850
            //     if (prodId == 8019201360063 || prodId == 7989170405567){
            //       let secondProductData = {
            //         id: 43804442132671, // product.id of Fuel Up Free Gift
            //         quantity: 1,
            //         properties: null
            //       };
            //       productsToAdd.push(secondProductData);
            //     }
            //     // AJAX call to add all products
            //     $.ajax({
            //       type: 'POST',
            //       url: '/cart/add.js',
            //       data: { items: productsToAdd },
            //       dataType: 'json',
            //       success: function (response) {
            //         //console.log('Products added successfully:', response);
            //         open = true;
            //         updateMinicart();
            //       },
            //       error: function (xhr, status, error) {
            //         console.error('Error adding products:', error);
            //       }
            //     });
            //   } else {
            // NORMAL CODE
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-popup]").addClass("is-hidden");
            let productForm;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]").length > 0 ? productForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-product-form]") : productForm = this.form;
            $52772a3ac0d5fa22$var$addToCartHandler(productForm);
        // }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".sticky-bottom [data-add-to-cart].add-to-cart.btn", function(e) {
        e.preventDefault();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-preorder-item.added").length > 0) {
            var data = [];
            var _this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-preorder-item.added").each(function() {
                var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".product-preorder-atc-form").attr("data-id");
                var item = {
                    id: variant_id,
                    quantity: 1
                };
                data.push(item);
            });
            data.push({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find(".sticky-variants").val(),
                quantity: 1
            });
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: data
                },
                dataType: "json",
                success: function() {
                    //$('[data-add-to-cart-upsell=true]').parent().find('[data-upsell-btn]').trigger('click');
                    $52772a3ac0d5fa22$var$open = true;
                    //checkFreeItem();
                    $52772a3ac0d5fa22$var$updateMinicart();
                }
            });
        } else {
            // // ADD FREE GIFT ON Mega & Mighty PDP
            // if ($('body').hasClass('template-product-bundle-mega') || $('body').hasClass('template-product-bundle-mighty')) {
            //   const pidv = $(this).closest(".sticky-form").find(".sticky-variants option:selected").attr("pid-value");
            //   const variant_id = $(this).closest(".sticky-form").find(".sticky-variants").val();
            //   // get Ship On data
            //   let ShipOnBms = $('.custom-variants_select div.active').data('ship-on');
            //   // Initialize an array to hold product data
            //   let productsToAdd = [{
            //     id: variant_id,
            //     quantity: 1,
            //     properties: {
            //       'Ship On': ShipOnBms
            //     }
            //   }];
            //   // Free gift with Mega 1200 or Mighty 850
            //   if (pidv == 8019201360063 || pidv == 7989170405567) {
            //     let secondProductData = {
            //       id: 43804442132671, // product.id of Fuel Up Free Gift
            //       quantity: 1
            //     };
            //     productsToAdd.push(secondProductData);
            //   }
            //   // AJAX call to add all products
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { items: productsToAdd },
            //     dataType: 'json',
            //     success: function (response) {
            //       //console.log('Products added successfully:', response);
            //       open = true;
            //       updateMinicart();
            //     },
            //     error: function (xhr, status, error) {
            //       console.error('Error adding products:', error);
            //     }
            //   });
            // } else {
            //Standard Code
            // get Ship On data
            let getShipOn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".custom-variants_select div.active").data("ship-on");
            const lineItemProperties = {
                "Ship On": getShipOn
            };
            var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find(".sticky-variants").val();
            $52772a3ac0d5fa22$var$addToCart(variant_id, 1, lineItemProperties);
        // }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-sticky-atc]", function(e) {
        e.preventDefault();
        var $form = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("form");
        var variantId = $form.find('[name="id"]').val();
        $52772a3ac0d5fa22$var$addToCart(variantId, 1, null);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-quick-atc-swatch]", function(e) {
        e.stopPropagation();
        const $quickATCForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-quick-atc-wrap]");
        var colorName = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-color-name");
        const otherForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-other");
        const thisID = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-product-id");
        const otherPopup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("._popup");
        var $learn_more_link = $quickATCForm.find("[data-pc-learn-more]");
        var $quick_atc_btn = $quickATCForm.find("[data-quick-atc-btn]");
        $quickATCForm.find("[data-quick-atc-swatch]").removeClass("checked");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("checked");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-variant-image") != "") {
            $quickATCForm.find("[data-quick-atc-image]").attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-image"));
            $quickATCForm.find("[data-second-image]").attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-hover-image"));
            $quickATCForm.find("[data-quick-atc-image]").attr("srcset", "");
            $quickATCForm.find("[data-second-image]").attr("srcset", "");
        }
        otherPopup.each(function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("product-id") != thisID) {
                var mainImage = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('[data-color-name="' + colorName + '"]').data("variant-image");
                var altImage = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('[data-color-name="' + colorName + '"]').data("variant-hover-image");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-" + otherForm).find("[data-quick-atc-image]").attr("src", mainImage);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-" + otherForm).find("[data-second-image]").attr("src", altImage);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-" + otherForm).find("[data-quick-atc-image]").attr("srcset", "");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-" + otherForm).find("[data-second-image]").attr("srcset", "");
            }
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-variant-available") != "true") $quick_atc_btn.attr("disabled", true);
        else $quick_atc_btn.attr("disabled", false);
        $quick_atc_btn.text((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-btn"));
        $quickATCForm.attr("data-variant-id", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-id"));
        $learn_more_link.attr("href", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-url"));
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-cell-wrap").find(".product-cell__img a").attr("href", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-url"));
        var $btn = $quickATCForm.find("[data-quick-atc-btn]");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("is-disabled")) {
            $btn.addClass("disabled");
            $btn.find("[data-btn-label]").text("sold out");
        } else {
            $btn.removeClass("disabled");
            $btn.find("[data-btn-label]").text("add");
        }
        var colorName = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-color-name");
        var originPrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-variant-price");
        var comparePrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-variant-compare-price");
        //console.log("originPrice ", originPrice);
        //console.log("comparePrice ", comparePrice);
        if (typeof comparePrice != "undefined" && comparePrice != "" && comparePrice > originPrice) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-cell-wrap").find(".product-cell-price").html((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(originPrice) + ' &nbsp;<s class="was-price">' + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(comparePrice) + "\u122D ");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".cart-else-item").find(".show-on-hover").text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(originPrice));
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-cell-wrap").find(".product-cell-price").text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(originPrice));
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".cart-else-item").find(".show-on-hover").text((0, $f67e0c7059ce8336$export$a17b3c2052469c69)(originPrice));
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-upsell-atc-swatch]", function(e) {
        const $upsellForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-upsell-wrap]");
        $upsellForm.find("[data-upsell-atc-swatch]").removeClass("checked");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("checked");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-image") != "") $upsellForm.find("[data-upsell-image]").css("background-image", "url(" + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-image") + ")");
        $upsellForm.attr("data-variant-id", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-id"));
        $upsellForm.attr("data-variant-price", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-price"));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-quick-atc-btn]", function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $quickATCForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-quick-atc-wrap]");
        const variantId = $quickATCForm.attr("data-variant-id");
        const productId = $quickATCForm.attr("data-prod-id"); //Used for Free Gift
        //Get PLP ShipOn data
        var getShipOn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-quick-atc-wrap]").find("label.checked").data("ship-note");
        const lineItemProperties = {
            "Ship On": getShipOn
        };
        if (variantId) // // Free gift with Mega 1200 or Mighty 850
        // if (productId == 8019201360063 || productId == 7989170405567) {
        //   let productsToAdd = [{
        //     id: variantId,
        //     quantity: 1,
        //     properties: {
        //       'Ship On': getShipOn
        //     }
        //   }];
        //   // Define the second product data
        //   let secondProductData = {
        //     id: 43804442132671, // Variant ID of the second product (Fuel Up Book)
        //     quantity: 1
        //   };
        //   // Add the second product to the array
        //   productsToAdd.push(secondProductData);
        //   // AJAX call to add all products
        //   $.ajax({
        //     type: 'POST',
        //     url: '/cart/add.js',
        //     data: { items: productsToAdd },
        //     dataType: 'json',
        //     success: function (response) {
        //       console.log('Products added successfully:', response);
        //       open = true;
        //       updateMinicart();
        //     },
        //     error: function (xhr, status, error) {
        //       console.error('Error adding products:', error);
        //     }
        //   });
        // } else {
        // Standard code
        $52772a3ac0d5fa22$var$addToCart(variantId, 1, lineItemProperties);
        else console.error("Variant ID is missing or invalid.");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-upsell-btn]", function(e) {
        const $upsellForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-upsell-wrap]");
        $52772a3ac0d5fa22$var$addToCart($upsellForm.data("variant-id"), 1, null);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-add-to-cart-upsell]", function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-add-to-cart-upsell") == "false") {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-add-to-cart-upsell", "true");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text("Added");
            const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-info [data-all-variants]"));
            const upsellPrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("upsell-price");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".bundle-price").text("+ " + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(upsellPrice) + " Bundle");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".bundle-price-wrap").removeClass("hide");
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-add-to-cart-upsell", "false");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text("Bundle it");
            const $variantSelected = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("option:selected", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-info [data-all-variants]"));
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".bundle-price-wrap").addClass("hide");
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".compare-item [data-ajax-btn]", function(e) {
        e.preventDefault();
        var vId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-id");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                id: vId,
                quantity: 1
            },
            dataType: "json",
            success: function() {
                $52772a3ac0d5fa22$var$open = true;
                //checkFreeItem();
                $52772a3ac0d5fa22$var$updateMinicart();
            },
            error: function() {
                console.error("Can't add item to cart");
            }
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-pre-toggle]", function(event) {
        event.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-item").toggleClass("added");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-remove-from-cart]", function() {
        var $minicartItem = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".minicart__item");
        var product_id = $minicartItem.attr("data-product-id");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-preorder-items .product-preorder-item[data-product_id='" + product_id + "']").removeClass("added");
        $52772a3ac0d5fa22$var$removeFromCart($minicartItem);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-cart-close]", $52772a3ac0d5fa22$var$closeCartModal);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-cart-close]").on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell-container").removeClass("active_usc");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-minicart-toggle]").on("click", function(e) {
        e.preventDefault();
        $52772a3ac0d5fa22$var$$minicart.toggleClass("is-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").toggleClass("is-cart-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell-container").toggleClass("active_usc");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-qty-plus]", function() {
        $52772a3ac0d5fa22$var$updateCartItem("inc", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-qty-minus]", function() {
        $52772a3ac0d5fa22$var$updateCartItem("dec", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-sticky-atc-btn]", function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-add-to-cart]").trigger("click");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("cart.requestComplete", function(event, cart) {
        //checkFreeItem();
        $52772a3ac0d5fa22$var$updateMinicart();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(function() {
        $52772a3ac0d5fa22$var$updateMinicart();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-product-upsell-variants] input", function() {
        var $option = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product_option");
        var img = $option.attr("data-variant-img");
        var id = $option.attr("data-variant-id");
        var in_stock = $option.attr("data-in-stock");
        var option_value = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-option_value");
        if (in_stock == "true") {
            var free_text = "";
            // if($("body").hasClass("template-product") && $(window).width() < 768) {
            //   free_text = $(".product-upsell-price div.hide--mobile").text();
            //   if(free_text != "") free_text = " - " + free_text;
            // }
            const $button = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-upsell-meta").find("[data-ajax-atc-btn]");
            const addLabel = $button.attr("data-label-add") || "Add to cart";
            $button.text(addLabel + free_text).prop("disabled", false);
        } else {
            const $button = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-upsell-meta").find("[data-ajax-atc-btn]");
            const soldOutLabel = $button.attr("data-label-sold-out") || "sold out";
            $button.text(soldOutLabel).prop("disabled", true);
        }
        var $item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-upsell-item");
        $item.find(".product-upsell-atc-form").attr("data-id", id);
        $item.find(".product-upsell-image img").attr("data-srcset", img).attr("srcset", img);
        $option.closest(".product_variants").find(".upsell_option").find("span").text(option_value);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-product-preorder-variants] input", function() {
        var $option = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product_option");
        var img = $option.attr("data-variant-img");
        var id = $option.attr("data-variant-id");
        var in_stock = $option.attr("data-in-stock");
        if (in_stock == "true") {
            var free_text = "";
            // if($("body").hasClass("template-product") && $(window).width() < 768) {
            //   free_text = $(".product-upsell-price div.hide--mobile").text();
            //   if(free_text != "") free_text = " - " + free_text;
            // }product-preorder-item
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-meta").find("[data-pre-toggle] .label-add").text("add" + free_text);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-meta").find("[data-pre-toggle]").prop("disabled", false);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-item").removeClass("added");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-meta").find("[data-pre-toggle] .label-add").html("sold out");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-meta").find("[data-pre-toggle]").prop("disabled", true);
        }
        var $item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-item");
        $item.find(".product-preorder-atc-form").attr("data-id", id);
        $item.find(".product-preorder-image img").attr("data-srcset", img).attr("srcset", img);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".product-upsell-item .product-upsell-atc-form [data-ajax-atc-btn]", function(e) {
        e.preventDefault();
        const $form = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-upsell-atc-form");
        const variantId = $form.attr("data-id");
        if (!variantId) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
                id: variantId,
                quantity: 1
            },
            success: function() {
                $52772a3ac0d5fa22$var$open = true;
                $52772a3ac0d5fa22$var$updateMinicart();
            }
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".product-preorder-item:not(.added) .product-preorder-atc-form [data-ajax-atc-btn]", function(e) {
        e.preventDefault();
        var $item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-item");
        var vId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-atc-form").attr("data-id");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
                id: vId,
                quantity: 1
            },
            success: function(cart) {
                $item.addClass("added");
                $52772a3ac0d5fa22$var$open = true;
                //checkFreeItem();
                $52772a3ac0d5fa22$var$updateMinicart();
            }
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".product-preorder-item.added [data-ajax-atc-btn]", function(e) {
        e.preventDefault();
        var $item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".product-preorder-item");
        var $form = $item.find(".product-preorder-atc-form");
        var vId = $form.attr("data-id");
        var updateQuery = "updates[" + vId + "]=0";
        jQuery.post("/cart/update.js", updateQuery, function() {
            $item.removeClass("added");
            $52772a3ac0d5fa22$var$open = true;
            //checkFreeItem();
            $52772a3ac0d5fa22$var$updateMinicart();
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".btn-save-cart-note", function() {
        let note = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".gift-note").val().trim();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            url: "/cart/update.js",
            type: "POST",
            data: {
                note: note
            },
            success: function(result) {
                $52772a3ac0d5fa22$var$updateMinicart();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".gift-wrapper .minicart-small-title").toggleClass("active");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__gift").slideToggle();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".gift-wrapper .edit_text").show();
            },
            error: function(jqxhr, status, exception) {
                console.log(exception);
            }
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".gift-wrapper .minicart-small-title", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass("active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__gift").slideToggle();
    });
};
const $52772a3ac0d5fa22$var$updateCartItem = function(param, handle) {
    var id = handle.closest(".minicart__item").attr("data-id");
    var qty = parseInt(handle.parent(".item__qty").find("[data-qty]").text());
    if (param == "inc") {
        qty += 1;
        $52772a3ac0d5fa22$var$updateQty(id, qty);
    } else if (qty != 1) {
        qty -= 1;
        $52772a3ac0d5fa22$var$updateQty(id, qty);
    }
};
const $52772a3ac0d5fa22$var$updateQty = function(id, qty) {
    jQuery.post("/cart/update.js", "updates[" + id + "]=" + qty, function() {
        //checkFreeItem();
        $52772a3ac0d5fa22$var$updateMinicart();
    });
};
const $52772a3ac0d5fa22$var$init = function() {
    if (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.formatMoney = (0, $f67e0c7059ce8336$export$a17b3c2052469c69);
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.isDefaultTitle = function(title) {
            if (title.toLowerCase() == "default title") return false;
            // Check if it is gift card and value that ends  with .00
            if (title.includes(".00")) return false;
            return true;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.append = function(value, append) {
            return value + append;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_preorder = function(item) {
            if (item["properties"] == undefined) return false;
            if (item["properties"]["preorder"]) return true;
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_discount = function(item) {
            if (item["discounts"] != undefined) {
                if (item["discounts"].length != 0) return true;
            }
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_discount_and_not_zero = function(item) {
            if (item["discounts"] != undefined && item["discounts"].length != 0) return item["original_price"] > item["discounted_price"] && item["original_price"] - item["discounted_price"] > 0;
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_compare = function(item) {
            if (item["discounts"] != undefined) {
                if (item["discounts"].length != 0) return false;
            }
            if (item["compare_at_price"] != undefined) return true;
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_regular = function(item) {
            if (item["discounts"] != undefined) {
                if (item["discounts"].length != 0) return false;
            }
            if (item["compare_at_price"] != undefined) return false;
            return true;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_compare_in_cart = function(cart) {
            for(let index = 0; index < cart.items.length; index++){
                const item = cart.items[index];
                // Check if the item has no discounts
                if (!item["discounts"] || item["discounts"].length === 0) {
                    // Check if the compare price exists and is greater than the actual price
                    if (item["compare_at_price"] > item["price"]) return true; // Found an item with a valid compare price
                }
            }
            return false; // No valid compare prices found
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.empty_note = function(cart_note) {
            if (cart_note != undefined) {
                if (cart_note.length != 0) return false;
            }
            return true;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.is_free = function(item) {
            if (item["discounts"] != undefined) {
                if (item["discounts"].length != 0) {
                    if (item["discounted_price"] != 0) return false;
                    else return true;
                } else return false;
            } else return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.get_discount = function(item) {
            if (item["discounts"] != undefined) {
                if (item["discounted_price"] != item["price"]) return item["discounted_price"];
                else return false;
            }
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.get_compare = function(item) {
            if (item["compare_at_price"] != undefined) {
                if (item["compare_at_price"] != item["price"]) return item["compare_at_price"];
                else return null;
            }
            return false;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.get_compare_subtotal = function(cart) {
            let subtotal = 0;
            for(let index = 0; index < cart.items.length; index++){
                const item = cart.items[index];
                if (item["discounts"] != undefined) {
                    if (item["discounted_price"] != item["price"]) subtotal += item["discounted_price"] * item["quantity"];
                    else if (item["compare_at_price"] != undefined) {
                        if (item["compare_at_price"] != item["price"]) subtotal += item["compare_at_price"] * item["quantity"];
                        else subtotal += item["compare_at_price"] * item["quantity"];
                    } else subtotal += item["price"] * item["quantity"];
                }
            }
            return subtotal;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).formatters.convert = function(value, append) {
            if (append) return "/products/" + append;
            return value;
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9b125a4b43f93caa$exports))).bind($52772a3ac0d5fa22$var$$minicart, $52772a3ac0d5fa22$var$data);
    } else {
        console.error("minicart.js: Tinybind template library is not connected");
        return false;
    }
    $52772a3ac0d5fa22$var$initMinicartScrollbar();
    if (localStorage.getItem("opened_side_cart") == "true" && window.location.pathname == "/") {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-minicart]").addClass("is-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").addClass("is-cart-open");
        localStorage.setItem("opened_side_cart", false);
    }
};
function $52772a3ac0d5fa22$export$2e2bcd8739ae039() {
    $52772a3ac0d5fa22$var$init();
    $52772a3ac0d5fa22$var$eventHandlers();
}
// BEAST MINI CROSS-SELL ATC
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell_atc_bm").on("submit", function(event) {
    event.preventDefault(); // Prevent the default form submission
    // Prevent multiple clicks
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell_atc_bm #add-to-cart-button").prop("disabled", true);
    // Retrieve product IDs from session storage
    var mainProductId = sessionStorage.getItem("bmp_sesh");
    var upsellProductId = sessionStorage.getItem("bmu_sesh");
    // get Ship On data
    let ship_on = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".section-product_main").find(".prod_active div.checked").data("ships-on");
    // Initialize the items array
    var items = [
        {
            id: mainProductId,
            quantity: 1,
            properties: {
                "Ship On": ship_on
            }
        }
    ];
    // Add upsell product if available
    if (upsellProductId) {
        let ship_on_cs = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".section-product_main").find(".prod_active div.upsell_Active").data("ships-on");
        items.push({
            id: upsellProductId,
            quantity: 1,
            properties: {
                "Ship On": ship_on_cs
            }
        });
    }
    // Function to add a single item to the cart
    function addItemToCart(item, callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: "POST",
            url: "/cart/add.js",
            data: item,
            dataType: "json",
            success: function(response) {
                //console.log(`Product ${item.id} added to cart!`);
                if (callback) callback();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#upsell_atc_bm #add-to-cart-button").prop("disabled", false);
            },
            error: function(xhr, status, error) {
                //console.log(`Failed to add product ${item.id} to cart.`, xhr.responseText);
                if (callback) callback(error);
            }
        });
    }
    // Recursive function to add all items
    function addAllItems(items, index = 0) {
        if (index >= items.length) {
            // All items processed
            $52772a3ac0d5fa22$var$updateMinicart();
            $52772a3ac0d5fa22$var$refreshRecommend();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-minicart]").addClass("is-open");
            return;
        }
        addItemToCart(items[index], function(error) {
            if (error) // console.log('Stopping further requests due to an error.');
            return;
            // Process next item
            addAllItems(items, index + 1);
        });
    }
    // Start adding items
    addAllItems(items);
});
// CART CROSS-SELL
function $52772a3ac0d5fa22$var$checkCartAndFetchCrossSell() {
    // List your handles
    const ProductHandles_1 = [
        "the-mini-by-beast"
    ];
    const ProductHandles_2 = [
        "the-mini-by-beast-plus"
    ];
    const ProductHandles_3 = [
        "b10-health-blender"
    ];
    const ProductHandles_4 = [
        "beastmode-blender"
    ];
    const ProductHandles_5 = [
        "b10-full-system"
    ];
    const ProductHandles_6 = [
        "beastmode-blender"
    ];
    // List your collections
    const collection_1 = "cs_mini_base";
    const collection_2 = "cs_mini_plus";
    const collection_3 = "cs_beast_base";
    const collection_4 = "cs_beast_base";
    const collection_5 = "cs_beast_plus";
    const collection_6 = "cs_beast_plus";
    // List your upsell collections
    const collection_upsell_1 = "us_mini_base";
    const collection_upsell_2 = "";
    const collection_upsell_3 = "us_b10_base";
    const collection_upsell_4 = "us_beastmode_base";
    const collection_upsell_5 = "";
    const collection_upsell_6 = "";
    fetch("/cart.js").then((response)=>response.json()).then((cart)=>{
        const crossSellContainer = document.getElementById("cross-sell-container");
        const isMobile = window.innerWidth < 990;
        const upsellContainer = isMobile ? document.getElementById("upsell-container-mobile") : document.getElementById("upsell-container");
        if (!crossSellContainer && !upsellContainer) return;
        if (cart.items.length === 0) {
            if (crossSellContainer) crossSellContainer.innerHTML = ""; // Clear the container if the cart is empty
            if (upsellContainer) upsellContainer.innerHTML = ""; // Clear the upsell container if the cart is empty
            return;
        }
        // Collect the handles of items in the cart
        const cartHandles = cart.items.map((item)=>item.handle);
        // Check for matching products in the cart
        let matchingProductHandles = [
            {
                handles: ProductHandles_1,
                collection: collection_1,
                upsell: collection_upsell_1
            },
            {
                handles: ProductHandles_2,
                collection: collection_2,
                upsell: collection_upsell_2
            },
            {
                handles: ProductHandles_3,
                collection: collection_3,
                upsell: collection_upsell_3
            },
            {
                handles: ProductHandles_4,
                collection: collection_4,
                upsell: collection_upsell_4
            },
            {
                handles: ProductHandles_5,
                collection: collection_5,
                upsell: collection_upsell_5
            },
            {
                handles: ProductHandles_6,
                collection: collection_6,
                upsell: collection_upsell_6
            }
        ];
        let foundItem = null;
        let selectedCollection = "";
        let selectedUpsellCollection = "";
        for (const productGroup of matchingProductHandles)if (productGroup.handles.length > 0) {
            foundItem = cart.items.find((item)=>productGroup.handles.includes(item.handle));
            if (foundItem) {
                selectedCollection = productGroup.collection;
                selectedUpsellCollection = productGroup.upsell;
                break;
            }
        }
        // Clear containers initially
        if (crossSellContainer) crossSellContainer.innerHTML = "";
        if (upsellContainer) upsellContainer.innerHTML = "";
        // Fetch the cross-sell collection if defined
        if (selectedCollection) fetch(`/collections/${selectedCollection}/products.json`).then((response)=>response.json()).then((crossSellData)=>{
            const filteredCrossSellProducts = crossSellData.products.filter((product)=>!cartHandles.includes(product.handle));
            $52772a3ac0d5fa22$var$renderProducts(filteredCrossSellProducts, foundItem.variant_title, crossSellContainer, "cross-sell", true);
        }).catch((error)=>console.error("Error fetching collection:", error));
        // Fetch the upsell collection if defined
        if (selectedUpsellCollection) fetch(`/collections/${selectedUpsellCollection}/products.json`).then((response)=>response.json()).then((upsellData)=>{
            const filteredUpsellProducts = upsellData.products.filter((product)=>!cartHandles.includes(product.handle));
            $52772a3ac0d5fa22$var$renderProducts(filteredUpsellProducts, foundItem.variant_title, upsellContainer, "upsell", false);
        }).catch((error)=>console.error("Error fetching upsell collection:", error));
        // If neither collection is defined, do nothing
        if (!selectedCollection && !selectedUpsellCollection) {
            if (crossSellContainer) crossSellContainer.innerHTML = "";
            if (upsellContainer) upsellContainer.innerHTML = "";
        }
    }).catch((error)=>console.error("Error fetching cart:", error));
}
function $52772a3ac0d5fa22$var$renderProducts(products, selectedColor, container, type, isSlider) {
    if (!container) return;
    // Clear previous content
    container.innerHTML = "";
    // Create a title for the section
    let titleXsell = `<h4>You might also like:</h4>`;
    let titleUpsell = `<h3>Discover the next level</h3>`;
    container.innerHTML += titleXsell;
    // Filter products based on the selected color or "Default Title"
    const filteredProducts = products.filter((product)=>product.variants.some((variant)=>variant.option1 === selectedColor || variant.option1 === "Default Title"));
    if (isSlider) {
        // Create a slider container
        let sliderHTML = `<div class="${type}_slider" data-slider>`;
        filteredProducts.forEach((product)=>{
            const matchingVariant = product.variants.find((variant)=>variant.option1 === selectedColor || variant.option1 === "Default Title");
            if (matchingVariant) // Render product in slider format
            sliderHTML += `
          <div class="minicart__item crossell_item crossell-${matchingVariant.available}">
            <a class="minicart__item-main no-hover-link">
              <img class="minicart__item-image" src="${matchingVariant.featured_image.src}" alt="${matchingVariant.featured_image.alt}">
            </a>
            <div class="minicart__item-info">
              <div class="minicart__item-title">
                <a href="/products/${product.handle.replace(/-xsell$/, "")}?variant=${matchingVariant.id}">${product.title}</a>
              </div>
              <div class="minicart__item-list">
                <div class="minicart__item-price">
                  <span class="org_price localized-price">$${matchingVariant.price}</span>
                  ${matchingVariant.compare_at_price != null ? `<span class="compare_price localized-price">$${matchingVariant.compare_at_price}</span>` : ""}
                </div>
              </div>
              <form class="upsell_atc" data-variant-id="${matchingVariant.id}"">
                <button type="submit" class="add-to-cart-button d-flex button_style_button2">Add</button>
              </form>
            </div>
          </div>
        `;
        });
        sliderHTML += `</div>`;
        container.innerHTML += sliderHTML;
        // Destroy any previous instance of Slick slider before initializing
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.${type}_slider`).hasClass("slick-initialized")) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.${type}_slider`).slick("unslick");
        // Initialize the Slick Slider after content is added
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.${type}_slider`).slick({
                slidesToShow: 1,
                infinite: true,
                slidesToScroll: 1,
                dots: true,
                arrows: false
            });
        });
    } else {
        // Render upsell products in card format
        let upsellHTML = `<div class="upsell-inner-wrap usell_slider" data-slider>`;
        filteredProducts.forEach((product)=>{
            const matchingVariant = product.variants.find((variant)=>variant.option1 === selectedColor || variant.option1 === "Default Title");
            if (matchingVariant) // Render product in card format
            upsellHTML += `
          <div class="upsell_item upsell-${matchingVariant.available}">
            <a class="minicart__item-main">
              <img class="minicart__item-image" src="${matchingVariant.featured_image.src}" alt="${matchingVariant.featured_image.alt}">
            </a>
            <div class="minicart__item-info">
              <div class="minicart__item-title">
                <a href="/products/${product.handle.replace(/-xsell$/, "")}?variant=${matchingVariant.id}">${product.title}</a>
              </div>
              <div class="minicart__item-list">
                <div class="minicart__item-price">
                  <span class="org_price localized-price">$${matchingVariant.price}</span>
                  ${matchingVariant.compare_at_price != null ? `<span class="compare_price localized-price">$${matchingVariant.compare_at_price}</span>` : ""}
                </div>
              </div>
              <form class="upsell_atc" data-variant-id="${matchingVariant.id}">
                <button type="submit" class="add-to-cart-button">Upgrade your Beast<span>\u{2122}</span></button>
              </form>
            </div>
          </div>
        `;
        });
        upsellHTML += `</div>`;
        container.innerHTML += titleUpsell += upsellHTML;
        // Destroy any previous instance of Slick slider before initializing
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.usell_slider`).hasClass("slick-initialized")) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.usell_slider`).slick("unslick");
        // Initialize the Slick Slider for upsell products
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".usell_slider").slick({
                slidesToShow: 3,
                infinite: true,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 989,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    }
    // Bind the add-to-cart function for upsell items
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".upsell_atc").on("submit", function(event) {
        event.preventDefault();
        const variantId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-id");
        const formData = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        "Exclusive Offer": "Cart"
                    }
                }
            ]
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            url: "/cart/add.js",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(formData),
            dataType: "json",
            success: function(data) {
                $52772a3ac0d5fa22$var$updateMinicart();
                $52772a3ac0d5fa22$var$refreshRecommend();
            },
            error: function(jqXHR) {
                console.error("There was a problem with the fetch operation:", jqXHR.responseText);
            }
        });
    });
}
// Ship On Data Check - Runs in updateMinicart
function $52772a3ac0d5fa22$var$checkShipOnProperty() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function(cart) {
            //console.log(cart);
            // Flag to check if any item has the 'Ship On' property
            var hasShipOnProperty = false;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).each(cart.items, function(index, item) {
                // console.log(item);
                // Check if the item has the 'Ship On' property
                if (item.properties && item.properties["Ship On"]) {
                    // Log the 'Ship On' property for debugging
                    // console.log("Product has Ship On:", item.properties["Ship On"]);
                    // Set the flag to true since we found the property
                    hasShipOnProperty = true;
                    // Find the corresponding .minicart__item element in the DOM
                    var minicartItem = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".minicart__item .mini-cart-ships-on").eq(index);
                    // Check if the .shipon_msg div already exists for this item
                    if (minicartItem.find(".shipon_msg").length === 0) {
                        // Remove any existing .shipon_msg before appending the new one
                        minicartItem.find(".shipon_msg").remove();
                        // Create a new div to append to the minicart item
                        var shipOnDiv = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('<div class="shipon_msg"></div>').text(item.properties["Ship On"]); // Set the content of the div
                        // Append the new div to the minicart item
                        minicartItem.append(shipOnDiv);
                    }
                }
            });
        // Log if no item in the cart has the 'Ship On' property
        // if (!hasShipOnProperty) {
        //   console.log('No product in cart has the "Ship On" date.');
        // }
        },
        error: function(xhr, status, error) {
            console.error("Error checking cart:", error);
        }
    });
}




var $iUSsr = parcelRequire("iUSsr");




var $iUSsr = parcelRequire("iUSsr");
const $4f0aa0cd93a68fcc$var$selectors = {
    body: "body.template-product-bundle",
    wrapper: ".product-feature_images",
    row: ".row_wrapper",
    btnShowMore: ".product-feature-more",
    collapsedWrapper: ".product-feature_images-bottom"
};
function $4f0aa0cd93a68fcc$export$2e2bcd8739ae039() {
    const isBundle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`${$4f0aa0cd93a68fcc$var$selectors.body}`);
    const $showMoreBtn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`${$4f0aa0cd93a68fcc$var$selectors.btnShowMore}`);
    const btnTitle = $showMoreBtn.find('span').attr('data-title');
    const btnCollapseTitle = $showMoreBtn.find('span').attr('data-collapse-title');
    if (isBundle.length > 0) {
        const $collapsedWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`${$4f0aa0cd93a68fcc$var$selectors.collapsedWrapper}`);
        function showHideContent(elem) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(elem).toggleClass('active');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(elem).hasClass('active')) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(elem).find('span').text(btnCollapseTitle);
                $collapsedWrapper.slideDown(400);
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(elem).find('span').text(btnTitle);
                $collapsedWrapper.slideUp(400);
            }
        }
        $showMoreBtn.on('click', function() {
            showHideContent(this);
        });
    } else {
        const $wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`${$4f0aa0cd93a68fcc$var$selectors.wrapper}`);
        let originalHeight, initialHeight;
        setTimeout(function() {
            originalHeight = $wrapper.height();
            initialHeight = $wrapper.find(`${$4f0aa0cd93a68fcc$var$selectors.row}`).eq(0).height();
            $wrapper.css('height', initialHeight);
        });
        $showMoreBtn.click(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass('active');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('active')) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('span').text('see less');
                $wrapper.css('height', originalHeight);
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('span').text(btnTitle);
                $wrapper.css('height', initialHeight);
            }
        });
    }
}



function $3b8b94fa989699a9$var$reinitAllFunction() {
    $0d840adb65d390a7$export$2e2bcd8739ae039();
    $09bbf9086b09b2ab$export$2e2bcd8739ae039();
    $4d3add7eda271e10$export$2e2bcd8739ae039();
    $4f0aa0cd93a68fcc$export$2e2bcd8739ae039();
//swatches.default();
}
function $3b8b94fa989699a9$var$changeProduct(evt) {
    let $currentUrl = evt.target.value;
    let selectors = {
        reviews: '.review-carousel__heading-review',
        reviewsSection: '.review-carousel__real-reviews',
        productMainImages: '.product-main__left',
        productLogoSlider: '.product-main__right .logo_slider',
        headingWrapper: '.product-main__right .product-top-info__heading-wrapper',
        stickyBottom: '.sticky-bottom-wrapper',
        stickyButton: '.sticky-bottom--button',
        form: '.product-main__right .product-form--bundle',
        feature_section: '.product-feature',
        product_video: '#product-video',
        product_info: '.product-main__right .faq-main',
        paymentTherms: '.product-payment-terms',
        amazonBTN: '#amzn-buy-now'
    };
    const selectorsValues = Object.values(selectors);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
        url: $currentUrl,
        method: 'GET',
        success: function(data) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).each(selectorsValues, function(index, item) {
                const dataBlock = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(data).find(item);
                dataBlock.length ? (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).replaceWith(dataBlock).fadeIn() : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item).fadeOut();
            });
        },
        complete: function(data) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#addToCartForm .product-add-to-cart").data("top", (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#addToCartForm .product-add-to-cart").offset().top); //for index.js
            $3b8b94fa989699a9$var$reinitAllFunction();
            $3b8b94fa989699a9$var$customFetch();
        }
    });
}
function $3b8b94fa989699a9$var$customFetch() {
    let prime_widget_elem = document.getElementById('amzn-buy-now').getAttribute('data-sku');
    if (bwp) bwp.updateWidget(`${prime_widget_elem}`);
}
function $3b8b94fa989699a9$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-switcher input[type=radio]').on('change', (evt)=>{
        $3b8b94fa989699a9$var$changeProduct(evt);
    });
}



var $iUSsr = parcelRequire("iUSsr");
function $f4284bbd181684e7$export$2e2bcd8739ae039() {
    const $megamenuContents = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-parent-link]");
    $megamenuContents.each(function(index, megamenuContent) {
        const parentLink = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(megamenuContent).data("parent-link");
        if (parentLink != "") // Desktop nav only: the same menu markup is emitted twice, so an unscoped
        // selector also dropped a copy in the drawer. The drawer uses mobileMenu.js.
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".site-header__nav [data-megamenu=" + parentLink + "]").addClass("has-megamenu").append((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(megamenuContent).parent().html());
    });
    let hoverTimer;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-megamenu].has-megamenu").on("mouseenter", function() {
        clearTimeout(hoverTimer);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").addClass("megamenu-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".menu-overlay").addClass("visible");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-megamenu].has-megamenu").on("mouseleave", function() {
        hoverTimer = setTimeout(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".menu-overlay").removeClass("visible");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").removeClass("megamenu-open");
        }, 0); // Adjust the delay time as needed
    });
}


/**
 * Mobile menu panel stack.
 *
 * L2 panels are rendered by their own mega-menu section and MOVED here with
 * appendChild, never innerHTML, so no id is duplicated.
 *
 * A row is expandable only when a matching data-mobile-panel exists: data-megamenu is
 * emitted on every link block, so its presence proves nothing.
 */ const $8d49a7d8198705c0$var$MOBILE_BREAKPOINT = 990;
function $8d49a7d8198705c0$export$2e2bcd8739ae039() {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    if (window.innerWidth >= $8d49a7d8198705c0$var$MOBILE_BREAKPOINT) return;
    const root = menu.querySelector('[data-mobile-panel="root"]');
    if (!root) return;
    const panels = document.querySelectorAll('[data-mobile-panel]:not([data-mobile-panel="root"])');
    if (!panels.length) return;
    const openPanel = (panel)=>{
        panel.hidden = false;
        // Next frame, so the panel is laid out before the transition starts.
        requestAnimationFrame(()=>{
            panel.classList.add('is-active');
            menu.classList.add('is-nested');
        });
    };
    const closePanels = (animate)=>{
        menu.classList.remove('is-nested');
        menu.querySelectorAll('[data-mobile-panel].is-active').forEach((panel)=>{
            if (panel === root) return;
            panel.classList.remove('is-active');
            if (animate) window.setTimeout(()=>{
                panel.hidden = true;
            }, 300);
            else panel.hidden = true;
        });
    };
    panels.forEach((panel)=>{
        const id = panel.getAttribute('data-mobile-panel');
        const row = root.querySelector('[data-megamenu="' + id + '"]');
        if (!row) return;
        menu.appendChild(panel);
        const link = row.querySelector('a');
        if (!link) return;
        row.classList.add('has-panel');
        // Label follows the row's text: the panel's section cannot see the block title.
        const label = panel.querySelector('[data-mobile-menu-back-label]');
        if (label) label.textContent = link.textContent.trim();
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
        link.addEventListener('click', (event)=>{
            event.preventDefault();
            link.setAttribute('aria-expanded', 'true');
            openPanel(panel);
        });
        const back = panel.querySelector('[data-mobile-menu-back]');
        if (back) back.addEventListener('click', ()=>{
            link.setAttribute('aria-expanded', 'false');
            closePanels(true);
        });
    });
    // Always reopen at the root. Reset on every toggle rather than reading
    // is-menu-open, whose value here depends on handler registration order.
    document.querySelectorAll('[data-open-menu]').forEach((toggle)=>{
        toggle.addEventListener('click', ()=>closePanels(false));
    });
}



var $iUSsr = parcelRequire("iUSsr");
function $48dca9a681ac1549$export$2e2bcd8739ae039() {
    function getScope($el) {
        const $scope = $el.closest('[id^="shopify-section-"]');
        return $scope.length ? $scope : (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document);
    }
    function filterFAQs(search_q, $scope) {
        const query = (search_q || '').toLowerCase().trim();
        const searchTerms = query.length ? query.split(/\s+/).filter(Boolean) : [];
        if (!query) {
            const $accordions = $scope.find('[data-accordion]');
            $accordions.removeAttr('data--hidden').show();
            $accordions.find('[data-subaccordion]').hide().removeAttr('data--hidden');
            $accordions.find('[data-accordion-title]').removeClass('is-open');
            const $firstAccordion = $accordions.eq(0);
            $firstAccordion.find('[data-accordion-title]').addClass('is-open');
            $firstAccordion.find('[data-subaccordion]').show();
            return;
        }
        $scope.find('[data-accordion]').each(function() {
            const $accordion = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            const $title = $accordion.find('h2.faq-item__title span').first().text().toLowerCase();
            const titleMatches = $title.includes(query);
            let hasVisibleSubitems = false;
            $accordion.find('[data-subaccordion]').each(function() {
                const $subitem = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                const $subtitle = $subitem.find('.faq-item__subtitle span').first().text().toLowerCase();
                const allTermsMatch = titleMatches || searchTerms.every((term)=>$subtitle.includes(term));
                if (allTermsMatch) {
                    hasVisibleSubitems = true;
                    $subitem.removeAttr('data--hidden').show();
                } else $subitem.attr('data--hidden', 'true').hide();
            });
            if (titleMatches || hasVisibleSubitems) {
                $accordion.removeAttr('data--hidden').show();
                $accordion.find('[data-accordion-title]').addClass('is-open');
            } else {
                $accordion.attr('data--hidden', 'true').hide();
                $accordion.find('[data-accordion-title]').removeClass('is-open');
            }
        });
    }
    // Trigger search overlay
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-show-search-trigger]').on('click', function() {
        var display_mode = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('search-style');
        if (display_mode === "overlay") {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-overlay-search]').toggleClass('is_active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-popup='search-popup']").addClass('is-hidden');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-faq-search]').first().trigger('focus');
        }
    });
    // Search button click event
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-faq-search-btn]').on('click', function() {
        const $scope = getScope((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
        const search_q = $scope.find('[data-faq-search]').first().val() || '';
        filterFAQs(search_q, $scope);
    });
    // Search input keypress event (Enter key)
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-faq-search]').on('keydown', function(evt) {
        if (evt.key === 'Enter') {
            const $scope = getScope((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
            const search_q = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).val() || '';
            filterFAQs(search_q, $scope);
        }
    });
    // Close search
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.search-close').on('click', function() {
        const $scope = getScope((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this));
        $scope.find('[data-faq-search]').val('').attr('placeholder', 'Search FAQs...');
        filterFAQs('', $scope);
        $scope.find('[data-accordion]').removeAttr('data--hidden').show();
        $scope.find('[data-subaccordion]').hide();
        $scope.find('[data-accordion-title]').removeClass('is-open');
        const $firstAccordion = $scope.find('.faq-item.accordion').eq(0);
        $firstAccordion.removeAttr('data--hidden').show();
        $firstAccordion.find('[data-accordion-title]').addClass('is-open');
        $firstAccordion.find('[data-subaccordion]').show();
    });
}



var $iUSsr = parcelRequire("iUSsr");
const $c48879bd984a8cbb$var$$quickViewPopup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-quick-view-popup]');
const $c48879bd984a8cbb$var$initImageSlider = function($productMainDom) {
    const $productSlider = $productMainDom.find('[data-ps]');
    $productSlider.on('init', function() {
        $productSlider.addClass('is-visible');
    });
    const slider = $productSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false
    });
};
const $c48879bd984a8cbb$var$initProductForm = function($productMainDom) {
    const defaultOption = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-product-option]');
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(defaultOption[0]).trigger('click');
};
function $c48879bd984a8cbb$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '[data-quick-view]', function() {
        const productHandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('quick-view');
        $c48879bd984a8cbb$var$$quickViewPopup.find('.popup-window').html('');
        $c48879bd984a8cbb$var$$quickViewPopup.removeClass('is-hidden');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            url: "/products/" + productHandle,
            type: 'GET',
            data: {
                view: 'quickview'
            },
            success: function(res) {
                let $resultDom = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(res);
                console.log($resultDom.find('.product-main'));
                $c48879bd984a8cbb$var$$quickViewPopup.find('.popup-window').html($resultDom.find('.product-main').html());
                setTimeout(()=>{
                    $c48879bd984a8cbb$var$initImageSlider($c48879bd984a8cbb$var$$quickViewPopup.find('.product-main__container'));
                    $c48879bd984a8cbb$var$initProductForm($c48879bd984a8cbb$var$$quickViewPopup.find('.product-main__container'));
                }, 100);
            }
        });
    });
}



var $iUSsr = parcelRequire("iUSsr");
function $6262cca4805b33a2$export$2e2bcd8739ae039() {
    //case ea-section-product page
    var blocks = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-product_block');
    for(var i = 0; i < blocks.length; i++)(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".section-product_block" + i).click(function() {
        var id = this.id;
        var option = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('option-title');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product_img").attr("src", id);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-option-name]").text(option);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-image_blockicon').removeClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".section-image_blockicon").addClass('checked');
    });
    //case product-form page
    var features = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-benefits');
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.product-benefits', function() {
        var option = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-product-description');
        var $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#produc-feature_content");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#produc-feature_content");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-type') == 'desc') {
            option = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-product-desc]").html();
            $target.attr('data-content-type', 'desc');
        } else $target.removeAttr('data-content-type');
        $target.html(option);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-benefits').removeClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('checked');
    });
}




var $iUSsr = parcelRequire("iUSsr");
function $846095188e74f4b9$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.add-subscription-block span, .add-subscription-block svg', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#ReCharge').remove();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#shopify-section-product-add-subscription').show();
        const $productSlider = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-ps-subscription]');
        const $productThumbSlider = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-thumb-subscription]');
        if ($productSlider.length) {
            $productSlider.on('init', function() {
                $productSlider.addClass('is-visible');
            });
            const slider = $productSlider.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                asNavFor: '.product-thumbs-slider'
            });
            const thumbSlider = $productThumbSlider.slick({
                focusOnSelect: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                asNavFor: '.product-slider'
            });
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-all-variants]').trigger('change');
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-charge-date]').val(today);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-add-to-subscription]').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var url = '/tools/recurring/portal/' + window.customerHash + '/request_objects?token=' + window.customerToken;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            type: 'get',
            url: url,
            dataType: 'json',
            data: {
                schema: '{ "addresses": { "discount": { "id": "parent.discount_id" }}, "customer": {}, "settings": {} }'
            }
        }).done(function(response) {
            // Successful request made
            const addressId = response['addresses'][0]['id'];
            const variantId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-all-variants]').val();
            let quantity = 4;
            const chargeDate = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-charge-date]').val();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-product-option=1]').val() == 'Duo') quantity = 2;
            url = '/tools/recurring/portal/' + window.customerHash + '/subscriptions?token=' + window.customerToken;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
                type: 'post',
                url: url,
                dataType: 'json',
                data: {
                    shopify_variant_id: variantId,
                    order_interval_frequency: "4",
                    order_interval_unit: "month",
                    charge_interval_frequency: 4,
                    next_charge_scheduled_at: chargeDate,
                    address_id: addressId,
                    quantity: 4
                }
            }).done(function(response) {
                // Successful request made
                window.console.log(response);
                window.location.href = '/tools/recurring/login';
                return response;
            }).fail(function(response) {
                // Request failed
                window.console.error(response);
                return response;
            }).always(function() {
                delete window.locked;
            });
        }).fail(function(response) {
            // Request failed
            window.console.error(response);
        });
    });
}


function $112f3e990e5bf005$export$2e2bcd8739ae039() {
    if (!customElements.get('video-component')) {
        class YoutubeVimeoVideo extends HTMLElement {
            constructor(){
                super();
                this.options = JSON.parse(this.dataset.videoOptions);
                if (!this.options['videoType']) return;
                this.playerInner = this.querySelector('.js-video-mount');
                this.playBtn = this.querySelector('.js-video-play-button');
                this.pauseBtn = this.querySelector('.js-video-pause-button');
                this.muteBtn = this.querySelector('.js-video-mute-button');
                this.unMuteBtn = this.querySelector('.js-video-unmute-button');
                this.customVideo = this.querySelector('video');
                this.parent = this.parentElement;
                this.poster = this.querySelector('.js-video-poster');
                if (this.poster) this.posterBtn = this.poster.querySelector('svg');
                this.getAspectRatio();
                this.loadScript().then(this.setupPlayer.bind(this));
                this.initEvents();
            }
            initEvents() {
                if (this.playBtn) this.playBtn.addEventListener('click', ()=>this.playerPlay());
                if (this.pauseBtn) this.pauseBtn.addEventListener('click', ()=>this.playerPause());
                if (this.muteBtn) this.muteBtn.addEventListener('click', ()=>this.playerMute());
                if (this.unMuteBtn) this.unMuteBtn.addEventListener('click', ()=>this.playerUnMute());
                if (this.poster) this.posterBtn.addEventListener('click', ()=>this.playerPlay());
                if (this.poster) this.poster.addEventListener('click', ()=>this.playerPlay());
            }
            initPlayerEvents(player) {
                if (this.customVideo) ;
                else {
                    if (this.options['videoType'] !== 'vimeo') {
                        if (player) player.addEventListener('onStateChange', (e)=>{
                            if (e.data === 1) {
                                this.showHideButton(this.playBtn, false);
                                this.showHideButton(this.pauseBtn, true);
                            } else if (e.data === 2) {
                                this.showHideButton(this.playBtn, true);
                                this.showHideButton(this.pauseBtn, false);
                            }
                        });
                    } else {
                        if (player) player.on('play', (e)=>{
                            this.showHideButton(this.playBtn, false);
                            this.showHideButton(this.pauseBtn, true);
                        });
                        if (player) player.on('pause', (e)=>{
                            this.showHideButton(this.playBtn, true);
                            this.showHideButton(this.pauseBtn, false);
                        });
                    }
                }
            }
            loadScript() {
                return new Promise((resolve, reject)=>{
                    const script = document.createElement('script');
                    document.body.appendChild(script);
                    script.async = true;
                    script.src = this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
                    script.onload = resolve;
                    script.onerror = reject;
                });
            }
            getAspectRatio() {
                if (this.customVideo) return;
                let url = '';
                if (this.options['videoType'] === 'youtube') url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${this.options['videoId']}`;
                else url = `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.options['videoId']}`;
                fetch(url).then((response)=>response.json()).then((responseJson)=>{
                    if (!responseJson) return;
                    const aspectRatio = responseJson.width / responseJson.height;
                    if (this.parent) this.parent.style.setProperty('--aspect-ratio', `${aspectRatio}`);
                });
            }
            setupPlayer() {
                if (this.customVideo) this.onPlayerReady();
                else {
                    const playerLoadingInterval = setInterval(()=>{
                        this.options['videoType'] === 'youtube' ? this.youtubeSetup(playerLoadingInterval) : this.vimeoSetup(playerLoadingInterval);
                    }, 200);
                }
            }
            youtubeSetup(playerLoadingInterval) {
                if (window.YT !== undefined && window.YT.Player !== undefined) {
                    this.player = new YT.Player(this.playerInner, {
                        videoId: this.options['videoId'],
                        playerVars: {
                            autoplay: this.options['autoplay'],
                            controls: this.options['controls'],
                            rel: 0,
                            height: '100%',
                            width: '100%',
                            iv_load_policy: 3,
                            loop: 1,
                            playsinline: 1,
                            modestbranding: 1,
                            showinfo: 0,
                            origin: this.options['requestHost']
                        },
                        events: {
                            onReady: ()=>{
                                this.onPlayerReady();
                            },
                            onStateChange: (e)=>{
                                if (e.data === window.YT.PlayerState.ENDED) e.target.seekTo(0);
                            }
                        }
                    });
                    clearInterval(playerLoadingInterval);
                }
            }
            vimeoSetup(playerLoadingInterval) {
                if (window.Vimeo) {
                    this.player = new Vimeo.Player(this.playerInner, {
                        id: this.options['videoId'],
                        controls: this.options['controls'],
                        muted: true,
                        loop: true
                    });
                    this.player.ready().then(()=>{
                        this.onPlayerReady();
                        this.getAspectRatio();
                    });
                    clearInterval(playerLoadingInterval);
                }
            }
            onPlayerReady() {
                if (this.options['autoplay']) this.autoPlay();
                this.classList.add('is-loaded');
                this.initPlayerEvents(this.player);
            }
            autoPlay() {
                this.playerMute();
                this.playerPlay();
                this.classList.add('is-playing');
            }
            playerPlay() {
                if (this.customVideo) this.customVideo.play();
                else this.options['videoType'] === 'youtube' ? this.player.playVideo() : this.player.play();
                this.classList.add('is-playing');
                this.showHideButton(this.playBtn, false);
                this.showHideButton(this.pauseBtn, true);
                this.hideElement(this.poster);
            }
            hideElement(element) {
                if (element) element.classList.add('visually-hidden');
                if (this.posterBtn) this.posterBtn.removeEventListener('click', ()=>this.playerPlay());
            }
            showHideButton(button, show = false) {
                if (!button) return;
                if (show) {
                    button.style.opacity = 1;
                    button.style.visibility = 'visible';
                } else {
                    button.style.opacity = 0;
                    button.style.visibility = 'hidden';
                }
            }
            playerPause() {
                if (this.customVideo) this.customVideo.pause();
                else this.options['videoType'] === 'youtube' ? this.player.pauseVideo() : this.player.pause();
                this.classList.remove('is-playing');
                this.showHideButton(this.playBtn, true);
                this.showHideButton(this.pauseBtn, false);
            }
            playerMute() {
                if (this.customVideo) this.customVideo.muted = true;
                else this.options['videoType'] === 'youtube' ? this.player.mute() : this.player.setMuted(true);
                this.classList.add('is-muted');
            }
            playerUnMute() {
                if (this.customVideo) this.customVideo.muted = false;
                else this.options['videoType'] === 'youtube' ? this.player.unMute() : this.player.setMuted(false);
                this.classList.remove('is-muted');
            }
        }
        customElements.define('video-component', YoutubeVimeoVideo);
    }
}


function $af17ce3e8da8c71c$export$2e2bcd8739ae039() {
    if (!customElements.get('tabs-component')) {
        class TabsComponent extends HTMLElement {
            constructor(){
                super();
                this.selectors = {
                    tabButtonsContainer: '[role="tablist"]',
                    tabButton: '[role="tab"]',
                    tabPanel: '[role="tabpanel"]'
                };
            }
            connectedCallback() {
                if (!this.querySelector(this.selectors.tabButtonsContainer)) return;
                this.tabs = Array.from(this.querySelector(this.selectors.tabButtonsContainer).querySelectorAll(this.selectors.tabButton));
                this.tabpanels = Array.from(this.querySelectorAll(this.selectors.tabPanel));
                this.preventOnClick = this.getAttribute('data-prevent-on-click') === 'true';
                this.querySelector(this.selectors.tabButtonsContainer).addEventListener('click', this.onClick.bind(this));
                this.querySelector(this.selectors.tabButtonsContainer).addEventListener('change', this.onClick.bind(this));
                this.querySelector(this.selectors.tabButtonsContainer).addEventListener('keydown', this.onKeyDown.bind(this));
            }
            onClick(event) {
                if (this.preventOnClick) event.preventDefault();
                const target = event.target;
                if (event.type === 'change') {
                    const tabButton = this.tabs.find((tab)=>tab.getAttribute('aria-controls') === target.value);
                    if (tabButton) tabButton.click();
                    return;
                }
                if (target.getAttribute('role') === 'tab' || target.closest(this.selectors.tabButton)) this.onTabClick(event);
            }
            onTabClick(event) {
                const target = event.target;
                const tab = target.getAttribute('role') === 'tab' ? target : target.closest(this.selectors.tabButton);
                if (!tab) return;
                tab.getAttribute('aria-controls') === 'show-all-tabs' ? this.showAllTabs(tab) : this.setSelectedTab(tab);
            }
            setSelectedToPreviousTab(tab) {
                let index;
                if (tab === this.tabs[0]) this.setSelectedTab(tab);
                else {
                    index = this.tabs.indexOf(tab);
                    this.setSelectedTab(this.tabs[index - 1], true);
                }
            }
            setSelectedToNextTab(tab) {
                let index;
                if (tab === this.tabs[this.tabs.length - 1]) this.setSelectedTab(tab);
                else {
                    index = this.tabs.indexOf(tab);
                    this.setSelectedTab(this.tabs[index + 1], true);
                }
            }
            setSelectedTab(tab, focus = false) {
                const tabPanelId = tab.getAttribute('aria-controls');
                const tabPanelElement = this.querySelector(`#${tabPanelId}`);
                const tabPanelsArray = Array.from(this.querySelectorAll(`[data-tab-id='${tabPanelId}']`));
                if (typeof focus !== 'boolean') focus = true;
                //Change tabs active buttons
                this.changeActiveTabButton(tab, focus);
                //Change tabs active content blocks
                if (tabPanelElement) this.showSingleTab(tabPanelElement);
                if (tabPanelsArray.length) this.showMultipleTabs(tabPanelsArray);
                if (tabPanelId === 'show-all-tabs') this.showAllTabs(tab);
            }
            showSingleTab(tabPanelElement) {
                const panelParent = tabPanelElement.parentNode;
                const panelParentChilds = Array.from(panelParent.children);
                for(let i = 0; i < panelParentChilds.length; i++){
                    if (panelParentChilds[i].getAttribute('role') !== 'tabpanel') continue;
                    panelParentChilds[i] === tabPanelElement ? this.showPanel(panelParentChilds[i]) : this.hidePanel(panelParentChilds[i]);
                }
            }
            showMultipleTabs(tabPanelsArray) {
                this.tabpanels.forEach((panel)=>tabPanelsArray.includes(panel) ? this.showPanel(panel) : this.hidePanel(panel));
            }
            hidePanel(panel) {
                panel.setAttribute('hidden', true);
                panel.removeAttribute('aria-selected', true);
                panel.tabIndex = -1;
            }
            showPanel(panel) {
                panel.removeAttribute('hidden');
                panel.setAttribute('aria-selected', true);
                panel.tabIndex = 0;
            }
            onKeyDown(event) {
                const target = event.target;
                const tab = target.getAttribute('role') === 'tab' ? target : target.closest(this.selectors.tabButton);
                switch(event.key){
                    case 'ArrowLeft':
                        this.setSelectedToPreviousTab(tab);
                        break;
                    case 'ArrowRight':
                        this.setSelectedToNextTab(tab);
                        break;
                    case 'Home':
                        this.setSelectedTab(this.tabs[0], true);
                        break;
                    case 'End':
                        this.setSelectedTab(this.tabs[this.tabs], true);
                        break;
                    default:
                        break;
                }
            }
            changeActiveTabButton(tab, focus) {
                tab.closest(this.selectors.tabButtonsContainer).querySelectorAll(this.selectors.tabButton).forEach((item)=>{
                    if (item === tab) {
                        item.setAttribute('aria-selected', true);
                        item.tabIndex = 0;
                        if (focus) item.focus();
                    } else if (item.closest('tabs-component') === this) {
                        item.setAttribute('aria-selected', false);
                        item.tabIndex = -1;
                    }
                });
            }
            showAllTabs(tab) {
                this.changeActiveTabButton(tab, true);
                this.tabpanels.forEach((panel)=>this.showPanel(panel));
            }
        }
        customElements.define('tabs-component', TabsComponent);
    }
}


function $81551a82a638a90d$export$2e2bcd8739ae039() {
    class StickyInfo extends HTMLElement {
        constructor(){
            super();
            this.navHeight = document.querySelector('[data-site-header]').getBoundingClientRect().height || 0;
            this.speedScroll = parseInt(this.getAttribute('data-speed'));
            this.minTop = parseInt(this.getAttribute('data-min-top'));
            this.headerHeight = this.navHeight;
            this.oldPosition = window.scrollY;
            this.windowHeight = window.innerHeight;
            this.infoHeight = this.getBoundingClientRect().height;
            this.differentHeights = this.windowHeight - this.infoHeight + this.headerHeight + 25;
            this.init();
        }
        init() {
            if (this.differentHeights < this.minTop) {
                if (this.oldPosition > this.differentHeights) this.style.top = `${this.windowHeight - this.infoHeight}px`;
                else this.style.top = `${this.oldPosition}px`;
            }
            window.addEventListener('scroll', ()=>{
                const computedStyle = window.getComputedStyle(this);
                const position = computedStyle.position;
                if (position !== 'sticky') return;
                this.currentPosition = window.scrollY;
                this.infoHeight = this.getBoundingClientRect().height;
                this.windowHeight = window.innerHeight;
                if (this.currentPosition > this.oldPosition) {
                    let elTop = parseFloat(this.style.top.replace("px", ""));
                    if (elTop > this.windowHeight - this.infoHeight - this.minTop) this.style.top = `${elTop - this.speedScroll}px`;
                } else if (this.currentPosition < this.oldPosition) {
                    let elTop = parseFloat(this.style.top.replace("px", ""));
                    if (elTop < this.minTop) this.style.top = `${elTop + this.speedScroll}px`;
                }
                this.oldPosition = window.scrollY;
            });
        }
    }
    customElements.define('sticky-info', StickyInfo);
}



var $iUSsr = parcelRequire("iUSsr");
const $e41d4ddccb2b04e1$var$section = "[data-vertical-slider-section]";
const $e41d4ddccb2b04e1$var$slider = "[data-vertical-slider]";
const $e41d4ddccb2b04e1$var$slide = "[data-vertical-slide]";
const $e41d4ddccb2b04e1$var$$header = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#site-header");
const $e41d4ddccb2b04e1$var$$button = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-button]", $e41d4ddccb2b04e1$var$slider);
const $e41d4ddccb2b04e1$var$$controls = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-vertical-slider-controls]", $e41d4ddccb2b04e1$var$slider);
const $e41d4ddccb2b04e1$var$$arrow = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-vertical-slider-arrow]", $e41d4ddccb2b04e1$var$slider);
let $e41d4ddccb2b04e1$var$pageHeight, $e41d4ddccb2b04e1$var$headerHeight, $e41d4ddccb2b04e1$var$sectionHeight;
let $e41d4ddccb2b04e1$var$topCoordinates = [];
let $e41d4ddccb2b04e1$var$idx = 0;
const $e41d4ddccb2b04e1$var$reset = ()=>{
    $e41d4ddccb2b04e1$var$headerHeight, $e41d4ddccb2b04e1$var$pageHeight, $e41d4ddccb2b04e1$var$sectionHeight = 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$slider).removeClass("is-fixed is-hidden");
    $e41d4ddccb2b04e1$var$showSlide("all");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$section).css("height", "auto");
    $e41d4ddccb2b04e1$var$idx = 0;
};
const $e41d4ddccb2b04e1$var$init = ()=>{
    $e41d4ddccb2b04e1$var$reset();
    setTimeout(()=>{
        $e41d4ddccb2b04e1$var$headerHeight = $e41d4ddccb2b04e1$var$$header.outerHeight(); //log({headerHeight});
        $e41d4ddccb2b04e1$var$pageHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerHeight() - $e41d4ddccb2b04e1$var$headerHeight; //log({pageHeight});
        $e41d4ddccb2b04e1$var$sectionHeight = $e41d4ddccb2b04e1$var$getSectionHeight(); //log({slide});
        console.log("height", $e41d4ddccb2b04e1$var$sectionHeight);
        $e41d4ddccb2b04e1$var$updateTopCoordinates();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$section).css({
            height: $e41d4ddccb2b04e1$var$sectionHeight
        });
    }, 100);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$slide).hide().eq(0).show();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll();
    //video auto play
    var scroll_position = setInterval(function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scrollTop() >= $e41d4ddccb2b04e1$var$sectionHeight) {
            var symbol = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#home_video")[0].src.indexOf("?") > -1 ? "&" : "?";
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#home_video")[0].src += symbol + "autoplay=1";
            clearInterval(scroll_position);
        }
    }, 100);
};
const $e41d4ddccb2b04e1$var$getSectionHeight = ()=>{
    return $e41d4ddccb2b04e1$var$pageHeight * (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$slide).length;
};
const $e41d4ddccb2b04e1$var$updateTopCoordinates = ()=>{
    $e41d4ddccb2b04e1$var$topCoordinates = [];
    const sectionTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$section).offset().top;
    for(let i = 0; i < (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$slide).length; i++)$e41d4ddccb2b04e1$var$topCoordinates.push(sectionTop + $e41d4ddccb2b04e1$var$pageHeight * i);
    console.log($e41d4ddccb2b04e1$var$topCoordinates);
};
const $e41d4ddccb2b04e1$var$updateSliderOnScroll = (scroll)=>{
    $e41d4ddccb2b04e1$var$topCoordinates.forEach((topCoordinate, index)=>{
        if (scroll >= topCoordinate) {
            $e41d4ddccb2b04e1$var$showSlide(index);
            $e41d4ddccb2b04e1$var$controlsUpdate(index);
        }
    });
};
const $e41d4ddccb2b04e1$var$showSlide = (index)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$slide).each(function(i, element) {
        if (index === "all") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).show();
        else if (index == i) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).show();
        else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).hide();
    });
};
const $e41d4ddccb2b04e1$var$scrollToSlide = (index)=>{
    $e41d4ddccb2b04e1$var$topCoordinates.forEach(function(topCoordinate, i) {
        if (index == i) {
            let scroll = topCoordinate + 1;
            if (index == 0) scroll = $e41d4ddccb2b04e1$var$topCoordinates[1] - 1;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html,body").animate({
                scrollTop: scroll
            }, "fast");
        }
    });
};
const $e41d4ddccb2b04e1$var$scrollHandler = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        if ($e41d4ddccb2b04e1$var$topCoordinates.length) {
            const scroll = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).scrollTop(); //log({scroll})
            $e41d4ddccb2b04e1$var$updateSliderOnScroll(scroll);
        }
    });
};
const $e41d4ddccb2b04e1$var$controlsHandler = ()=>{
    $e41d4ddccb2b04e1$var$$button.click(function(e) {
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("button");
        $e41d4ddccb2b04e1$var$scrollToSlide(index);
    });
    $e41d4ddccb2b04e1$var$$arrow.click(function(e) {
        $e41d4ddccb2b04e1$var$scrollToSlide($e41d4ddccb2b04e1$var$idx + 1);
    });
};
const $e41d4ddccb2b04e1$var$controlsUpdate = (index)=>{
    const $thisButton = $e41d4ddccb2b04e1$var$$button.eq(index);
    const $thisLi = $e41d4ddccb2b04e1$var$$button.eq(index).parent();
    $e41d4ddccb2b04e1$var$$button.removeClass("is-active");
    $thisButton.addClass("is-active");
    $e41d4ddccb2b04e1$var$idx = index;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989) {
        if (index == 0) {
            $e41d4ddccb2b04e1$var$$controls.css("marginTop", "0px");
            return false;
        }
    }
};
const $e41d4ddccb2b04e1$var$verticalSlider = function(options) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($e41d4ddccb2b04e1$var$section).length) {
        $e41d4ddccb2b04e1$var$init();
        // $(window).resize(init);
        $e41d4ddccb2b04e1$var$scrollHandler();
        $e41d4ddccb2b04e1$var$controlsHandler();
    }
};
var $e41d4ddccb2b04e1$export$2e2bcd8739ae039 = $e41d4ddccb2b04e1$var$verticalSlider;



var $iUSsr = parcelRequire("iUSsr");
const $2b2140b9483408fc$var$section = "[data-video-section]";
const $2b2140b9483408fc$var$slide = "[data-video]";
const $2b2140b9483408fc$var$$header = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#site-header");
const $2b2140b9483408fc$var$mq = window.matchMedia("(max-width: 767px)");
let $2b2140b9483408fc$var$player;
let $2b2140b9483408fc$var$pageHeight, $2b2140b9483408fc$var$headerHeight, $2b2140b9483408fc$var$sectionHeight;
let $2b2140b9483408fc$var$topCoordinates = [];
let $2b2140b9483408fc$var$idx = 0;
const $2b2140b9483408fc$var$reset = ()=>{
    $2b2140b9483408fc$var$headerHeight, $2b2140b9483408fc$var$pageHeight, $2b2140b9483408fc$var$sectionHeight = 0;
    // $(slider).removeClass('is-fixed is-hidden');
    $2b2140b9483408fc$var$showSlide("all");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$section).css("height", "auto");
    $2b2140b9483408fc$var$idx = 0;
};
const $2b2140b9483408fc$var$isVisible = function($element) {
    return $element.is(":visible");
};
const $2b2140b9483408fc$var$init = ()=>{
    $2b2140b9483408fc$var$reset();
    setTimeout(()=>{
        $2b2140b9483408fc$var$headerHeight = $2b2140b9483408fc$var$$header.outerHeight(); //log({headerHeight});
        $2b2140b9483408fc$var$pageHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerHeight() - $2b2140b9483408fc$var$headerHeight; //log({pageHeight});
        $2b2140b9483408fc$var$sectionHeight = $2b2140b9483408fc$var$getSectionHeight(); //log({slide});
        $2b2140b9483408fc$var$updateTopCoordinates();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").hasClass("template-index")) {
            var t_spacing = $2b2140b9483408fc$var$sectionHeight / 2 - 100;
            var m_spacing = t_spacing;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 980) {
                m_spacing = t_spacing + 85;
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$section).css({
                });
            } else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$section).css({
            });
        }
    }, 100);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$slide).hide().eq(0).show();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll();
    //video auto play
    var scroll_position = setInterval(function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scrollTop() >= $2b2140b9483408fc$var$sectionHeight / 2) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".embed_container").each(function(idx) {
                console.log("EMbed", idx);
                var $embed = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".section-video_form");
                var _videoForm = null;
                $videoForm.each(function(idx) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("hide--mobile")) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 989) _videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("hide--desktop")) {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() <= 989) _videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                    } else _videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                });
                if (_videoForm?.hasClass("video")) {
                    var $video = _videoForm.find("#videoId");
                    if ($video.attr("data-autoplay") != "false" && typeof _videoForm.find("#videoId").get(0) != "undefined") {
                        _videoForm.find("#videoId").get(0).play();
                        _videoForm.closest(".embed_container").find("[data-video-replay]").hide();
                        _videoForm.find("#videoId").on("ended", function() {
                            _videoForm.closest(".embed_container").find("[data-video-replay]").show();
                        });
                    }
                } else if (_videoForm?.hasClass("external_video")) {
                    var $video = _videoForm.find("iframe");
                    if (_videoForm?.hasClass("vimeo")) $2b2140b9483408fc$var$player = new Vimeo.Player($video);
                    else if (_videoForm?.hasClass("youtube")) {
                        window.YT !== undefined && window.YT.Player;
                        $2b2140b9483408fc$var$player = new YT.Player((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($video).attr("id"));
                    }
                    var src = $video.attr("src");
                    if ($video.attr("data-autoplay") != "false") {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 767) src += "?rel=0&loop=1&title=0&portrait=0&autoplay=1&playsinline=1&muted=1";
                        else src += "?rel=0&loop=0&title=0&portrait=0&autoplay=1&playsinline=1&muted=1&showinfo=0&controls=0";
                    }
                    $video.attr("src", src);
                }
                if ($video && $video.length && $video.attr("data-autoplay") != "false") {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".video_pause_icon").attr("style", "display: block;");
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".video_start_icon").attr("style", "display: none;");
                }
            });
            clearInterval(scroll_position);
        }
    }, 100);
};
const $2b2140b9483408fc$var$getSectionHeight = ()=>{
    return $2b2140b9483408fc$var$pageHeight * (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$slide).length;
};
const $2b2140b9483408fc$var$showSlide = (index)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$slide).each(function(i, element) {
        if (index === "all") (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).show();
        else if (index == i) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).show();
        else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(element).hide();
    });
};
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-video-replay]", function() {
    var $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".embed_container").find(".section-video_form.hide--desktop");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-selector") == "all") $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".embed_container").find(".section-video_form");
    var $video = $target.find("#videoId");
    $video.get(0).play();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hide();
    $video.find("#videoId").on("ended", function() {
        $video.closest(".embed_container").find("[data-video-replay]").show();
    });
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".video_pause_icon").on("click", function() {
    var $parent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".embed_container");
    var $videoForm = $parent.find(".section-video_form");
    if ($videoForm.hasClass("video")) $parent.find("#videoId").get(0).pause();
    else if ($videoForm.hasClass("external_video")) {
        var $video = $parent.find("iframe");
        var src = $video.attr("src");
        src = src.split("?")[0];
        $video.attr("src", src);
    }
    $parent.find(".video_pause_icon").attr("style", "display: none;");
    $parent.find(".video_start_icon").attr("style", "display: block;");
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".video_start_icon").on("click", function() {
    var $parent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".embed_container");
    var $videoForm = $parent.find(".section-video_form");
    if ($videoForm.hasClass("video")) {
        $parent.find("#videoId").get(0).play();
        changeIcon();
    } else if ($videoForm.hasClass("external_video")) {
        const videos = $parent.find(".section-video_form iframe");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(videos).each((index, item)=>{
            if ($2b2140b9483408fc$var$isVisible((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(item))) {
                if (typeof $2b2140b9483408fc$var$player.play == "function") {
                    $2b2140b9483408fc$var$player.play().catch(function(error) {
                        console.error(error);
                    });
                    changeButton();
                } else if (typeof $2b2140b9483408fc$var$player.playVideo == "function") {
                    console.log($2b2140b9483408fc$var$player);
                    $2b2140b9483408fc$var$player.playVideo();
                    changeButton();
                }
            }
        });
    }
    function changeIcon() {
        $parent.find(".video_pause_icon").attr("style", "display: block;");
        $parent.find(".video_start_icon").attr("style", "display: none;");
    }
    function changeButton() {
        $parent.find(".video_play").attr("style", "display: none;");
    }
});
const $2b2140b9483408fc$var$updateTopCoordinates = ()=>{
    $2b2140b9483408fc$var$topCoordinates = [];
    const sectionTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$section).offset().top;
    for(let i = 0; i < (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$slide).length; i++)$2b2140b9483408fc$var$topCoordinates.push(sectionTop + $2b2140b9483408fc$var$pageHeight * i);
};
function $2b2140b9483408fc$var$scrollHandler() {
    var windowHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).height();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        var scrollTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scrollTop();
        var $video = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-wrapper][data-scroll-play]");
        $video.each(function() {
            var $this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            var $target;
            var handle = $this.attr("data-type");
            var pos_t = $this.offset().top;
            if (handle == "video") $target = $this.find("video");
            else if (handle == "external_video") $target = $this.find("iframe");
            if (!$target) return;
            if (scrollTop + windowHeight > pos_t) {
                if (scrollTop < pos_t + $target.height()) {
                    if ($this.attr("data-screen") != "off" && $this.attr("data-play") != "true") {
                        if (handle == "video") $target.get(0).play();
                        else if (handle == "external_video") {
                            if (typeof playExternalVideo === "function") playExternalVideo($target);
                        }
                        $this.attr("data-play", "true");
                    }
                } else $this.attr("data-screen", "off");
            }
        });
    });
}
const $2b2140b9483408fc$var$videoPlay = function(options) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($2b2140b9483408fc$var$section).length) {
        $2b2140b9483408fc$var$init();
        $2b2140b9483408fc$var$scrollHandler();
    }
};
var $2b2140b9483408fc$export$2e2bcd8739ae039 = $2b2140b9483408fc$var$videoPlay;



var $iUSsr = parcelRequire("iUSsr");
function $e71238102108dddb$export$2e2bcd8739ae039() {
    var $category = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.ingredients .ingredients_category .category_item");
    var $ingredients = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.ingredients .ingredient_items");
    var $ingredient = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.ingredients .ingredient_items .ingredient");
    var $ingredient_details = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.ingredients .ingredient_details");
    var $ingredient_detail_item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.ingredients .ingredient_details .detail_item");
    var ingHtml;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 980) ingHtml = $ingredients.html();
    initialIngSlider();
    $category.on('click', function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('active')) {
            var category = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-category');
            $category.removeClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('active');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 990) $ingredients.removeClass('slick-initialized').removeClass('slick-slider').removeClass('slck-dotted').html(ingHtml);
            $ingredient_detail_item.hide();
            $ingredient_details.css('height', 0);
            $ingredient.removeClass('active');
            $ingredient.find('a').removeClass('active');
            if (category == 'all') $ingredients.find('.ingredient').removeAttr('data-hidden');
            else {
                $ingredients.find('.ingredient').attr('data-hidden', 'true');
                $ingredients.find('.ingredient[data-category="' + category + '"]').removeAttr('data-hidden');
            }
            initialIngSlider();
        }
    });
    function initialIngSlider() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 990) {
            $ingredients.find('[data-hidden]').remove();
            var slickHtml = '';
            var len = 30;
            var is_ended = false;
            $ingredients.find('.ingredient').each(function(idx) {
                var _idx = idx % len;
                var $this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                if (_idx == 0) slickHtml += '<div class="slide_item_wrapper">';
                slickHtml += '<div class="' + $this.attr('class') + '" data-category="' + $this.attr('data-category') + '">' + $this.html() + '</div>';
                if (_idx + 1 == len) {
                    slickHtml += '</div>';
                    is_ended = true;
                } else is_ended = false;
            });
            if (is_ended == false) slickHtml += '</div>';
            $ingredients.html(slickHtml);
            $ingredients.slick({
                slidesToShow: 1,
                arrows: false,
                dots: true
            });
            if ($ingredients.find('.slide_item_wrapper').length > 1) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-swipe-ingredient-label]").removeClass('hidden');
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-swipe-ingredient-label]").addClass('hidden');
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.ingredient a', function() {
        var is_active = true;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('active')) is_active = false;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.ingredient a').removeClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('active');
        var ingredient = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-ingredient');
        $ingredient_detail_item.hide();
        var target_detail_item = $ingredient_details.find('.detail_item[data-ingredient="' + ingredient + '"]');
        if (is_active == false) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).removeClass('active');
            target_detail_item.slideUp(300);
            $ingredient_details.css('height', 0);
            return false;
        }
        var height = target_detail_item.outerHeight();
        $ingredient_details.css('height', height);
        target_detail_item.slideDown(300);
        var scrollTop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scrollTop() + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).height();
        var offsetTop = target_detail_item.offset().top + height;
        var spacing = 350;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 980) spacing = 180;
        if (offsetTop > scrollTop) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
            'scrollTop': offsetTop - height - spacing
        }, 300);
    });
    var showArticles = 100;
    var articleHandle = 'all';
    var searchArticles = [];
    var searchHandle = '';
    var $read_more = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.article_read_more');
    var $blog_categories = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header");
    var $blog_category = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item");
    var $blog_category_tag = ".shopify-section-blog-main .blog_header .blog_header_item .blog_header_item_submenu a";
    var $blogs = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_content");
    var $blog = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_content article.post-cell");
    var $blogs_desc = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_desc");
    var chandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item.active").attr('data-type');
    var ihandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item.active").attr('data-category');
    $blog.attr('data-hidden', 'true');
    $blogs.find('article.post-cell[data-handle="' + chandle + '"]').removeAttr('data-hidden');
    if (chandle == 'all' || (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_content.blog_content-show-hidden').length > 0) {
        $blog.removeAttr('data-hidden');
        $ingredient.removeAttr('data-hidden');
    }
    if (ihandle == '' || ihandle == undefined) {
        $blogs.removeAttr('style');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").removeAttr('style');
    } else {
        $blogs.attr('style', 'display: none !important;');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
    }
    var articleHtml;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) {
        articleHtml = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-article-slider]").html();
        initialArticleSlider();
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) {
        initialMobileHeaderSlider();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-mob-header-slider]").on('afterChange', function(event, slick, currentSlide, nextSlide) {
            var $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_wrapper");
            var $this = $container.find('.blog_header .slick-active[data-slick-index="' + currentSlide + '"] .blog_header_item');
            var handle = $this.attr('data-type');
            $container.find('.blog_header .blog_header_item').removeClass('active');
            $this.addClass('active');
            if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
                $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
                $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');
                $container.find('.blog_header .blog_header_item').removeClass('active');
                $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');
                $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
                $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');
                $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
                $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
                $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
                $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
                var ihandle = $this.attr('data-category');
                if (ihandle == '' || ihandle == undefined) {
                    $blogs.removeAttr('style');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").removeAttr('style');
                } else {
                    $blogs.attr('style', 'display: none !important;');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").removeAttr('style');
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
                }
            }
        });
    } else initialHeaderSlider();
    function readmoreArticle() {
        var $articles = $blogs.find('article.post-cell');
        if (articleHandle != 'all') $articles = $blogs.find('article.post-cell[data-handle="' + articleHandle + '"]');
        if (searchArticles.length > 0 && searchHandle) $articles = searchArticles;
        $articles.each(function(index) {
            if (index < showArticles || index >= $articles.length / 2 && index - $articles.length / 2 < showArticles) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).show();
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hide();
        });
        if ($articles.length / 2 <= showArticles) $read_more.hide();
        else $read_more.show();
    }
    $read_more.click(function(e) {
        e.preventDefault();
        showArticles += 20;
        readmoreArticle();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.recipe-blog-switcher_button').on('click', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.recipe-blog-switcher_button').removeClass('active');
        const switcherTarget = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('target');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.recipe-blog-switcher_button[data-target="${switcherTarget}"]`).addClass('active');
        if (switcherTarget == 'recipes') {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header').removeClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_search_wrap').removeClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header-swipe').removeClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header_item--first').trigger('click');
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header').addClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_search_wrap').addClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header-swipe').addClass('hide');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header_item--news').trigger('click');
        }
    });
    $blog_category.on('click', function() {
        var level = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-level');
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('active')) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('has-sub-menu')) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header').addClass('blog_header_has-sub-menu');
            else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header').removeClass('blog_header_has-sub-menu');
            $blog_category.removeClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($blog_category_tag).removeClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('active');
            var $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_wrapper');
            $container.find('.ingredient_details .detail_item').attr('style', 'display: none;');
            $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-article-slider]").removeClass('slick-initialized').removeClass('slick-slider').removeClass('slck-dotted').html(articleHtml);
            $blog = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_content article.post-cell");
            $blog.attr('data-hidden', 'true');
            $ingredient = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_content article.post-cell");
            $ingredient.attr('data-hidden', 'true');
            var handle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-type');
            articleHandle = handle;
            $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');
            if (handle == 'all') {
                $blog.removeAttr('data-hidden');
                $ingredient.removeAttr('data-hidden');
                $blogs_desc.removeClass('active');
            } else {
                $blogs.find('article.post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
                $ingredients.find('article.post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
                $blogs_desc.removeClass('active');
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.shopify-section-blog-main .blog_desc[data-type="' + handle + '"]').addClass('active');
            window.history.pushState('', '', location.protocol + '//' + location.host + location.pathname + '?' + handle);
        } else //if($(window).width() > 767) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('has-sub-menu')) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header').removeClass('blog_header_has-sub-menu');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).removeClass('active');
        }
        var ihandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-category');
        if (ihandle == '' || ihandle == undefined) {
            $blogs.removeAttr('style');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").removeAttr('style');
        } else {
            $blogs.attr('style', 'display: none !important;');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").removeAttr('style');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.recipes-search-wrapper .recipes-search').val('');
        showArticles = 100;
        searchArticles = [];
        searchHandle = '';
        readmoreArticle();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').on('click', $blog_category_tag, function(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
        evnt.stopImmediatePropagation();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass('active')) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))($blog_category_tag).removeClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('active');
            $blog = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_content article.post-cell");
            $blog.attr('data-hidden', 'true');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header').addClass('blog_header_has-sub-menu');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header_item').addClass('active');
            var handle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-type-tag');
            var menublog = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_header_item').attr('data-type');
            $blogs.find('article.post-cell[data-handle="' + menublog + '"][data-handle-tag*="' + handle + '"]').removeAttr('data-hidden');
        }
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) {
        var $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item.active");
        $target.removeClass('active');
        $target.click();
    }
    function initialArticleSlider() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-article-slider]").slick({
            slidesToShow: 1,
            arrows: false,
            dots: true
        });
    }
    function initialHeaderSlider() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-header-slider]").slick({
            infinite: false,
            slidesToShow: (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 1400 ? 6 : 5,
            arrows: true,
            dots: false
        });
    }
    function initialMobileHeaderSlider() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main [data-mob-header-slider]").slick({
            infinite: false,
            arrows: false,
            dots: false,
            swipeToSlide: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true,
            variableWidth: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog-tab').on('click', '.recipes-search-wrapper svg', function() {
        var $search = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.recipes-search-wrapper');
        var handle = $search.find('.recipes-search').val();
        handle = handle.trim().replaceAll(' ', '-');
        var $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_wrapper');
        var activeCat = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item.active").data('type');
        if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
            $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
            $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_header .blog_header_item').removeClass('active');
            $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
            $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
            $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
            $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
            $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
            var ihandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-category');
            if (ihandle == '' || ihandle == undefined) {
                $blogs.removeAttr('style');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").removeAttr('style');
            } else {
                $blogs.attr('style', 'display: none !important;');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").removeAttr('style');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
            }
        } else if (activeCat == 'all') $container.find('.blog_content .post-cell').removeAttr('data-hidden');
        else $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]').removeAttr('data-hidden');
        var foundSearch = '';
        handle.split(',').forEach(function(handle) {
            foundSearch += '[data-search*="' + handle.toLowerCase() + '"]';
        });
        if (activeCat == 'all') var foundItem = $container.find('.blog_content .post-cell' + foundSearch);
        else var foundItem = $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]' + foundSearch);
        if (foundItem.length > 0) {
            $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
            foundItem.removeAttr('data-hidden');
        }
        if (foundItem.length == 0 && handle != '') $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog-tab').on('keyup', '.recipes-search-wrapper .recipes-search', function(event) {
        var handle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).val();
        searchHandle = handle;
        handle = handle.trim().replaceAll(' ', '-');
        var $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.blog_wrapper');
        var activeCat = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .blog_header .blog_header_item.active").data('type');
        if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
            $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
            $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_header .blog_header_item').removeClass('active');
            $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
            $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');
            $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
            $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
            $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
            $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');
            var ihandle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-category');
            if (ihandle == '' || ihandle == undefined) {
                $blogs.removeAttr('style');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").removeAttr('style');
            } else {
                $blogs.attr('style', 'display: none !important;');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .ingredient_details").removeAttr('style');
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
            }
        } else if (activeCat == 'all') $container.find('.blog_content .post-cell').removeAttr('data-hidden');
        else $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]').removeAttr('data-hidden');
        var foundSearch = '';
        handle.split(/[\s,-]+/).forEach(function(handle) {
            foundSearch += '[data-search*="' + handle.toLowerCase() + '"]';
        });
        if (activeCat == 'all') var foundItem = $container.find('.blog_content .post-cell' + foundSearch);
        else var foundItem = $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]' + foundSearch);
        if (foundItem.length > 0) {
            $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
            foundItem.removeAttr('data-hidden');
        }
        if (foundItem.length == 0 && handle != '') $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
        searchArticles = foundItem;
        readmoreArticle();
    });
    readmoreArticle();
}



var $iUSsr = parcelRequire("iUSsr");
function $6df95036873b82cf$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".section-image_blockicon[data-image-handle]").on('click', function() {
        var handle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-image-handle');
        var $parent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('#section-product');
        $parent.find('[data-image]').attr('data--hidden', 'true');
        $parent.find('[data-image="' + handle + '"]').removeAttr('data--hidden');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.section-product_main').find('[data-variant-url]').attr('href', (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-url'));
        var originalPrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-variant-price');
        var comparePrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-variant-compare-at-price');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.section-product_main').find('.origin_price').text(originalPrice);
        if (typeof comparePrice != 'undefined' && comparePrice.length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.section-product_main').find('.compare_price').text(comparePrice).show();
        else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.section-product_main').find('.compare_price').hide().css('display', 'none');
    });
    var url = location.href;
    if (url.indexOf('/blogs/') > 0) {
        if (url.indexOf('?') > 0) {
            var handle = url.split('?')[1];
            var $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.blog_header_item[data-type="' + handle + '"]');
            $target.click();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
                scrollTop: $target.offset().top - 100
            }, 500);
        }
    }
}



var $iUSsr = parcelRequire("iUSsr");
function $50726214b1faa17b$export$2e2bcd8739ae039() {
    let cur_video = null;
    setTimeout(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".shopify-section.video-slider-section").css("opacity", "1");
    }, 100);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-section-wrapper] [data-video-play]").css("opacity", "1");
    play_video();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        play_video();
    });
    function play_video() {
        var $videoWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-slider]");
        var $video = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-slider-item]");
        var scroll = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scrollTop();
        $videoWrapper.each(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find("[data-video-slider-item]").each(function(idx) {
                var offset = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).offset().top;
                var sectionHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).height();
                var margin = 100;
                var mob_margin = 0;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() < 768) {
                    margin = 100;
                    mob_margin = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".text_wrapper").height();
                }
                if (scroll + sectionHeight + margin > offset + mob_margin) {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-active") != "true") {
                        var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".section-video_form");
                        var _this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                        if ($videoForm.length > 0) videoControl($videoForm, "play");
                        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find("[data-video-control]").attr("data-play", "true");
                        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-active", "true");
                    } else if (scroll - sectionHeight / 2 > offset) var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".section-video_form");
                    else {
                        var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find(".section-video_form");
                        var _this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
                    // videoControl($videoForm, 'play');
                    // $(this).find('[data-video-control]').attr('data-play', 'true');
                    }
                }
                var $indicator = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-section-wrapper]").find("[data-sticky-indicator]");
                if (scroll + sectionHeight / 2 > offset) {
                    $indicator.find("[data-indicator-dots]").find("span").removeClass("active");
                    $indicator.find("[data-indicator-dots]").find("span").eq(idx).addClass("active");
                    idx += 1;
                    $indicator.find("[data-indicator-count]").find("[data-current-index]").text(idx);
                }
                offset;
                $indicator.find(".wrapper").height();
            });
        });
    }
    setTimeout(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-section-wrapper]").each(function() {
            var $this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            var $indicator = $this.find("[data-sticky-indicator]");
            var $slider = $this.find("[data-video-slider]");
            var offset = $this.offset().top;
            var topSpacing = $slider.find("[data-video-slider-item]:first-child").height() / 2;
            var height = $slider.find("[data-video-slider-item]:last-child").height() / 2;
            $indicator.css({
                top: topSpacing,
                "margin-top": topSpacing,
                height: height,
                opacity: 1
            });
        });
    }, 1000);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-sticky-indicator] [data-indicator-dots] span").on("click", function() {
        var handle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-target");
        var $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-section-wrapper]").find("#" + handle);
        var scrollTop = $target.offset().top - $target.height() / 2 + 30;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
            scrollTop: scrollTop
        }, 500);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-play]").on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-control]").attr("data-play", "true");
        var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-slider-item]").find(".section-video_form");
        videoControl($videoForm, "play");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-pause]").on("click", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-control]").attr("data-play", "false");
        var $videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video-slider-item]").find(".section-video_form");
        videoControl($videoForm, "pause");
    });
    function videoControl($videoForm, handle) {
        var $_videoForm = null;
        var _width = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width();
        $videoForm.each(function() {
            if (_width > 989 && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("hide--mobile")) $_videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
            if (_width < 990 && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("hide--desktop")) $_videoForm = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        });
        if (handle == "play") {
            if ($_videoForm?.hasClass("video")) {
                $_videoForm.find("#videoId").get(0).play();
                $_videoForm.find("#videoId").on("ended", function() {
                    $_videoForm.closest("[data-video-slider-item]").find("[data-video-control]").attr("data-play", "false");
                });
            } else if ($_videoForm?.hasClass("external_video")) {
                var $video = $_videoForm.find("iframe");
                var src = $video.attr("src");
                src += "?rel=0&loop=1&title=0&byline=0&portrait=0&sidedock=0&autoplay=1&playsinline=1&muted=1";
                $video.attr("src", src);
            }
        } else if (handle == "pause") {
            if ($_videoForm?.hasClass("video")) $_videoForm.find("#videoId").get(0).pause();
            else if ($_videoForm?.hasClass("external_video")) {
                var $video = $_videoForm.find("iframe");
                var src = $video.attr("src");
                src = src.split("?")[0];
                $video.attr("src", src);
            }
        }
    }
}



var $iUSsr = parcelRequire("iUSsr");
function $6be663150ae35491$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_image').on('click', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_title').html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-description'));
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image').hide(); // Hide all images in the first section
        let index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('id');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image[id="' + index + '"]').show();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('is-active');
        index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('id');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image').hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image:first').show();
    var index = 0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 768) {
        const icons = document.querySelectorAll('.section-icon-slider_block');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[0]).find('.section-icon-slider_image').addClass('is-active');
        setInterval(function() {
            index++;
            if (index >= icons.length) index = 0;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').addClass('is-active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_title').html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').attr('data-description'));
            // Change the first section's image as well
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image').hide(); // Hide all images in the first section
            const newIndex = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').attr('id');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image[id="' + newIndex + '"]').show(); // Show the current image in the first section
        }, 8000);
        // Register click event listeners for arrows here
        // This assumes the previous and next arrows have the classes 'prev-arrow' and 'next-arrow' respectively.
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.prev-arrow').on('click', function() {
            index--;
            if (index < 0) index = icons.length - 1;
            updateSlide();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.next-arrow').on('click', function() {
            index++;
            if (index >= icons.length) index = 0;
            updateSlide();
        });
        function updateSlide() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_block .section-icon-slider_image').removeClass('is-active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').addClass('is-active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.section-icon-slider_title').html((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').attr('data-description'));
            // Change the first section's image as well
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image').hide();
            const newIndex = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(icons[index]).find('.section-icon-slider_image').attr('id');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.first .section-icon-slider_image[id="' + newIndex + '"]').show();
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() <= 768) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".section-icon-slider_blocks").slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-icon-close]').click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('[data-icon]').addClass('is-hidden').trigger('setDefaultContent');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-icon-open]').click(function(event) {
        event.preventDefault();
        var popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('icon-open');
        var $popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-icon="' + popup + '"');
        $popup.toggleClass('is-hidden');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.img_embed').attr('src', (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('url'));
    });
    //afterpay popup
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-afterpay-close]').click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#afterpay-modal-overlay1').css('display', 'none');
    // $('.is-cart-open').css('overflow','auto');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-afterpay-open]').click(function(event) {
        event.preventDefault();
        var popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('afterpay-open');
        var $popup = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[data-afterpay="' + popup + '"');
        // $popup.toggleClass('is-hidden');
        // $('[data-minicart]').removeClass('is-open');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#afterpay-modal-overlay1').css('display', 'block');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '[data-read-more]', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.product-info__bottom').addClass('expanded');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '[data-read-less]', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.product-info__bottom').removeClass('expanded');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.compare-item .product-options__list .product-option__color', function() {
        var vId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-variant-id');
        var $item = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.compare-item');
        $item.find('[data-ajax-btn]').attr('data-id', vId);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.compare-item a[data-link="true"]', function(e) {
        e.preventDefault();
        var url = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('href');
        var vId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.compare-item').find('[data-ajax-btn]').attr('data-id');
        url += '?variant=' + vId;
        document.location.href = url;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.compare-item .btn_learn_more[data-link="false"]', function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
            scrollTop: 0
        }, 500);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.compare-item .product_feature_title', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).next('.product_features').slideToggle();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.product-item-bottom').toggleClass('expanded');
    });
}
// COOKIES CONSET (14/10/2024)
let $6be663150ae35491$var$cc_set = sessionStorage.getItem("consent");
if ($6be663150ae35491$var$cc_set != 'accepted') (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#cookie_consent').show();
else (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#cookie_consent').hide();
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.cookie_btn').on('click', function() {
    sessionStorage.setItem("consent", "accepted");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('#cookie_consent').hide();
});
const $6be663150ae35491$var$wiggleElement = document.querySelector('.cookie_btn');
function $6be663150ae35491$var$startWiggleAnimation() {
    $6be663150ae35491$var$wiggleElement.style.animation = 'wiggle 0.7s forwards';
    // Reset the animation after 1 minute
    setTimeout(()=>{
        $6be663150ae35491$var$wiggleElement.style.animation = 'none'; // Remove the animation
        setTimeout(()=>{
            $6be663150ae35491$var$startWiggleAnimation(); // Restart the animation
        }, 10); // Small timeout to trigger reflow
    }, 10000); // 1 minute in milliseconds
}
// Start the animation for the first time
$6be663150ae35491$var$startWiggleAnimation();



var $iUSsr = parcelRequire("iUSsr");
const $2e99f0b2373520f1$var$autoscroll = function() {
    const blocks = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('[autoscroll-contents]');
    // One full loop, in ms. Higher is slower. data-marquee-duration overrides it per
    // block, so one carousel can be retimed without retiming every marquee.
    var defaultSpeed = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() > 767 ? 30000 : 20000;
    blocks.removeClass('d-flex');
    blocks.each(function() {
        var $block = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        var override = parseInt($block.attr('data-marquee-duration'), 10);
        $block.marquee({
            duration: override > 0 ? override : defaultSpeed,
            gap: 0,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            startPosition: 2,
            startVisible: true
        });
    });
};
var $2e99f0b2373520f1$export$2e2bcd8739ae039 = $2e99f0b2373520f1$var$autoscroll;



var $iUSsr = parcelRequire("iUSsr");
const $f3adc60d236964d3$var$reviewSlide = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.review-slide-wrapper').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        dots: false,
        centerPadding: '100px',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true
                }
            }
        ]
    });
};
var $f3adc60d236964d3$export$2e2bcd8739ae039 = $f3adc60d236964d3$var$reviewSlide;



var $iUSsr = parcelRequire("iUSsr");
const $0a34df8dd8464d0a$var$mobileBanners = function() {
    var _index = 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.image_slide').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        dots: false,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots: true,
                    centerPadding: '0px'
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots: true,
                    centerPadding: '0px'
                }
            }
        ]
    });
    function loading() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.image_slide').closest('.banner_wraps').removeClass('loading-image');
    }
    setTimeout(loading, 3000);
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#compare_products .product-item').eq(0).addClass('active');
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').eq(1).hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page .btn-box .btn_feature').click(function() {
        var top = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scrollTop();
        if (top > 200) window.scrollTo({
            top: 50,
            behavior: 'smooth'
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page #myModal').css('display', 'block');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page #myModal .modal-content').css('bottom', '0');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page .btn-box').css('display', 'none');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on('click', '.close_button', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page .btn-box').css('display', 'flex');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page #myModal .modal-content').css('bottom', '-550px');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page #myModal').css('display', 'none');
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.see_compare_btn').click(function(e) {
        e.stopPropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.holiday-page #compare_product_modal').show();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').css({
            'overflow': 'hidden'
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-modal-content').find('.close').click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#compare_product_modal").hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').css({
            'overflow': 'auto'
        });
    });
    window.onclick = function(event) {
        var modal = document.getElementById("compare_product_modal");
        if (event.target == modal) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#compare_product_modal").hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('body').css({
                'overflow': 'auto'
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.banner_wraps .slick-dots li').mouseover(function() {
        var index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text() - 1;
        var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.options_slickdots.active`).find(`.product-option__color:nth("${index}")`).data('variant-id');
        var product_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.hero_images').find('.banner-product').eq(_index).data('product-id');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`._popup[data-product-id="${product_id}"]`).find('.product_variant').attr('data-variant-id', variant_id);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`._popup[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('.product-option__color').addClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.holiday[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('[data-quick-atc-swatch]').click();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.hero_images').on('beforeChange', function(event, slick, currentSlide, index) {
        var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.options_slickdots.active`).find(`.product-option__color:nth("${index}")`).data('variant-id');
        var product_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('.hero_images').find('.banner-product').eq(_index).data('product-id');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.options_slickdots:nth("${_index}") .product-option__color, ._popup:nth("${_index}") .product-option__color`).removeClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.options_slickdots:nth("${_index}") .product-option`).eq(index).find('.product-option__color').addClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`._popup[data-product-id="${product_id}"]`).find('.product_variant').attr('data-variant-id', variant_id);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`._popup[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('.product-option__color').addClass('checked');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.holiday[data-product-id="${product_id}"]`).find('.product-options__list .product-option').eq(index).find('[data-quick-atc-swatch]').click();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup .product-option__color').mouseover(function() {
        var index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('num');
        var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('variant-id');
        var product_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('._popup').data('product-id');
        var scrollTop = window.pageYOffset;
        var scrollLeft = window.pageXOffset;
        console.log(_index);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest('._popup').find('.product_variant').attr('data-variant-id', variant_id);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.banner-product[data-product-id="${product_id}"]`).find(`.slick-dots li`).eq(index).find('button').click();
        window.scrollTo(scrollLeft, scrollTop);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#compare_products .product-item').mouseover(function() {
        var index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data('number');
        _index = index;
        var product_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).find('[data-product-id]').data('product-id');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('#compare_products .product-item').removeClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').css('display', 'none');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`._popup[data-product-id="${product_id}"]`).css('display', 'flex');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.banner_wraps').removeClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`.banner-product[data-product-id="${product_id}"]`).find('.banner_wraps').addClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.options_slickdots').removeClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.options_slickdots').eq(index).addClass('active');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.banner_wraps.active .image_slide').slick('refresh');
    });
    var stickyHeight = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.js-sticky-cart').eq(0).outerHeight() || 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scroll(function() {
        const $stickyCart = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.js-sticky-cart');
        if ($stickyCart.length < 1) return;
        var scrollBottom = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).scrollTop() + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).height();
        var stickyBottom = $stickyCart.eq(0).offset().top + stickyHeight;
        if (scrollBottom > stickyBottom) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').attr('style', 'display: flex;position: fixed;');
            var alt = !_index;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').eq(alt).attr('style', 'display: none;position: fixed;');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.site-footer .container').attr('style', 'padding-bottom:' + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product_item ._popup').outerHeight() + 'px');
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').attr('style', 'display: none;');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('._popup').eq(_index).attr('style', 'display: flex;position: static;');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.site-footer .container').attr('style', 'padding-bottom:0');
        }
    });
};
var $0a34df8dd8464d0a$export$2e2bcd8739ae039 = $0a34df8dd8464d0a$var$mobileBanners;



var $iUSsr = parcelRequire("iUSsr");
const $b9609ce396a0f2ed$var$mobileSlide = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.product-image__slide').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    });
};
var $b9609ce396a0f2ed$export$2e2bcd8739ae039 = $b9609ce396a0f2ed$var$mobileSlide;


function $f16d2ce4da089431$var$getChildren(n, skipMe) {
    var r = [];
    for(; n; n = n.nextSibling)if (n.nodeType == 1 && n != skipMe) r.push(n);
    return r;
}
function $f16d2ce4da089431$var$getSiblings(n) {
    return $f16d2ce4da089431$var$getChildren(n.parentNode.firstChild, n);
}
const $f16d2ce4da089431$var$videoPlay = function() {
    const videoGridSections = document.querySelectorAll('.grid-videos');
    if (videoGridSections.length > 0) videoGridSections.forEach((section)=>{
        const playPauseButtons = section.querySelectorAll('.grid-videos__item-buttons button');
        const videoComponents = section.querySelectorAll('video-component');
        //for full screen video with new btn
        if (playPauseButtons.length > 0) playPauseButtons.forEach((button)=>{
            button.addEventListener('click', function(e) {
                const parent = this.closest('.grid-videos__item');
                if (!parent) return;
                const siblingElem = $f16d2ce4da089431$var$getSiblings(this);
                const textWrapper = parent.querySelector('.grid-videos__item-text-wrapper');
                const customVideo = parent.querySelector('video-component');
                let defaultCustomButtonPlayIcon;
                let defaultCustomButtonPauseIcon;
                if (customVideo.playBtn) defaultCustomButtonPlayIcon = customVideo.playBtn.querySelector('svg');
                if (customVideo.pauseBtn) defaultCustomButtonPauseIcon = customVideo.pauseBtn.querySelector('svg');
                customVideo.showHideButton(this, false);
                customVideo.showHideButton(siblingElem[0], true);
                if (this.getAttribute('aria-label') === 'Pause Video') customVideo.playerPause();
                else {
                    customVideo.playerPlay();
                    if (defaultCustomButtonPlayIcon) defaultCustomButtonPlayIcon.style.display = 'block';
                    if (defaultCustomButtonPauseIcon) defaultCustomButtonPauseIcon.style.display = 'block';
                    customVideo.hideElement(textWrapper);
                }
            });
        });
        if (videoComponents.length > 0) videoComponents.forEach((customVideoElement)=>{
            const parent = customVideoElement.closest('.grid-videos__item');
            if (!parent) return;
            const textWrapper = parent.querySelector('.grid-videos__item-text-wrapper');
            customVideoElement.addEventListener('click', function(e) {
                if (customVideoElement.classList.contains('is-playing')) customVideoElement.hideElement(textWrapper);
            });
        });
    });
};
var $f16d2ce4da089431$export$2e2bcd8739ae039 = $f16d2ce4da089431$var$videoPlay;



function $c9e2357093d3782c$export$2e2bcd8739ae039() {
    class ProductSticky extends HTMLElement {
        constructor(){
            super();
            this.select = this.querySelector('custom-select');
            if (this.select) this.input = this.select.inputHidden;
            this.section = this.closest('[data-parent-sticky]');
            this.productCard = this.section.querySelector('product-card');
            this.btn = this.querySelector('.add-to-checkout');
            this.price = {
                price: this.querySelector('[data-price]'),
                comparePrice: this.querySelector('[data-price-compare]'),
                priceSave: this.querySelector('[data-price-save]')
            };
            this.init();
        }
        init() {
            if (!this.productCard) return;
            if (this.btn) this.btn.addEventListener('click', this.addToCart);
            if (this.select) this.select.addEventListener('change', this.changeVariantProductCard.bind(this));
            if (this.section) {
                this.showHideElement();
                window.addEventListener('scroll', window.debounce(this.showHideElement.bind(this), 100));
            }
        }
        changeVariant(title) {
            const variantAvailable = this.productCard.currentVariant.available;
            if (this.input.value !== title) {
                this.select.querySelector(`[data-option-value="${title}"] button`).click();
                this.changeButton(variantAvailable).bind(this);
            }
        }
        showHideElement() {
            const section_position = this.section.getBoundingClientRect();
            if (section_position.bottom < 0) {
                this.style.opacity = '1';
                this.style.transform = "translateY(0)";
            } else {
                this.style.opacity = '0';
                this.style.transform = "translateY(100%)";
            }
        }
        changeButton(boolean) {
            const $addText = this.btn.querySelector('.product-form__submit-text');
            const $soldOut = this.btn.querySelector('.sold-out-message');
            if (boolean === false) {
                this.btn.setAttribute('disabled', 'disabled');
                $soldOut.classList.remove('visually-hidden');
                $addText.classList.add('visually-hidden');
            } else {
                $addText.classList.remove('visually-hidden');
                $soldOut.classList.add('visually-hidden');
                this.btn.removeAttribute('disabled');
            }
        }
        changePrice(price, comparePrice, priceSave) {
            if (this.price.price) this.price.price.innerHTML = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(price);
            if (this.price.comparePrice && comparePrice) this.price.comparePrice.innerHTML = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(comparePrice);
            if (this.price.priceSave && priceSave && priceSave > 0) this.price.priceSave.innerHTML = 'Save ' + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(priceSave);
        }
        changeVariantProductCard() {
            this.productCard.currentVariant = this.productCard.changeCurrentVariant(this.input.value, this.productCard.productForm.product.variants);
            this.productCard.changeColorSwatch();
            this.productCard.updateCheckedVariants();
            const price = this.productCard.currentVariant.price, comparePrice = this.productCard.currentVariant.compare_at_price, savePrice = this.productCard.currentVariant.compare_at_price - this.productCard.currentVariant.price, variantAvailable = this.productCard.currentVariant.available;
            this.changePrice(price, comparePrice, savePrice);
            this.changeButton(variantAvailable);
        }
    }
    customElements.define('product-sticky', ProductSticky);
}


/**
 * <localization-form> - country/currency and language switchers.
 *
 * Slim port of Dawn's assets/localization-form.js. Selecting an item writes its value
 * into the hidden country_code / locale_code input and submits the form Shopify's
 * {% form 'localization' %} rendered; the storefront handles the rest.
 *
 * Dropped from Dawn (Dawn-specific, and `.menu-drawer` / `.section-header` do not exist
 * here - querySelector would return null and throw): the country search filter, the
 * `country-selector-open` drawer class, the sticky-header `preventHide` flag and the
 * `overflow-hidden-mobile` body class.
 */ function $c7c5cfc21ae3ecac$export$2e2bcd8739ae039() {
    if (customElements.get('localization-form')) return;
    class LocalizationForm extends HTMLElement {
        constructor(){
            super();
            this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                button: this.querySelector('button.localization-form__select'),
                panel: this.querySelector('.disclosure__list-wrapper')
            };
            if (!this.elements.input || !this.elements.button || !this.elements.panel) return;
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
            this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
            this.addEventListener('focusout', this.closeSelector.bind(this));
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.querySelectorAll('a').forEach((item)=>item.addEventListener('click', this.onItemClick.bind(this)));
        }
        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
        }
        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }
        closeSelector(event) {
            if (!this.contains(event.target) || !this.contains(event.relatedTarget)) this.hidePanel();
        }
        onContainerKeyDown(event) {
            const focusableItems = Array.from(this.querySelectorAll('a'));
            const focusedItemIndex = focusableItems.findIndex((item)=>item === document.activeElement);
            let itemToFocus;
            switch(event.code.toUpperCase()){
                case 'ARROWUP':
                    event.preventDefault();
                    itemToFocus = focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
                    itemToFocus.focus();
                    break;
                case 'ARROWDOWN':
                    event.preventDefault();
                    itemToFocus = focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
                    itemToFocus.focus();
                    break;
            }
        }
        onContainerKeyUp(event) {
            switch(event.code.toUpperCase()){
                case 'ESCAPE':
                    if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
                    event.preventDefault();
                    this.hidePanel();
                    event.stopPropagation();
                    this.elements.button.focus();
                    break;
                case 'SPACE':
                    if (this.elements.button.getAttribute('aria-expanded') === 'true') return;
                    event.preventDefault();
                    this.openSelector();
                    break;
            }
        }
        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
        }
    }
    customElements.define('localization-form', LocalizationForm);
}



const $80da5c6b27ea9eb8$var$layoutTrackingAndLocalization = function() {
    window.addEventListener("load", function() {
        var _learnq = window._learnq || [];
        function addedToCart() {
            fetch(`${window.location.origin}/cart.js`).then((res)=>res.clone().json().then((data)=>{
                    var cart = {
                        total_price: data.total_price / 100,
                        $value: data.total_price / 100,
                        total_discount: data.total_discount,
                        original_total_price: data.original_total_price / 100,
                        items: data.items
                    };
                    if (item !== "undefined") cart = Object.assign(cart, item);
                    if (klAjax) {
                        _learnq.push([
                            "track",
                            "Added to Cart",
                            cart
                        ]);
                        console.log("Added to Cart top line", cart);
                        klAjax = false;
                    }
                }));
        }
        (function(ns, fetchFn) {
            ns.fetch = function() {
                const response = fetchFn.apply(this, arguments);
                response.then((res)=>{
                    if (`${window.location.origin}/cart/add.js`.includes(res.url) && res.url !== "") addedToCart();
                });
                return response;
            };
        })(window, window.fetch);
        var klAjax = true;
        var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit'], .add-to-checkout, .sticky-form .add-to-cart");
        for(var i = 0; i < atcButtons.length; i++)atcButtons[i].addEventListener("click", function() {
            if (klAjax) {
                _learnq.push([
                    "track",
                    "Added to Cart",
                    item
                ]);
                console.log("Added to Cart", item);
                klAjax = false;
            }
        });
    });
    function localizePrices() {
        const locale = window.Shopify && window.Shopify.locale;
        // Only suffix-currency languages (DE, AT, FR) render the symbol after the
        // amount. Keyed on the language code, never on the domain.
        if (!locale || !(0, $f67e0c7059ce8336$export$3a90bcda830d8985).includes(locale.toLowerCase())) return;
        document.querySelectorAll(".localized-price").forEach((el)=>{
            const text = el.textContent.trim();
            const match = text.match(/^([^\d\s]+)\s?([\d.,]+)$/);
            if (match) {
                const [, symbol, amount] = match;
                el.textContent = `${amount}${symbol}`;
            } else {
                const reverseMatch = text.match(/^([\d.,]+)\s?([^\d\s]+)$/);
                if (reverseMatch) {
                    const [, amount, symbol] = reverseMatch;
                    el.textContent = `${amount}${symbol}`;
                }
            }
        });
    }
    localizePrices();
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if ([
                ...mutation.addedNodes
            ].some((node)=>node.nodeType === 1 && node.querySelector?.(".localized-price"))) localizePrices();
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
var $80da5c6b27ea9eb8$export$2e2bcd8739ae039 = $80da5c6b27ea9eb8$var$layoutTrackingAndLocalization;



var $iUSsr = parcelRequire("iUSsr");
const $fa25632170257a3c$var$layoutSlickAndInteractions = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".sldier_marquee_outers").slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: "linear",
        slidesToShow: 1,
        draggable: false,
        focusOnSelect: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
    function callslick() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".bm-section.bm-section-3 .blockWrap").slick({
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 780,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
    callslick();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).on("resize", function() {
        callslick();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".linkCta").click(function() {
        var linkCta = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("linkCta");
        window.location.href = linkCta;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".tabDetails h3.head").click(function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("active")) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".tabDetails h3.head").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".descrip").slideUp();
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".tabDetails h3.head").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".descrip").slideUp();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).next(".descrip").slideDown();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".site-header__nav .nav__item.m-level-1").mouseenter(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body.template-page-beastmode").addClass("admnus megamenu-open");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".site-header__nav .nav__item.m-level-1").mouseleave(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body.template-page-beastmode").removeClass("admnus megamenu-open");
    });
};
var $fa25632170257a3c$export$2e2bcd8739ae039 = $fa25632170257a3c$var$layoutSlickAndInteractions;


/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */ 
var $iUSsr = parcelRequire("iUSsr");
(function(f) {
    f.fn.marquee = function(x) {
        return this.each(function() {
            var a = f.extend({}, f.fn.marquee.defaults, x), b = f(this), c, t, e = 3, y = "animation-play-state", p = !1, E = function(a, b, c) {
                for(var e = [
                    "webkit",
                    "moz",
                    "MS",
                    "o",
                    ""
                ], d = 0; d < e.length; d++)e[d] || (b = b.toLowerCase()), a.addEventListener(e[d] + b, c, !1);
            }, F = function(a) {
                var b = [], c;
                for(c in a)a.hasOwnProperty(c) && b.push(c + ":" + a[c]);
                b.push();
                return "{" + b.join(",") + "}";
            }, l = {
                pause: function() {
                    p && a.allowCss3Support ? c.css(y, "paused") : f.fn.pause && c.pause();
                    b.data("runningStatus", "paused");
                    b.trigger("paused");
                },
                resume: function() {
                    p && a.allowCss3Support ? c.css(y, "running") : f.fn.resume && c.resume();
                    b.data("runningStatus", "resumed");
                    b.trigger("resumed");
                },
                toggle: function() {
                    l["resumed" == b.data("runningStatus") ? "pause" : "resume"]();
                },
                destroy: function() {
                    clearTimeout(b.timer);
                    b.find("*").addBack().unbind();
                    b.html(b.find(".js-marquee:first").html());
                }
            };
            if ("string" === typeof x) f.isFunction(l[x]) && (c || (c = b.find(".js-marquee-wrapper")), !0 === b.data("css3AnimationIsSupported") && (p = !0), l[x]());
            else {
                var u;
                f.each(a, function(c, d) {
                    u = b.attr("data-" + c);
                    if ("undefined" !== typeof u) {
                        switch(u){
                            case "true":
                                u = !0;
                                break;
                            case "false":
                                u = !1;
                        }
                        a[c] = u;
                    }
                });
                a.speed && (a.duration = parseInt(b.width(), 10) / a.speed * 1E3);
                var v = "up" == a.direction || "down" == a.direction;
                a.gap = a.duplicated ? parseInt(a.gap) : 0;
                b.wrapInner('<div class="js-marquee"></div>');
                var h = b.find(".js-marquee").css({
                    "margin-right": a.gap,
                    "float": "left"
                });
                a.duplicated && h.clone(!0).appendTo(b);
                b.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');
                c = b.find(".js-marquee-wrapper");
                if (v) {
                    var k = b.height();
                    c.removeAttr("style");
                    b.height(k);
                    b.find(".js-marquee").css({
                        "float": "none",
                        "margin-bottom": a.gap,
                        "margin-right": 0
                    });
                    a.duplicated && b.find(".js-marquee:last").css({
                        "margin-bottom": 0
                    });
                    var q = b.find(".js-marquee:first").height() + a.gap;
                    a.startVisible && !a.duplicated ? (a._completeDuration = (parseInt(q, 10) + parseInt(k, 10)) / parseInt(k, 10) * a.duration, a.duration *= parseInt(q, 10) / parseInt(k, 10)) : a.duration *= (parseInt(q, 10) + parseInt(k, 10)) / parseInt(k, 10);
                } else {
                    var m = b.find(".js-marquee:first").width() + a.gap;
                    var n = b.width();
                    a.startVisible && !a.duplicated ? (a._completeDuration = (parseInt(m, 10) + parseInt(n, 10)) / parseInt(n, 10) * a.duration, a.duration *= parseInt(m, 10) / parseInt(n, 10)) : a.duration *= (parseInt(m, 10) + parseInt(n, 10)) / parseInt(n, 10);
                }
                a.duplicated && (a.duration /= 2);
                if (a.allowCss3Support) {
                    h = document.body || document.createElement("div");
                    var g = "marqueeAnimation-" + Math.floor(1E7 * Math.random()), A = [
                        "Webkit",
                        "Moz",
                        "O",
                        "ms",
                        "Khtml"
                    ], B = "animation", d = "", r = "";
                    h.style.animation && (r = "@keyframes " + g + " ", p = !0);
                    if (!1 === p) {
                        for(var z = 0; z < A.length; z++)if (void 0 !== h.style[A[z] + "AnimationName"]) {
                            h = "-" + A[z].toLowerCase() + "-";
                            B = h + B;
                            y = h + y;
                            r = "@" + h + "keyframes " + g + " ";
                            p = !0;
                            break;
                        }
                    }
                    p && (d = g + " " + a.duration / 1E3 + "s " + a.delayBeforeStart / 1E3 + "s infinite " + a.css3easing, b.data("css3AnimationIsSupported", !0));
                }
                var C = function() {
                    c.css("transform", "translateY(" + ("up" == a.direction ? k + "px" : "-" + q + "px") + ")");
                }, D = function() {
                    c.css("transform", "translateX(" + ("left" == a.direction ? n + "px" : "-" + m + "px") + ")");
                };
                a.duplicated ? (v ? a.startVisible ? c.css("transform", "translateY(0)") : c.css("transform", "translateY(" + ("up" == a.direction ? k + "px" : "-" + (2 * q - a.gap) + "px") + ")") : a.startVisible ? c.css("transform", "translateX(0)") : c.css("transform", "translateX(" + ("left" == a.direction ? n + "px" : "-" + (2 * m - a.gap) + "px") + ")"), a.startVisible || (e = 1)) : a.startVisible ? e = 2 : v ? C() : D();
                var w = function() {
                    a.duplicated && (1 === e ? (a._originalDuration = a.duration, a.duration = v ? "up" == a.direction ? a.duration + k / (q / a.duration) : 2 * a.duration : "left" == a.direction ? a.duration + n / (m / a.duration) : 2 * a.duration, d && (d = g + " " + a.duration / 1E3 + "s " + a.delayBeforeStart / 1E3 + "s " + a.css3easing), e++) : 2 === e && (a.duration = a._originalDuration, d && (g += "0", r = f.trim(r) + "0 ", d = g + " " + a.duration / 1E3 + "s 0s infinite " + a.css3easing), e++));
                    v ? a.duplicated ? (2 < e && c.css("transform", "translateY(" + ("up" == a.direction ? 0 : "-" + q + "px") + ")"), t = {
                        transform: "translateY(" + ("up" == a.direction ? "-" + q + "px" : 0) + ")"
                    }) : a.startVisible ? 2 === e ? (d && (d = g + " " + a.duration / 1E3 + "s " + a.delayBeforeStart / 1E3 + "s " + a.css3easing), t = {
                        transform: "translateY(" + ("up" == a.direction ? "-" + q + "px" : k + "px") + ")"
                    }, e++) : 3 === e && (a.duration = a._completeDuration, d && (g += "0", r = f.trim(r) + "0 ", d = g + " " + a.duration / 1E3 + "s 0s infinite " + a.css3easing), C()) : (C(), t = {
                        transform: "translateY(" + ("up" == a.direction ? "-" + c.height() + "px" : k + "px") + ")"
                    }) : a.duplicated ? (2 < e && c.css("transform", "translateX(" + ("left" == a.direction ? 0 : "-" + m + "px") + ")"), t = {
                        transform: "translateX(" + ("left" == a.direction ? "-" + m + "px" : 0) + ")"
                    }) : a.startVisible ? 2 === e ? (d && (d = g + " " + a.duration / 1E3 + "s " + a.delayBeforeStart / 1E3 + "s " + a.css3easing), t = {
                        transform: "translateX(" + ("left" == a.direction ? "-" + m + "px" : n + "px") + ")"
                    }, e++) : 3 === e && (a.duration = a._completeDuration, d && (g += "0", r = f.trim(r) + "0 ", d = g + " " + a.duration / 1E3 + "s 0s infinite " + a.css3easing), D()) : (D(), t = {
                        transform: "translateX(" + ("left" == a.direction ? "-" + m + "px" : n + "px") + ")"
                    });
                    b.trigger("beforeStarting");
                    if (p) {
                        c.css(B, d);
                        var h = r + " { 100%  " + F(t) + "}", l = c.find("style");
                        0 !== l.length ? l.filter(":last").html(h) : f("head").append("<style>" + h + "</style>");
                        E(c[0], "AnimationIteration", function() {
                            b.trigger("finished");
                        });
                        E(c[0], "AnimationEnd", function() {
                            w();
                            b.trigger("finished");
                        });
                    } else c.animate(t, a.duration, a.easing, function() {
                        b.trigger("finished");
                        a.pauseOnCycle ? b.timer = setTimeout(w, a.delayBeforeStart) : w();
                    });
                    b.data("runningStatus", "resumed");
                };
                b.bind("pause", l.pause);
                b.bind("resume", l.resume);
                a.pauseOnHover && (b.bind("mouseenter", l.pause), b.bind("mouseleave", l.resume));
                p && a.allowCss3Support ? w() : b.timer = setTimeout(w, a.delayBeforeStart);
            }
        });
    };
    f.fn.marquee.defaults = {
        allowCss3Support: !0,
        css3easing: "linear",
        easing: "linear",
        delayBeforeStart: 1E3,
        direction: "left",
        duplicated: !1,
        duration: 5E3,
        gap: 20,
        pauseOnCycle: !1,
        pauseOnHover: !1,
        startVisible: !1
    };
})((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))));


// import "./vendor/matchHeight";
// import "./vendor/tiny-img-link-preloader";
// import "./vendor/vimeo.min";
// import "./vendor/sweetalert2@9.min";
// import "./vendor/custom";
// import "./vendor/lazysizes.min";
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
const $2b766076d08b0976$var$register = function(f, args) {
    try {
        f(args);
        if (args && args.resize) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).resize(function() {
            f(args);
        });
    } catch (e) {
        console.error(e);
    }
};
const $2b766076d08b0976$var$trigger = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-trigger]").click(function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-trigger]").not((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this)).removeClass("is-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass("is-open");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-trigger-hover]").mouseover(function(e) {
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-trigger]").removeClass("is-open");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", function(e) {
        const trigger = "[data-trigger]";
        const $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(e.target);
        const $trigger = $target.closest(trigger);
        const $next = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(trigger).next();
        const isNext = $next.find($target).length;
        if ($trigger.length || isNext) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(trigger).removeClass("is-open");
    });
};
const $2b766076d08b0976$var$tabs = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".press-icon").hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-tab]").click(function(e) {
        e.stopPropagation();
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("tab");
        const $parent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-tabs]");
        const site_url = location.href;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-tab], [data-tab-content]", $parent).removeClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-tab-content=${index}]`, $parent).addClass("is-active");
        if (site_url.indexOf("in-the-press") != -1) {
            if (index == "press") {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".press-products").show();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".press-icon").hide();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".hero__container.gift").hide();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".hero__container.press").show();
            } else if (index == "gift-card") {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".press-products").hide();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".press-icon").show();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".hero__container.gift").show();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".hero__container.press").hide();
            }
            //if($(window).width() < 768) {
            setTimeout(function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".tab-content.is-active[data-hor-slider]").slick("refresh");
            }, 10);
        //}
        }
    });
};
const $2b766076d08b0976$var$filter = ()=>{
    const storageIndex = localStorage.getItem("collection-tab");
    if (storageIndex) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-collection-tabs] [data-tab]").removeClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-collection-tabs] [data-tab=${storageIndex}]`).addClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-collection-tabs] [data-tab-content]").removeClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-collection-tabs] [data-tab-content=${storageIndex}]`).addClass("is-active");
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-collection-tabs] .nav__link").click(function() {
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-tab-content]").data("tab-content");
        localStorage.setItem("collection-tab", index);
    });
};
const $2b766076d08b0976$var$video = function() {
    const video = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video] video");
    const btn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-video-btn]");
    btn.click(function(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).siblings("video").click();
    });
    video.each(function(index, videoEl) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(videoEl).on("play seeking", function() {
            // $(this).attr('controls', true);
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).siblings("button").hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video]").addClass("is-playing");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(videoEl).on("seeked", function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this)[0].play();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(videoEl).on("pause", function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).removeAttr("controls");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).siblings("button").show();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-video]").removeClass("is-playing");
        });
    });
};
const $2b766076d08b0976$var$handleGotop = function() {
    const gotop = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-gotop]");
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).scroll(function() {
        const scroll = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).scrollTop();
        if (scroll >= (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).height()) gotop.show();
        else gotop.hide();
    });
};
const $2b766076d08b0976$var$accordions = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-accordions-container]").each(function() {
        const $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        if ($container.data("accordions-mobile-only") == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerWidth() >= 990) return;
        const $buttons = $container.find("[data-accordion-button]");
        const $contents = $container.find("[data-accordion-content]");
        $contents.hide();
        $contents.first().show();
        $buttons.first().addClass("is-open");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-accordion-title]", function(event) {
        event.preventDefault();
        const $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-accordions-container]");
        if ($container.data("accordions-mobile-only") == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerWidth() > 989) return false;
        const $currentBtn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        const $currentContent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).siblings("[data-subaccordion]");
        $currentBtn.toggleClass("is-open");
        $currentContent.slideToggle();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-accordion-title]", $container).not($currentBtn).removeClass("is-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-subaccordion]", $container).not($currentContent).slideUp();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", "[data-accordion-button]", function(event) {
        event.preventDefault();
        const $container = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-accordions-container]");
        if ($container.data("accordions-mobile-only") == "1" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).outerWidth() > 989) return false;
        const $currentBtn = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this);
        const $currentContent = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).siblings("[data-accordion-content]");
        $currentBtn.toggleClass("is-open");
        $currentContent.slideToggle();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-accordion-button]", $container).not($currentBtn).removeClass("is-open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-accordion-content]", $container).not($currentContent).slideUp();
    });
};
const $2b766076d08b0976$var$faq = function() {
    const $toggle = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-faq-section-toggle]");
    const $section = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-faq-section]");
    if ($toggle.length) $toggle.on("click", function(e) {
        const currentSection = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("faq-section-toggle");
        $toggle.removeClass("is-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("is-active");
        $section.removeClass("is-active");
        $section.filter(`[data-faq-section=${currentSection}]`).addClass("is-active");
    });
};
const $2b766076d08b0976$var$stickyFooter = function() {
    const update = ()=>{
        setTimeout(()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).width() <= 989) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").css("paddingBottom", 0);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-site-footer]").show();
                return false;
            }
            var height = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-site-footer]").outerHeight();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").css({
                paddingBottom: height
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-site-footer]").show();
        }, 250);
    };
    update();
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).on("resize", update);
};
const $2b766076d08b0976$var$themeEditor = function() {
    if (Shopify.designMode) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").removeClass("animations-on");
};
const $2b766076d08b0976$var$toggleTarget = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-toggle]").click(function() {
        const target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("toggle");
        const $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-target=${target}]`);
        $target.toggleClass("is-active");
    });
};
const $2b766076d08b0976$var$goTo = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-goto]").click(function() {
        const target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("goto");
        const $target = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-goto-target=${target}]`);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest("[data-goto-target]").addClass("hide");
        $target.removeClass("hide");
    });
};
function $2b766076d08b0976$var$getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
}
const $2b766076d08b0976$var$misc = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-random-number]").text($2b766076d08b0976$var$getRandomInt(2, 9));
};
const $2b766076d08b0976$var$btnSectionScroll = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".btn.add-to-cart:not([data-add-to-cart])").click(function(e) {
        e.preventDefault();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).text().toLowerCase() == "order now" && (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-main").length) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
            scrollTop: 0
        }, "slow");
        else {
            const href = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("href");
            window.location.href = href;
        }
    });
};
// const collectionChange = function () {
//   $("[data-collection-button]").click(function (e) {
//     e.preventDefault();
//     $("[data-collection-button]").removeClass("active");
//     $(this).addClass("active");
//     const target = $(this).data("target");
//     const $target = $(`[data-wrap=${target}]`);
//     $(".collecttionwrap").removeClass("active").hide();
//     $target
//       .addClass("active")
//       .css({
//         opacity: 0,
//       })
//       .animate({
//         opacity: 1,
//       })
//       .show();
//     history.pushState("", "", $(this).attr("data-target"));
//   });
// };
const $2b766076d08b0976$var$customStickyEvent = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".custom-variants_select", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass("open");
    });
};
const $2b766076d08b0976$var$customStickyChange = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).on("click", ".custom-variants_select.open div[data-variant_id]", function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).hasClass("active")) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".custom-variants_select").find("div.active").removeClass("active");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).addClass("active");
            var variant_id = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-variant_id");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".custom-variants_select").next(".sticky-variants").val(variant_id).trigger("change");
            var is_available = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".custom-variants_select").next(".sticky-variants").find("option[value=" + variant_id + "]").attr("data-available");
            if (is_available == "true") {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find("[data-add-to-cart]").removeAttr("disabled");
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find("[data-add-to-cart]").html("Add To Cart - <span>" + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-price") + "</span>");
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find("[data-add-to-cart]").attr("disabled", true);
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).closest(".sticky-form").find("[data-add-to-cart]").html("Sold Out - <span>" + (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("data-price") + "</span>");
            }
        }
    });
};
const $2b766076d08b0976$var$pressScrollToTop = function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".slick-slider[data-tab-content]").on("afterChange", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
};
function $2b766076d08b0976$var$buttonLoadOff(btn) {
    const spinner = btn.querySelector(".loading-overlay__spinner");
    btn.classList.remove("loading");
    btn.removeAttribute("aria-disabled");
    if (spinner) spinner.classList.add("hidden");
}
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(()=>{
    $2b766076d08b0976$var$register((0, $4d3add7eda271e10$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$stickyFooter);
    $2b766076d08b0976$var$register((0, $0d840adb65d390a7$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$video);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$handleGotop);
    $2b766076d08b0976$var$register((0, $05f743a724b1c58b$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $48cc3ffebca0f766$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$accordions);
    $2b766076d08b0976$var$register((0, $e362e5530e455afb$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $56032083f0ed7410$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $819ac149f13a907c$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $1069474bd9395150$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $34a037206fb20059$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $4a6467074ac21b06$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$faq);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$themeEditor);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$trigger);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$tabs);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$filter);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$toggleTarget);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$goTo);
    $2b766076d08b0976$var$register((0, $52772a3ac0d5fa22$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $732388c7eeead09f$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$misc);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$btnSectionScroll);
    $2b766076d08b0976$var$register((0, $b8bcb8152ef21fa3$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $f4284bbd181684e7$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $8d49a7d8198705c0$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $3b8b94fa989699a9$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $48dca9a681ac1549$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $c48879bd984a8cbb$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $6262cca4805b33a2$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $4f0aa0cd93a68fcc$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $846095188e74f4b9$export$2e2bcd8739ae039));
    // register(gsapAnimation);
    $2b766076d08b0976$var$register((0, $e41d4ddccb2b04e1$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $2b2140b9483408fc$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $e71238102108dddb$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $6df95036873b82cf$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $50726214b1faa17b$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $6be663150ae35491$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register($2b766076d08b0976$var$customStickyEvent);
    $2b766076d08b0976$var$register($2b766076d08b0976$var$customStickyChange);
    $2b766076d08b0976$var$register((0, $2e99f0b2373520f1$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $f3adc60d236964d3$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $0a34df8dd8464d0a$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $112f3e990e5bf005$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $81551a82a638a90d$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $b9609ce396a0f2ed$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $f16d2ce4da089431$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $af17ce3e8da8c71c$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $c9e2357093d3782c$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $c7c5cfc21ae3ecac$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $80da5c6b27ea9eb8$export$2e2bcd8739ae039));
    $2b766076d08b0976$var$register((0, $fa25632170257a3c$export$2e2bcd8739ae039));
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").on("click", ".redeem-offer", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var _klOnsite = window._klOnsite || [];
        _klOnsite.push([
            "openForm",
            "Ukrhwk"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-form-popup").addClass("open-popup");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body,html").addClass("no-scroll");
        return false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-form-popup").on("click", "[data-popup-close]", function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-form-popup").removeClass("open-popup");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body,html").removeClass("no-scroll");
    });
    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == "redirectedToUrl" && e.detail.formId == "Ukrhwk") {
            // $('.klaviyo-form-popup').removeClass('open-popup');
            // $('body,html').removeClass('no-scroll');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-form-popup").addClass("loading");
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".klaviyo-form-popup button.needsclick").append('<div class="loader-wapper"></div>');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".orginal-add-to-cart button").trigger("click");
        }
    });
    $2b766076d08b0976$var$register($2b766076d08b0976$var$pressScrollToTop);
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).ready(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-compare-item__product").find(".product-option").find("label").click(function() {
        var variantId = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).data("variant-id");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-add-btns").find(".product-option").find(`[data-variant-id="${variantId}"]`).click();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".info-wrapper").click(function(e) {
        e.stopPropagation();
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("body").on("mousedown", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".info-wrapper").removeClass("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".print-recipe").on("click", function() {
        window.print();
    });
});
const $2b766076d08b0976$var$$compareProducts = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(".product-compare-item__product").find(".product-compare-content");
const $2b766076d08b0976$var$$compareTable = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#shopify-section-ea-product-compare");
if ($2b766076d08b0976$var$$compareTable.length > 0 && $2b766076d08b0976$var$$compareProducts.length > 0) {
    const compareProductsTop = $2b766076d08b0976$var$$compareProducts.position().top;
    const compareTableBottom = $2b766076d08b0976$var$$compareTable.position().top;
    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(window).on("scroll", function() {
        var st = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).scrollTop();
        var height = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).height();
        var width = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).width();
        if (width < 768) {
            if (st > compareProductsTop + height + 100) $2b766076d08b0976$var$$compareTable.addClass("compare-sticky");
            else $2b766076d08b0976$var$$compareTable.removeClass("compare-sticky");
            if (st > compareTableBottom) $2b766076d08b0976$var$$compareTable.removeClass("compare-sticky");
        }
    });
}
class $2b766076d08b0976$var$ProductForm extends HTMLElement {
    constructor(){
        super();
        this.form = this.querySelector("[data-type=add-to-cart-form]");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.product = JSON.parse(this.querySelector(".product-json").textContent);
        this.quantitySelector = this.querySelector("quantity-input");
        this.cartPopup = document.querySelector("[data-minicart]");
        if (this.form.elements.add && this.isIterable(this.form.elements.add)) this.addButtons = this.form.elements.add;
        else this.addButtons = [
            this.form.elements.add
        ];
    }
    onSubmitHandler(e) {
        e.preventDefault();
        this.addButtons.forEach((btn)=>{
            const spinner = btn.querySelector(".loading-overlay__spinner");
            if (btn.classList.contains("loading")) return;
            btn.setAttribute("aria-disabled", "true");
            btn.classList.add("loading");
            if (spinner) spinner.classList.remove("hidden");
            this.handleErrorMessage(false, btn);
        });
        const items = [];
        const mainItem = this.createFormDataItem(this.form);
        items.push(mainItem);
        const successCallback = function(response) {
            if (response.status) this.addButtons.forEach((btn)=>this.handleErrorMessage(response.description, btn));
        };
        const finallyCallback = function() {
            this.addButtons.forEach((btn)=>{
                $2b766076d08b0976$var$buttonLoadOff(btn);
            });
        };
        window.newAddToCart(items, true, successCallback.bind(this), null, finallyCallback.bind(this));
    }
    isIterable(obj) {
        return typeof obj[Symbol.iterator] === "function";
    }
    createFormDataItem(form) {
        if (!form) return false;
        const formData = new FormData(form);
        const item = {};
        formData.forEach((value, key)=>{
            const lastStr = key.charAt(key.length - 1);
            if (key.includes("properties") && lastStr === "]") {
                const newKey = key.substring(key.indexOf("[") + 1, key.indexOf("]"));
                if (item["properties"]) item["properties"][newKey] = value;
                else item["properties"] = {
                    [newKey]: value
                };
            } else item[key] = value;
        });
        return item || false;
    }
    handleErrorMessage(errorMessage = false, btn) {
        this.errorMessageWrapper = this.form.querySelector("[data-error-wrapper]");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessageWrapper.querySelector("[data-error-message]");
        if (errorMessage) {
            this.errorMessageWrapper.classList.remove("visually-hidden");
            this.errorMessage.textContent = errorMessage;
        }
        this.hideErrorMessage(this.errorMessageWrapper, errorMessage);
    }
    hideErrorMessage(errorMessageWrapper, errorMessage) {
        setTimeout(()=>{
            errorMessageWrapper.classList.add("visually-hidden");
            if (errorMessage) this.errorMessage.textContent = "";
        }, 5000);
    }
    toggleAddButton(available = true, text, hide = false, preorder = false) {
        if (!this.addButtons) return;
        let addButtonStatus = "enabled";
        if (!available) {
            addButtonStatus = "disabled";
            if (!text) text = window.variantStrings.soldOut;
        } else {
            if (preorder) {
                if (!text) text = window.variantStrings.preorder;
            } else if (!text) text = window.variantStrings.addToCart;
        }
        this.addButtons.forEach((btn)=>{
            const textInner = btn.querySelector("span");
            addButtonStatus === "enabled" ? btn.removeAttribute("disabled") : btn.setAttribute("disabled", "disabled");
            textInner.textContent = text;
        });
    }
}
customElements.define("product-form", $2b766076d08b0976$var$ProductForm);
class $2b766076d08b0976$var$ProductCard extends HTMLElement {
    constructor(){
        super();
        this.url = String(window.location.href);
        this.productForm = this.querySelector("product-form") || null;
        this.price = {
            price: this.querySelector("[data-price]"),
            comparePrice: this.querySelector("[data-price-compare]"),
            priceSave: this.querySelector("[data-price-save]")
        };
        this.optionTitles = this.querySelectorAll("[data-option-title]");
        this.stickyBar = document.querySelector("product-sticky");
        this.button = this.querySelector('button[type="submit"]') || null;
        this.variantImages = this.querySelectorAll(".js-variant-image") || null;
        this.cardColor = this.querySelector(".product__option-item-color") || null;
        if (this.cardColor && this.productForm.product) {
            const selectColor = this.cardColor.querySelector("input:checked");
            this.currentVariant = this.changeCurrentVariant(selectColor.value, this.productForm.product.variants);
        }
        this.bundlePrice = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).parents(".bundle-compare__product-wrapper").find(".bundle-compare__product-title-wrapper").find(".product-price__save");
        if (this.productForm) this.btnLink = this.querySelector(".product-card__btn-wrapper a") || null;
        this.init();
    }
    init() {
        if (this.button) this.button.addEventListener("mousedown mouseup", (e)=>{
            e.preventDefault();
            e.stopImmediatePropagation();
        });
        this.addEventListener("change", this.changeOnSwatches);
        this.endLoadBtn();
    }
    changeOnSwatches(event) {
        this.updateOptions();
        this.updateMasterId();
        if (event && event.target.hasAttribute("data-single-option-color")) this.changeColorSwatch(event.target);
        if (this.stickyBar && event) this.stickyBar.changeVariant(this.currentVariant.title);
    }
    updateMasterId() {
        this.currentVariant = this.productForm.product.variants.map((variant, i)=>{
            if (!variant.options.map((option, index)=>{
                return this.options[index] === option;
            }).includes(false)) return variant;
        });
        this.currentVariant = this.currentVariant.find((v)=>v);
    }
    updateOptions() {
        const fieldsets = Array.from(this.productForm.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset)=>{
            return Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value;
        });
    }
    updateCheckedVariants() {
        const fieldsets = Array.from(this.productForm.querySelectorAll("fieldset"));
        this.currentVariant.options.forEach((optionValue)=>{
            fieldsets.forEach((fieldset)=>{
                const input = Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.value == optionValue);
                if (typeof input === "object") input.checked = true;
            });
        });
    }
    changeOptionsTitle() {
        if (!this.optionTitles.length > 0) return;
        const optionTitlesArr = Array.from(this.optionTitles);
        optionTitlesArr.forEach((item, index)=>{
            if (this.currentVariant.options[index]) item.innerHTML = this.currentVariant.options[index];
        });
    }
    changeCurrentVariant(title, objects) {
        return objects.find((object)=>object.title === title);
    }
    changeColorSwatch() {
        const variantOptions = this.currentVariant.options, currentID = `${this.currentVariant.id}`, price = this.currentVariant.price, comparePrice = this.currentVariant.compare_at_price, savePrice = this.currentVariant.compare_at_price - this.currentVariant.price, variantAvailable = this.currentVariant.available;
        this.changeVariantImage(variantOptions);
        this.changePrice(price, comparePrice, savePrice);
        this.changeSelectId(currentID);
        this.changeOptionsTitle();
        if (this.button) this.changeButton(variantAvailable);
    }
    changeButton(boolean) {
        const $addText = this.button.querySelector(".product-form__submit-text");
        const $soldOut = this.button.querySelector(".sold-out-message");
        if (boolean === false) {
            this.button.setAttribute("disabled", "disabled");
            $soldOut.classList.remove("visually-hidden");
            $addText.classList.add("visually-hidden");
        } else {
            $addText.classList.remove("visually-hidden");
            $soldOut.classList.add("visually-hidden");
            this.button.removeAttribute("disabled");
        }
    }
    changeSelectId(variantId) {
        const select = this.productForm.form.elements.id;
        if (select) select.value = `${variantId}`;
    }
    changeVariantImage(variantOptions) {
        let currentImage;
        this.variantImages.forEach((image)=>{
            if (!variantOptions) return;
            variantOptions.forEach((option)=>{
                if (image.getAttribute("data-variant-image-title") !== option) {
                    if (image.classList.contains("active")) image.classList.remove("active");
                } else if (image.getAttribute("data-variant-image-title") === option) currentImage = image;
            });
        });
        currentImage.classList.add("active");
    }
    changePrice(price, comparePrice, priceSave) {
        if (this.price.price) this.price.price.innerHTML = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(price);
        if (this.price.comparePrice && comparePrice) this.price.comparePrice.innerHTML = (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(comparePrice);
        if (this.price.priceSave && priceSave && priceSave > 0) {
            this.price.priceSave.innerHTML = "Save $" + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(priceSave, "{{amount_no_decimals}}");
            if (this.bundlePrice.length > 0) this.bundlePrice[0].innerHTML = "Save $" + (0, $f67e0c7059ce8336$export$a17b3c2052469c69)(priceSave, "{{amount_no_decimals}}");
        }
    }
    endLoadBtn() {
        if (this.productForm === null) return;
        const btn = this.button;
        const spinner = btn.querySelector(".loading-overlay__spinner");
        btn.classList.remove("loading");
        btn.removeAttribute("aria-disabled");
        if (spinner) spinner.classList.add("hidden");
    }
}
customElements.define("product-card", $2b766076d08b0976$var$ProductCard);
class $2b766076d08b0976$var$customSelect extends HTMLElement {
    constructor(){
        super();
        this.button = this.querySelector(".form-select__btn");
        this.dropdownLabel = this.querySelector(".form-select__dropdown-option--label");
        this.buttonText = this.button.querySelector(".form-select__btn-text");
        this.list = this.querySelector(".form-select__dropdown");
        this.inputHidden = this.querySelector(".form__input-hidden");
        this.isAlternative = this.classList.contains("form-select__alternative");
        this.changeEvent = new Event("change", {
            bubbles: true
        });
        this.button.addEventListener("click", (e)=>{
            this.button.getAttribute("aria-expanded") === "true" ? this.close() : this.open();
        });
        if (window.isIosDevice) {
            const _self = this;
            window.addEventListener("click", function(event) {
                if (!_self.contains(event.target) && !_self.button.contains(event.target)) _self.close();
            });
        } else this.addEventListener("focusout", function(event) {
            if (this.contains(event.relatedTarget) || !document.hasFocus()) return;
            this.close(); // or whatever logic you want to use to close
        });
        this.initOptions();
        if (this.isAlternative) document.addEventListener("click", (e)=>{
            let isClickInside = this.contains(e.target);
            if (!isClickInside) this.close();
        });
        this.addEventListener("keydown", (event)=>{
            if (event.key === "Escape") this.close();
        });
    }
    open() {
        this.button.setAttribute("aria-expanded", "true");
        this.button.parentElement.classList.add("form-select--open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this.list).slideDown();
    }
    close() {
        this.button.setAttribute("aria-expanded", "false");
        this.button.parentElement.classList.remove("form-select--open");
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this.list).slideUp();
    }
    initOptions() {
        this.optionsButton = this.querySelectorAll(".form-select__dropdown-button");
        this.options = this.querySelectorAll(".form-select__dropdown-option");
        this.optionsButton.forEach((option)=>{
            const callback = (e)=>{
                const clickedOption = e.target.closest(".form-select__dropdown-option");
                this.close();
                if (clickedOption.getAttribute("aria-selected") === "true") return;
                this.options.forEach((option)=>option.setAttribute("aria-selected", "false"));
                clickedOption.setAttribute("aria-selected", "true");
                this.buttonText.innerHTML = clickedOption.querySelector(".form-select__dropdown-button").innerHTML;
                if (clickedOption.getAttribute("data-option-value")) this.inputHidden.value = clickedOption.getAttribute("data-option-value");
                else this.inputHidden.value = clickedOption.querySelector("[data-option-value]")?.getAttribute("data-option-value");
                this.inputHidden.dispatchEvent(this.changeEvent);
                this.button.setAttribute("aria-selected", "true");
            };
            option.addEventListener("click", callback);
            //fix for iOS
            if (this.dropdownLabel) this.dropdownLabel.addEventListener("click", ()=>this.close());
        });
    }
}
customElements.define("custom-select", $2b766076d08b0976$var$customSelect);
//scroll to
if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-anchor-link]").length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("[data-anchor-link]").on("click", function(e) {
    e.preventDefault();
    const thisLink = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr("href");
    const thisLinkArr = thisLink.split("#");
    const thisLinkPageUrl = thisLinkArr[0];
    const pageUrl = window.location.origin + window.location.pathname;
    const header_offset = document.getElementById("site-header").offsetHeight + 20;
    if (thisLinkPageUrl === pageUrl) {
        const $elem = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`[data-id="${thisLinkArr[1]}"]`);
        if ($elem) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("html, body").animate({
                scrollTop: $elem.offset().top - header_offset
            }, 300, "swing");
            window.history.replaceState(null, "", thisLink);
        }
    } else window.location.href = thisLink;
});

})();
//# sourceMappingURL=theme.js.map
